(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = global || self, global.uploadImage = factory());
})(this, function () {
  'use strict';

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function unwrapExports(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }

  var classCallCheck = createCommonjsModule(function (module) {
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _classCallCheck = unwrapExports(classCallCheck);

  var _typeof_1 = createCommonjsModule(function (module) {
    function _typeof(obj) {
      "@babel/helpers - typeof";

      return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
    }

    module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  unwrapExports(_typeof_1);
  var toPrimitive = createCommonjsModule(function (module) {
    var _typeof = _typeof_1["default"];

    function _toPrimitive(input, hint) {
      if (_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];

      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }

      return (hint === "string" ? String : Number)(input);
    }

    module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });
  unwrapExports(toPrimitive);
  var toPropertyKey = createCommonjsModule(function (module) {
    var _typeof = _typeof_1["default"];

    function _toPropertyKey(arg) {
      var key = toPrimitive(arg, "string");
      return _typeof(key) === "symbol" ? key : String(key);
    }

    module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });
  unwrapExports(toPropertyKey);
  var createClass = createCommonjsModule(function (module) {
    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
      }
    }

    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      Object.defineProperty(Constructor, "prototype", {
        writable: false
      });
      return Constructor;
    }

    module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _createClass = unwrapExports(createClass);
  /*!
   * Cropper.js v1.5.13
   * https://fengyuanchen.github.io/cropperjs
   *
   * Copyright 2015-present Chen Fengyuan
   * Released under the MIT license
   *
   * Date: 2022-11-20T05:30:46.114Z
   */


  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  var WINDOW = IS_BROWSER ? window : {};
  var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? 'ontouchstart' in WINDOW.document.documentElement : false;
  var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
  var NAMESPACE = 'cropper'; // Actions

  var ACTION_ALL = 'all';
  var ACTION_CROP = 'crop';
  var ACTION_MOVE = 'move';
  var ACTION_ZOOM = 'zoom';
  var ACTION_EAST = 'e';
  var ACTION_WEST = 'w';
  var ACTION_SOUTH = 's';
  var ACTION_NORTH = 'n';
  var ACTION_NORTH_EAST = 'ne';
  var ACTION_NORTH_WEST = 'nw';
  var ACTION_SOUTH_EAST = 'se';
  var ACTION_SOUTH_WEST = 'sw'; // Classes

  var CLASS_CROP = "".concat(NAMESPACE, "-crop");
  var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
  var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
  var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
  var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
  var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
  var CLASS_MOVE = "".concat(NAMESPACE, "-move"); // Data keys

  var DATA_ACTION = "".concat(NAMESPACE, "Action");
  var DATA_PREVIEW = "".concat(NAMESPACE, "Preview"); // Drag modes

  var DRAG_MODE_CROP = 'crop';
  var DRAG_MODE_MOVE = 'move';
  var DRAG_MODE_NONE = 'none'; // Events

  var EVENT_CROP = 'crop';
  var EVENT_CROP_END = 'cropend';
  var EVENT_CROP_MOVE = 'cropmove';
  var EVENT_CROP_START = 'cropstart';
  var EVENT_DBLCLICK = 'dblclick';
  var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
  var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
  var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
  var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
  var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
  var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
  var EVENT_READY = 'ready';
  var EVENT_RESIZE = 'resize';
  var EVENT_WHEEL = 'wheel';
  var EVENT_ZOOM = 'zoom'; // Mime types

  var MIME_TYPE_JPEG = 'image/jpeg'; // RegExps

  var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
  var REGEXP_DATA_URL = /^data:/;
  var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
  var REGEXP_TAG_NAME = /^img|canvas$/i; // Misc
  // Inspired by the default width and height of a canvas element.

  var MIN_CONTAINER_WIDTH = 200;
  var MIN_CONTAINER_HEIGHT = 100;
  var DEFAULTS = {
    // Define the view mode of the cropper
    viewMode: 0,
    // 0, 1, 2, 3
    // Define the dragging mode of the cropper
    dragMode: DRAG_MODE_CROP,
    // 'crop', 'move' or 'none'
    // Define the initial aspect ratio of the crop box
    initialAspectRatio: NaN,
    // Define the aspect ratio of the crop box
    aspectRatio: NaN,
    // An object with the previous cropping result data
    data: null,
    // A selector for adding extra containers to preview
    preview: '',
    // Re-render the cropper when resize the window
    responsive: true,
    // Restore the cropped area after resize the window
    restore: true,
    // Check if the current image is a cross-origin image
    checkCrossOrigin: true,
    // Check the current image's Exif Orientation information
    checkOrientation: true,
    // Show the black modal
    modal: true,
    // Show the dashed lines for guiding
    guides: true,
    // Show the center indicator for guiding
    center: true,
    // Show the white modal to highlight the crop box
    highlight: true,
    // Show the grid background
    background: true,
    // Enable to crop the image automatically when initialize
    autoCrop: true,
    // Define the percentage of automatic cropping area when initializes
    autoCropArea: 0.8,
    // Enable to move the image
    movable: true,
    // Enable to rotate the image
    rotatable: true,
    // Enable to scale the image
    scalable: true,
    // Enable to zoom the image
    zoomable: true,
    // Enable to zoom the image by dragging touch
    zoomOnTouch: true,
    // Enable to zoom the image by wheeling mouse
    zoomOnWheel: true,
    // Define zoom ratio when zoom the image by wheeling mouse
    wheelZoomRatio: 0.1,
    // Enable to move the crop box
    cropBoxMovable: true,
    // Enable to resize the crop box
    cropBoxResizable: true,
    // Toggle drag mode between "crop" and "move" when click twice on the cropper
    toggleDragModeOnDblclick: true,
    // Size limitation
    minCanvasWidth: 0,
    minCanvasHeight: 0,
    minCropBoxWidth: 0,
    minCropBoxHeight: 0,
    minContainerWidth: MIN_CONTAINER_WIDTH,
    minContainerHeight: MIN_CONTAINER_HEIGHT,
    // Shortcuts of events
    ready: null,
    cropstart: null,
    cropmove: null,
    cropend: null,
    crop: null,
    zoom: null
  };
  var TEMPLATE = '<div class="cropper-container" touch-action="none">' + '<div class="cropper-wrap-box">' + '<div class="cropper-canvas"></div>' + '</div>' + '<div class="cropper-drag-box"></div>' + '<div class="cropper-crop-box">' + '<span class="cropper-view-box"></span>' + '<span class="cropper-dashed dashed-h"></span>' + '<span class="cropper-dashed dashed-v"></span>' + '<span class="cropper-center"></span>' + '<span class="cropper-face"></span>' + '<span class="cropper-line line-e" data-cropper-action="e"></span>' + '<span class="cropper-line line-n" data-cropper-action="n"></span>' + '<span class="cropper-line line-w" data-cropper-action="w"></span>' + '<span class="cropper-line line-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-e" data-cropper-action="e"></span>' + '<span class="cropper-point point-n" data-cropper-action="n"></span>' + '<span class="cropper-point point-w" data-cropper-action="w"></span>' + '<span class="cropper-point point-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-ne" data-cropper-action="ne"></span>' + '<span class="cropper-point point-nw" data-cropper-action="nw"></span>' + '<span class="cropper-point point-sw" data-cropper-action="sw"></span>' + '<span class="cropper-point point-se" data-cropper-action="se"></span>' + '</div>' + '</div>';
  /**
   * Check if the given value is not a number.
   */

  var isNaN = Number.isNaN || WINDOW.isNaN;
  /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */

  function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }
  /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */


  var isPositiveNumber = function isPositiveNumber(value) {
    return value > 0 && value < Infinity;
  };
  /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */


  function isUndefined(value) {
    return typeof value === 'undefined';
  }
  /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */


  function isObject(value) {
    return _typeof(value) === 'object' && value !== null;
  }

  var hasOwnProperty = Object.prototype.hasOwnProperty;
  /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */

  function isPlainObject(value) {
    if (!isObject(value)) {
      return false;
    }

    try {
      var _constructor = value.constructor;
      var prototype = _constructor.prototype;
      return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
    } catch (error) {
      return false;
    }
  }
  /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */


  function isFunction(value) {
    return typeof value === 'function';
  }

  var slice = Array.prototype.slice;
  /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */

  function toArray(value) {
    return Array.from ? Array.from(value) : slice.call(value);
  }
  /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */


  function forEach(data, callback) {
    if (data && isFunction(callback)) {
      if (Array.isArray(data) || isNumber(data.length)
      /* array-like */
      ) {
          toArray(data).forEach(function (value, key) {
            callback.call(data, value, key, data);
          });
        } else if (isObject(data)) {
        Object.keys(data).forEach(function (key) {
          callback.call(data, data[key], key, data);
        });
      }
    }

    return data;
  }
  /**
   * Extend the given object.
   * @param {*} target - The target object to extend.
   * @param {*} args - The rest objects for merging to the target object.
   * @returns {Object} The extended object.
   */


  var assign = Object.assign || function assign(target) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (isObject(target) && args.length > 0) {
      args.forEach(function (arg) {
        if (isObject(arg)) {
          Object.keys(arg).forEach(function (key) {
            target[key] = arg[key];
          });
        }
      });
    }

    return target;
  };

  var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
  /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */

  function normalizeDecimalNumber(value) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
    return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
  }

  var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
  /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */

  function setStyle(element, styles) {
    var style = element.style;
    forEach(styles, function (value, property) {
      if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
        value = "".concat(value, "px");
      }

      style[property] = value;
    });
  }
  /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */


  function hasClass(element, value) {
    return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
  }
  /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */


  function addClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        addClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.add(value);
      return;
    }

    var className = element.className.trim();

    if (!className) {
      element.className = value;
    } else if (className.indexOf(value) < 0) {
      element.className = "".concat(className, " ").concat(value);
    }
  }
  /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */


  function removeClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        removeClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.remove(value);
      return;
    }

    if (element.className.indexOf(value) >= 0) {
      element.className = element.className.replace(value, '');
    }
  }
  /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */


  function toggleClass(element, value, added) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        toggleClass(elem, value, added);
      });
      return;
    } // IE10-11 doesn't support the second parameter of `classList.toggle`


    if (added) {
      addClass(element, value);
    } else {
      removeClass(element, value);
    }
  }

  var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
  /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */

  function toParamCase(value) {
    return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
  }
  /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */


  function getData(element, name) {
    if (isObject(element[name])) {
      return element[name];
    }

    if (element.dataset) {
      return element.dataset[name];
    }

    return element.getAttribute("data-".concat(toParamCase(name)));
  }
  /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */


  function setData(element, name, data) {
    if (isObject(data)) {
      element[name] = data;
    } else if (element.dataset) {
      element.dataset[name] = data;
    } else {
      element.setAttribute("data-".concat(toParamCase(name)), data);
    }
  }
  /**
   * Remove data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to remove.
   */


  function removeData(element, name) {
    if (isObject(element[name])) {
      try {
        delete element[name];
      } catch (error) {
        element[name] = undefined;
      }
    } else if (element.dataset) {
      // #128 Safari not allows to delete dataset property
      try {
        delete element.dataset[name];
      } catch (error) {
        element.dataset[name] = undefined;
      }
    } else {
      element.removeAttribute("data-".concat(toParamCase(name)));
    }
  }

  var REGEXP_SPACES = /\s\s*/;

  var onceSupported = function () {
    var supported = false;

    if (IS_BROWSER) {
      var once = false;

      var listener = function listener() {};

      var options = Object.defineProperty({}, 'once', {
        get: function get() {
          supported = true;
          return once;
        },

        /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */
        set: function set(value) {
          once = value;
        }
      });
      WINDOW.addEventListener('test', listener, options);
      WINDOW.removeEventListener('test', listener, options);
    }

    return supported;
  }();
  /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */


  function removeListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (!onceSupported) {
        var listeners = element.listeners;

        if (listeners && listeners[event] && listeners[event][listener]) {
          handler = listeners[event][listener];
          delete listeners[event][listener];

          if (Object.keys(listeners[event]).length === 0) {
            delete listeners[event];
          }

          if (Object.keys(listeners).length === 0) {
            delete element.listeners;
          }
        }
      }

      element.removeEventListener(event, handler, options);
    });
  }
  /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */


  function addListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (options.once && !onceSupported) {
        var _element$listeners = element.listeners,
            listeners = _element$listeners === void 0 ? {} : _element$listeners;

        _handler = function handler() {
          delete listeners[event][listener];
          element.removeEventListener(event, _handler, options);

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          listener.apply(element, args);
        };

        if (!listeners[event]) {
          listeners[event] = {};
        }

        if (listeners[event][listener]) {
          element.removeEventListener(event, listeners[event][listener], options);
        }

        listeners[event][listener] = _handler;
        element.listeners = listeners;
      }

      element.addEventListener(event, _handler, options);
    });
  }
  /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */


  function dispatchEvent(element, type, data) {
    var event; // Event and CustomEvent on IE9-11 are global objects, not constructors

    if (isFunction(Event) && isFunction(CustomEvent)) {
      event = new CustomEvent(type, {
        detail: data,
        bubbles: true,
        cancelable: true
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(type, true, true, data);
    }

    return element.dispatchEvent(event);
  }
  /**
   * Get the offset base on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */


  function getOffset(element) {
    var box = element.getBoundingClientRect();
    return {
      left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
      top: box.top + (window.pageYOffset - document.documentElement.clientTop)
    };
  }

  var location = WINDOW.location;
  var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
  /**
   * Check if the given URL is a cross origin URL.
   * @param {string} url - The target URL.
   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
   */

  function isCrossOriginURL(url) {
    var parts = url.match(REGEXP_ORIGINS);
    return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
  }
  /**
   * Add timestamp to the given URL.
   * @param {string} url - The target URL.
   * @returns {string} The result URL.
   */


  function addTimestamp(url) {
    var timestamp = "timestamp=".concat(new Date().getTime());
    return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
  }
  /**
   * Get transforms base on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */


  function getTransforms(_ref) {
    var rotate = _ref.rotate,
        scaleX = _ref.scaleX,
        scaleY = _ref.scaleY,
        translateX = _ref.translateX,
        translateY = _ref.translateY;
    var values = [];

    if (isNumber(translateX) && translateX !== 0) {
      values.push("translateX(".concat(translateX, "px)"));
    }

    if (isNumber(translateY) && translateY !== 0) {
      values.push("translateY(".concat(translateY, "px)"));
    } // Rotate should come first before scale to match orientation transform


    if (isNumber(rotate) && rotate !== 0) {
      values.push("rotate(".concat(rotate, "deg)"));
    }

    if (isNumber(scaleX) && scaleX !== 1) {
      values.push("scaleX(".concat(scaleX, ")"));
    }

    if (isNumber(scaleY) && scaleY !== 1) {
      values.push("scaleY(".concat(scaleY, ")"));
    }

    var transform = values.length ? values.join(' ') : 'none';
    return {
      WebkitTransform: transform,
      msTransform: transform,
      transform: transform
    };
  }
  /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */


  function getMaxZoomRatio(pointers) {
    var pointers2 = _objectSpread2({}, pointers);

    var maxRatio = 0;
    forEach(pointers, function (pointer, pointerId) {
      delete pointers2[pointerId];
      forEach(pointers2, function (pointer2) {
        var x1 = Math.abs(pointer.startX - pointer2.startX);
        var y1 = Math.abs(pointer.startY - pointer2.startY);
        var x2 = Math.abs(pointer.endX - pointer2.endX);
        var y2 = Math.abs(pointer.endY - pointer2.endY);
        var z1 = Math.sqrt(x1 * x1 + y1 * y1);
        var z2 = Math.sqrt(x2 * x2 + y2 * y2);
        var ratio = (z2 - z1) / z1;

        if (Math.abs(ratio) > Math.abs(maxRatio)) {
          maxRatio = ratio;
        }
      });
    });
    return maxRatio;
  }
  /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */


  function getPointer(_ref2, endOnly) {
    var pageX = _ref2.pageX,
        pageY = _ref2.pageY;
    var end = {
      endX: pageX,
      endY: pageY
    };
    return endOnly ? end : _objectSpread2({
      startX: pageX,
      startY: pageY
    }, end);
  }
  /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */


  function getPointersCenter(pointers) {
    var pageX = 0;
    var pageY = 0;
    var count = 0;
    forEach(pointers, function (_ref3) {
      var startX = _ref3.startX,
          startY = _ref3.startY;
      pageX += startX;
      pageY += startY;
      count += 1;
    });
    pageX /= count;
    pageY /= count;
    return {
      pageX: pageX,
      pageY: pageY
    };
  }
  /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */


  function getAdjustedSizes(_ref4) {
    var aspectRatio = _ref4.aspectRatio,
        height = _ref4.height,
        width = _ref4.width;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
    var isValidWidth = isPositiveNumber(width);
    var isValidHeight = isPositiveNumber(height);

    if (isValidWidth && isValidHeight) {
      var adjustedWidth = height * aspectRatio;

      if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
        height = width / aspectRatio;
      } else {
        width = height * aspectRatio;
      }
    } else if (isValidWidth) {
      height = width / aspectRatio;
    } else if (isValidHeight) {
      width = height * aspectRatio;
    }

    return {
      width: width,
      height: height
    };
  }
  /**
   * Get the new sizes of a rectangle after rotated.
   * @param {Object} data - The original sizes.
   * @returns {Object} The result sizes.
   */


  function getRotatedSizes(_ref5) {
    var width = _ref5.width,
        height = _ref5.height,
        degree = _ref5.degree;
    degree = Math.abs(degree) % 180;

    if (degree === 90) {
      return {
        width: height,
        height: width
      };
    }

    var arc = degree % 90 * Math.PI / 180;
    var sinArc = Math.sin(arc);
    var cosArc = Math.cos(arc);
    var newWidth = width * cosArc + height * sinArc;
    var newHeight = width * sinArc + height * cosArc;
    return degree > 90 ? {
      width: newHeight,
      height: newWidth
    } : {
      width: newWidth,
      height: newHeight
    };
  }
  /**
   * Get a canvas which drew the given image.
   * @param {HTMLImageElement} image - The image for drawing.
   * @param {Object} imageData - The image data.
   * @param {Object} canvasData - The canvas data.
   * @param {Object} options - The options.
   * @returns {HTMLCanvasElement} The result canvas.
   */


  function getSourceCanvas(image, _ref6, _ref7, _ref8) {
    var imageAspectRatio = _ref6.aspectRatio,
        imageNaturalWidth = _ref6.naturalWidth,
        imageNaturalHeight = _ref6.naturalHeight,
        _ref6$rotate = _ref6.rotate,
        rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate,
        _ref6$scaleX = _ref6.scaleX,
        scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX,
        _ref6$scaleY = _ref6.scaleY,
        scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
    var aspectRatio = _ref7.aspectRatio,
        naturalWidth = _ref7.naturalWidth,
        naturalHeight = _ref7.naturalHeight;
    var _ref8$fillColor = _ref8.fillColor,
        fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor,
        _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled,
        imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE,
        _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality,
        imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ,
        _ref8$maxWidth = _ref8.maxWidth,
        maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth,
        _ref8$maxHeight = _ref8.maxHeight,
        maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight,
        _ref8$minWidth = _ref8.minWidth,
        minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth,
        _ref8$minHeight = _ref8.minHeight,
        minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    var maxSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var minSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
    var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight)); // Note: should always use image's natural sizes for drawing as
    // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90

    var destMaxSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var destMinSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
    var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
    var params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
    canvas.width = normalizeDecimalNumber(width);
    canvas.height = normalizeDecimalNumber(height);
    context.fillStyle = fillColor;
    context.fillRect(0, 0, width, height);
    context.save();
    context.translate(width / 2, height / 2);
    context.rotate(rotate * Math.PI / 180);
    context.scale(scaleX, scaleY);
    context.imageSmoothingEnabled = imageSmoothingEnabled;
    context.imageSmoothingQuality = imageSmoothingQuality;
    context.drawImage.apply(context, [image].concat(_toConsumableArray(params.map(function (param) {
      return Math.floor(normalizeDecimalNumber(param));
    }))));
    context.restore();
    return canvas;
  }

  var fromCharCode = String.fromCharCode;
  /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */

  function getStringFromCharCode(dataView, start, length) {
    var str = '';
    length += start;

    for (var i = start; i < length; i += 1) {
      str += fromCharCode(dataView.getUint8(i));
    }

    return str;
  }

  var REGEXP_DATA_URL_HEAD = /^data:.*,/;
  /**
   * Transform Data URL to array buffer.
   * @param {string} dataURL - The Data URL to transform.
   * @returns {ArrayBuffer} The result array buffer.
   */

  function dataURLToArrayBuffer(dataURL) {
    var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
    var binary = atob(base64);
    var arrayBuffer = new ArrayBuffer(binary.length);
    var uint8 = new Uint8Array(arrayBuffer);
    forEach(uint8, function (value, i) {
      uint8[i] = binary.charCodeAt(i);
    });
    return arrayBuffer;
  }
  /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */


  function arrayBufferToDataURL(arrayBuffer, mimeType) {
    var chunks = []; // Chunk Typed Array for better performance (#435)

    var chunkSize = 8192;
    var uint8 = new Uint8Array(arrayBuffer);

    while (uint8.length > 0) {
      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
      // eslint-disable-next-line prefer-spread
      chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
      uint8 = uint8.subarray(chunkSize);
    }

    return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
  }
  /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */


  function resetAndGetOrientation(arrayBuffer) {
    var dataView = new DataView(arrayBuffer);
    var orientation; // Ignores range error when the image does not have correct Exif information

    try {
      var littleEndian;
      var app1Start;
      var ifdStart; // Only handle JPEG image (start by 0xFFD8)

      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
        var length = dataView.byteLength;
        var offset = 2;

        while (offset + 1 < length) {
          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
            app1Start = offset;
            break;
          }

          offset += 1;
        }
      }

      if (app1Start) {
        var exifIDCode = app1Start + 4;
        var tiffOffset = app1Start + 10;

        if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
          var endianness = dataView.getUint16(tiffOffset);
          littleEndian = endianness === 0x4949;

          if (littleEndian || endianness === 0x4D4D
          /* bigEndian */
          ) {
              if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

                if (firstIFDOffset >= 0x00000008) {
                  ifdStart = tiffOffset + firstIFDOffset;
                }
              }
            }
        }
      }

      if (ifdStart) {
        var _length = dataView.getUint16(ifdStart, littleEndian);

        var _offset;

        var i;

        for (i = 0; i < _length; i += 1) {
          _offset = ifdStart + i * 12 + 2;

          if (dataView.getUint16(_offset, littleEndian) === 0x0112
          /* Orientation */
          ) {
              // 8 is the offset of the current tag's value
              _offset += 8; // Get the original orientation value

              orientation = dataView.getUint16(_offset, littleEndian); // Override the orientation with its default value

              dataView.setUint16(_offset, 1, littleEndian);
              break;
            }
        }
      }
    } catch (error) {
      orientation = 1;
    }

    return orientation;
  }
  /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */


  function parseOrientation(orientation) {
    var rotate = 0;
    var scaleX = 1;
    var scaleY = 1;

    switch (orientation) {
      // Flip horizontal
      case 2:
        scaleX = -1;
        break;
      // Rotate left 180°

      case 3:
        rotate = -180;
        break;
      // Flip vertical

      case 4:
        scaleY = -1;
        break;
      // Flip vertical and rotate right 90°

      case 5:
        rotate = 90;
        scaleY = -1;
        break;
      // Rotate right 90°

      case 6:
        rotate = 90;
        break;
      // Flip horizontal and rotate right 90°

      case 7:
        rotate = 90;
        scaleX = -1;
        break;
      // Rotate left 90°

      case 8:
        rotate = -90;
        break;
    }

    return {
      rotate: rotate,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }

  var render = {
    render: function render() {
      this.initContainer();
      this.initCanvas();
      this.initCropBox();
      this.renderCanvas();

      if (this.cropped) {
        this.renderCropBox();
      }
    },
    initContainer: function initContainer() {
      var element = this.element,
          options = this.options,
          container = this.container,
          cropper = this.cropper;
      var minWidth = Number(options.minContainerWidth);
      var minHeight = Number(options.minContainerHeight);
      addClass(cropper, CLASS_HIDDEN);
      removeClass(element, CLASS_HIDDEN);
      var containerData = {
        width: Math.max(container.offsetWidth, minWidth >= 0 ? minWidth : MIN_CONTAINER_WIDTH),
        height: Math.max(container.offsetHeight, minHeight >= 0 ? minHeight : MIN_CONTAINER_HEIGHT)
      };
      this.containerData = containerData;
      setStyle(cropper, {
        width: containerData.width,
        height: containerData.height
      });
      addClass(element, CLASS_HIDDEN);
      removeClass(cropper, CLASS_HIDDEN);
    },
    // Canvas (image wrapper)
    initCanvas: function initCanvas() {
      var containerData = this.containerData,
          imageData = this.imageData;
      var viewMode = this.options.viewMode;
      var rotated = Math.abs(imageData.rotate) % 180 === 90;
      var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
      var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
      var aspectRatio = naturalWidth / naturalHeight;
      var canvasWidth = containerData.width;
      var canvasHeight = containerData.height;

      if (containerData.height * aspectRatio > containerData.width) {
        if (viewMode === 3) {
          canvasWidth = containerData.height * aspectRatio;
        } else {
          canvasHeight = containerData.width / aspectRatio;
        }
      } else if (viewMode === 3) {
        canvasHeight = containerData.width / aspectRatio;
      } else {
        canvasWidth = containerData.height * aspectRatio;
      }

      var canvasData = {
        aspectRatio: aspectRatio,
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        width: canvasWidth,
        height: canvasHeight
      };
      this.canvasData = canvasData;
      this.limited = viewMode === 1 || viewMode === 2;
      this.limitCanvas(true, true);
      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
      canvasData.left = (containerData.width - canvasData.width) / 2;
      canvasData.top = (containerData.height - canvasData.height) / 2;
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      this.initialCanvasData = assign({}, canvasData);
    },
    limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
      var options = this.options,
          containerData = this.containerData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var viewMode = options.viewMode;
      var aspectRatio = canvasData.aspectRatio;
      var cropped = this.cropped && cropBoxData;

      if (sizeLimited) {
        var minCanvasWidth = Number(options.minCanvasWidth) || 0;
        var minCanvasHeight = Number(options.minCanvasHeight) || 0;

        if (viewMode > 1) {
          minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
          minCanvasHeight = Math.max(minCanvasHeight, containerData.height);

          if (viewMode === 3) {
            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        } else if (viewMode > 0) {
          if (minCanvasWidth) {
            minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
          } else if (minCanvasHeight) {
            minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
          } else if (cropped) {
            minCanvasWidth = cropBoxData.width;
            minCanvasHeight = cropBoxData.height;

            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        }

        var _getAdjustedSizes = getAdjustedSizes({
          aspectRatio: aspectRatio,
          width: minCanvasWidth,
          height: minCanvasHeight
        });

        minCanvasWidth = _getAdjustedSizes.width;
        minCanvasHeight = _getAdjustedSizes.height;
        canvasData.minWidth = minCanvasWidth;
        canvasData.minHeight = minCanvasHeight;
        canvasData.maxWidth = Infinity;
        canvasData.maxHeight = Infinity;
      }

      if (positionLimited) {
        if (viewMode > (cropped ? 0 : 1)) {
          var newCanvasLeft = containerData.width - canvasData.width;
          var newCanvasTop = containerData.height - canvasData.height;
          canvasData.minLeft = Math.min(0, newCanvasLeft);
          canvasData.minTop = Math.min(0, newCanvasTop);
          canvasData.maxLeft = Math.max(0, newCanvasLeft);
          canvasData.maxTop = Math.max(0, newCanvasTop);

          if (cropped && this.limited) {
            canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
            canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
            canvasData.maxLeft = cropBoxData.left;
            canvasData.maxTop = cropBoxData.top;

            if (viewMode === 2) {
              if (canvasData.width >= containerData.width) {
                canvasData.minLeft = Math.min(0, newCanvasLeft);
                canvasData.maxLeft = Math.max(0, newCanvasLeft);
              }

              if (canvasData.height >= containerData.height) {
                canvasData.minTop = Math.min(0, newCanvasTop);
                canvasData.maxTop = Math.max(0, newCanvasTop);
              }
            }
          }
        } else {
          canvasData.minLeft = -canvasData.width;
          canvasData.minTop = -canvasData.height;
          canvasData.maxLeft = containerData.width;
          canvasData.maxTop = containerData.height;
        }
      }
    },
    renderCanvas: function renderCanvas(changed, transformed) {
      var canvasData = this.canvasData,
          imageData = this.imageData;

      if (transformed) {
        var _getRotatedSizes = getRotatedSizes({
          width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
          height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
          degree: imageData.rotate || 0
        }),
            naturalWidth = _getRotatedSizes.width,
            naturalHeight = _getRotatedSizes.height;

        var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
        var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
        canvasData.left -= (width - canvasData.width) / 2;
        canvasData.top -= (height - canvasData.height) / 2;
        canvasData.width = width;
        canvasData.height = height;
        canvasData.aspectRatio = naturalWidth / naturalHeight;
        canvasData.naturalWidth = naturalWidth;
        canvasData.naturalHeight = naturalHeight;
        this.limitCanvas(true, false);
      }

      if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
        canvasData.left = canvasData.oldLeft;
      }

      if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
        canvasData.top = canvasData.oldTop;
      }

      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
      this.limitCanvas(false, true);
      canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
      canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      setStyle(this.canvas, assign({
        width: canvasData.width,
        height: canvasData.height
      }, getTransforms({
        translateX: canvasData.left,
        translateY: canvasData.top
      })));
      this.renderImage(changed);

      if (this.cropped && this.limited) {
        this.limitCropBox(true, true);
      }
    },
    renderImage: function renderImage(changed) {
      var canvasData = this.canvasData,
          imageData = this.imageData;
      var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
      var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
      assign(imageData, {
        width: width,
        height: height,
        left: (canvasData.width - width) / 2,
        top: (canvasData.height - height) / 2
      });
      setStyle(this.image, assign({
        width: imageData.width,
        height: imageData.height
      }, getTransforms(assign({
        translateX: imageData.left,
        translateY: imageData.top
      }, imageData))));

      if (changed) {
        this.output();
      }
    },
    initCropBox: function initCropBox() {
      var options = this.options,
          canvasData = this.canvasData;
      var aspectRatio = options.aspectRatio || options.initialAspectRatio;
      var autoCropArea = Number(options.autoCropArea) || 0.8;
      var cropBoxData = {
        width: canvasData.width,
        height: canvasData.height
      };

      if (aspectRatio) {
        if (canvasData.height * aspectRatio > canvasData.width) {
          cropBoxData.height = cropBoxData.width / aspectRatio;
        } else {
          cropBoxData.width = cropBoxData.height * aspectRatio;
        }
      }

      this.cropBoxData = cropBoxData;
      this.limitCropBox(true, true); // Initialize auto crop area

      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight); // The width/height of auto crop area must large than "minWidth/Height"

      cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
      cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
      cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
      cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;
      this.initialCropBoxData = assign({}, cropBoxData);
    },
    limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
      var options = this.options,
          containerData = this.containerData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData,
          limited = this.limited;
      var aspectRatio = options.aspectRatio;

      if (sizeLimited) {
        var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
        var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
        var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
        var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height; // The min/maxCropBoxWidth/Height must be less than container's width/height

        minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
        minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);

        if (aspectRatio) {
          if (minCropBoxWidth && minCropBoxHeight) {
            if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
              minCropBoxHeight = minCropBoxWidth / aspectRatio;
            } else {
              minCropBoxWidth = minCropBoxHeight * aspectRatio;
            }
          } else if (minCropBoxWidth) {
            minCropBoxHeight = minCropBoxWidth / aspectRatio;
          } else if (minCropBoxHeight) {
            minCropBoxWidth = minCropBoxHeight * aspectRatio;
          }

          if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
            maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
          } else {
            maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
          }
        } // The minWidth/Height must be less than maxWidth/Height


        cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
        cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
        cropBoxData.maxWidth = maxCropBoxWidth;
        cropBoxData.maxHeight = maxCropBoxHeight;
      }

      if (positionLimited) {
        if (limited) {
          cropBoxData.minLeft = Math.max(0, canvasData.left);
          cropBoxData.minTop = Math.max(0, canvasData.top);
          cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
          cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
        } else {
          cropBoxData.minLeft = 0;
          cropBoxData.minTop = 0;
          cropBoxData.maxLeft = containerData.width - cropBoxData.width;
          cropBoxData.maxTop = containerData.height - cropBoxData.height;
        }
      }
    },
    renderCropBox: function renderCropBox() {
      var options = this.options,
          containerData = this.containerData,
          cropBoxData = this.cropBoxData;

      if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
        cropBoxData.left = cropBoxData.oldLeft;
      }

      if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
        cropBoxData.top = cropBoxData.oldTop;
      }

      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
      this.limitCropBox(false, true);
      cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
      cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;

      if (options.movable && options.cropBoxMovable) {
        // Turn to move the canvas when the crop box is equal to the container
        setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
      }

      setStyle(this.cropBox, assign({
        width: cropBoxData.width,
        height: cropBoxData.height
      }, getTransforms({
        translateX: cropBoxData.left,
        translateY: cropBoxData.top
      })));

      if (this.cropped && this.limited) {
        this.limitCanvas(true, true);
      }

      if (!this.disabled) {
        this.output();
      }
    },
    output: function output() {
      this.preview();
      dispatchEvent(this.element, EVENT_CROP, this.getData());
    }
  };
  var preview = {
    initPreview: function initPreview() {
      var element = this.element,
          crossOrigin = this.crossOrigin;
      var preview = this.options.preview;
      var url = crossOrigin ? this.crossOriginUrl : this.url;
      var alt = element.alt || 'The image to preview';
      var image = document.createElement('img');

      if (crossOrigin) {
        image.crossOrigin = crossOrigin;
      }

      image.src = url;
      image.alt = alt;
      this.viewBox.appendChild(image);
      this.viewBoxImage = image;

      if (!preview) {
        return;
      }

      var previews = preview;

      if (typeof preview === 'string') {
        previews = element.ownerDocument.querySelectorAll(preview);
      } else if (preview.querySelector) {
        previews = [preview];
      }

      this.previews = previews;
      forEach(previews, function (el) {
        var img = document.createElement('img'); // Save the original size for recover

        setData(el, DATA_PREVIEW, {
          width: el.offsetWidth,
          height: el.offsetHeight,
          html: el.innerHTML
        });

        if (crossOrigin) {
          img.crossOrigin = crossOrigin;
        }

        img.src = url;
        img.alt = alt;
        /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * Add `height:auto` to override `height` attribute on IE8
         * (Occur only when margin-top <= -height)
         */

        img.style.cssText = 'display:block;' + 'width:100%;' + 'height:auto;' + 'min-width:0!important;' + 'min-height:0!important;' + 'max-width:none!important;' + 'max-height:none!important;' + 'image-orientation:0deg!important;"';
        el.innerHTML = '';
        el.appendChild(img);
      });
    },
    resetPreview: function resetPreview() {
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        setStyle(element, {
          width: data.width,
          height: data.height
        });
        element.innerHTML = data.html;
        removeData(element, DATA_PREVIEW);
      });
    },
    preview: function preview() {
      var imageData = this.imageData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var cropBoxWidth = cropBoxData.width,
          cropBoxHeight = cropBoxData.height;
      var width = imageData.width,
          height = imageData.height;
      var left = cropBoxData.left - canvasData.left - imageData.left;
      var top = cropBoxData.top - canvasData.top - imageData.top;

      if (!this.cropped || this.disabled) {
        return;
      }

      setStyle(this.viewBoxImage, assign({
        width: width,
        height: height
      }, getTransforms(assign({
        translateX: -left,
        translateY: -top
      }, imageData))));
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        var originalWidth = data.width;
        var originalHeight = data.height;
        var newWidth = originalWidth;
        var newHeight = originalHeight;
        var ratio = 1;

        if (cropBoxWidth) {
          ratio = originalWidth / cropBoxWidth;
          newHeight = cropBoxHeight * ratio;
        }

        if (cropBoxHeight && newHeight > originalHeight) {
          ratio = originalHeight / cropBoxHeight;
          newWidth = cropBoxWidth * ratio;
          newHeight = originalHeight;
        }

        setStyle(element, {
          width: newWidth,
          height: newHeight
        });
        setStyle(element.getElementsByTagName('img')[0], assign({
          width: width * ratio,
          height: height * ratio
        }, getTransforms(assign({
          translateX: -left * ratio,
          translateY: -top * ratio
        }, imageData))));
      });
    }
  };
  var events = {
    bind: function bind() {
      var element = this.element,
          options = this.options,
          cropper = this.cropper;

      if (isFunction(options.cropstart)) {
        addListener(element, EVENT_CROP_START, options.cropstart);
      }

      if (isFunction(options.cropmove)) {
        addListener(element, EVENT_CROP_MOVE, options.cropmove);
      }

      if (isFunction(options.cropend)) {
        addListener(element, EVENT_CROP_END, options.cropend);
      }

      if (isFunction(options.crop)) {
        addListener(element, EVENT_CROP, options.crop);
      }

      if (isFunction(options.zoom)) {
        addListener(element, EVENT_ZOOM, options.zoom);
      }

      addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));

      if (options.zoomable && options.zoomOnWheel) {
        addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
          passive: false,
          capture: true
        });
      }

      if (options.toggleDragModeOnDblclick) {
        addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
      }

      addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
      addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));

      if (options.responsive) {
        addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
      }
    },
    unbind: function unbind() {
      var element = this.element,
          options = this.options,
          cropper = this.cropper;

      if (isFunction(options.cropstart)) {
        removeListener(element, EVENT_CROP_START, options.cropstart);
      }

      if (isFunction(options.cropmove)) {
        removeListener(element, EVENT_CROP_MOVE, options.cropmove);
      }

      if (isFunction(options.cropend)) {
        removeListener(element, EVENT_CROP_END, options.cropend);
      }

      if (isFunction(options.crop)) {
        removeListener(element, EVENT_CROP, options.crop);
      }

      if (isFunction(options.zoom)) {
        removeListener(element, EVENT_ZOOM, options.zoom);
      }

      removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);

      if (options.zoomable && options.zoomOnWheel) {
        removeListener(cropper, EVENT_WHEEL, this.onWheel, {
          passive: false,
          capture: true
        });
      }

      if (options.toggleDragModeOnDblclick) {
        removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
      }

      removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
      removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);

      if (options.responsive) {
        removeListener(window, EVENT_RESIZE, this.onResize);
      }
    }
  };
  var handlers = {
    resize: function resize() {
      if (this.disabled) {
        return;
      }

      var options = this.options,
          container = this.container,
          containerData = this.containerData;
      var ratioX = container.offsetWidth / containerData.width;
      var ratioY = container.offsetHeight / containerData.height;
      var ratio = Math.abs(ratioX - 1) > Math.abs(ratioY - 1) ? ratioX : ratioY; // Resize when width changed or height changed

      if (ratio !== 1) {
        var canvasData;
        var cropBoxData;

        if (options.restore) {
          canvasData = this.getCanvasData();
          cropBoxData = this.getCropBoxData();
        }

        this.render();

        if (options.restore) {
          this.setCanvasData(forEach(canvasData, function (n, i) {
            canvasData[i] = n * ratio;
          }));
          this.setCropBoxData(forEach(cropBoxData, function (n, i) {
            cropBoxData[i] = n * ratio;
          }));
        }
      }
    },
    dblclick: function dblclick() {
      if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
        return;
      }

      this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
    },
    wheel: function wheel(event) {
      var _this = this;

      var ratio = Number(this.options.wheelZoomRatio) || 0.1;
      var delta = 1;

      if (this.disabled) {
        return;
      }

      event.preventDefault(); // Limit wheel speed to prevent zoom too fast (#21)

      if (this.wheeling) {
        return;
      }

      this.wheeling = true;
      setTimeout(function () {
        _this.wheeling = false;
      }, 50);

      if (event.deltaY) {
        delta = event.deltaY > 0 ? 1 : -1;
      } else if (event.wheelDelta) {
        delta = -event.wheelDelta / 120;
      } else if (event.detail) {
        delta = event.detail > 0 ? 1 : -1;
      }

      this.zoom(-delta * ratio, event);
    },
    cropStart: function cropStart(event) {
      var buttons = event.buttons,
          button = event.button;

      if (this.disabled // Handle mouse event and pointer event and ignore touch event
      || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && ( // No primary button (Usually the left button)
      isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 // Open context menu
      || event.ctrlKey)) {
        return;
      }

      var options = this.options,
          pointers = this.pointers;
      var action;

      if (event.changedTouches) {
        // Handle touch event
        forEach(event.changedTouches, function (touch) {
          pointers[touch.identifier] = getPointer(touch);
        });
      } else {
        // Handle mouse event and pointer event
        pointers[event.pointerId || 0] = getPointer(event);
      }

      if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) {
        action = ACTION_ZOOM;
      } else {
        action = getData(event.target, DATA_ACTION);
      }

      if (!REGEXP_ACTIONS.test(action)) {
        return;
      }

      if (dispatchEvent(this.element, EVENT_CROP_START, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      } // This line is required for preventing page zooming in iOS browsers


      event.preventDefault();
      this.action = action;
      this.cropping = false;

      if (action === ACTION_CROP) {
        this.cropping = true;
        addClass(this.dragBox, CLASS_MODAL);
      }
    },
    cropMove: function cropMove(event) {
      var action = this.action;

      if (this.disabled || !action) {
        return;
      }

      var pointers = this.pointers;
      event.preventDefault();

      if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      }

      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          // The first parameter should not be undefined (#432)
          assign(pointers[touch.identifier] || {}, getPointer(touch, true));
        });
      } else {
        assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
      }

      this.change(event);
    },
    cropEnd: function cropEnd(event) {
      if (this.disabled) {
        return;
      }

      var action = this.action,
          pointers = this.pointers;

      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          delete pointers[touch.identifier];
        });
      } else {
        delete pointers[event.pointerId || 0];
      }

      if (!action) {
        return;
      }

      event.preventDefault();

      if (!Object.keys(pointers).length) {
        this.action = '';
      }

      if (this.cropping) {
        this.cropping = false;
        toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
      }

      dispatchEvent(this.element, EVENT_CROP_END, {
        originalEvent: event,
        action: action
      });
    }
  };
  var change = {
    change: function change(event) {
      var options = this.options,
          canvasData = this.canvasData,
          containerData = this.containerData,
          cropBoxData = this.cropBoxData,
          pointers = this.pointers;
      var action = this.action;
      var aspectRatio = options.aspectRatio;
      var left = cropBoxData.left,
          top = cropBoxData.top,
          width = cropBoxData.width,
          height = cropBoxData.height;
      var right = left + width;
      var bottom = top + height;
      var minLeft = 0;
      var minTop = 0;
      var maxWidth = containerData.width;
      var maxHeight = containerData.height;
      var renderable = true;
      var offset; // Locking aspect ratio in "free mode" by holding shift key

      if (!aspectRatio && event.shiftKey) {
        aspectRatio = width && height ? width / height : 1;
      }

      if (this.limited) {
        minLeft = cropBoxData.minLeft;
        minTop = cropBoxData.minTop;
        maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
        maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
      }

      var pointer = pointers[Object.keys(pointers)[0]];
      var range = {
        x: pointer.endX - pointer.startX,
        y: pointer.endY - pointer.startY
      };

      var check = function check(side) {
        switch (side) {
          case ACTION_EAST:
            if (right + range.x > maxWidth) {
              range.x = maxWidth - right;
            }

            break;

          case ACTION_WEST:
            if (left + range.x < minLeft) {
              range.x = minLeft - left;
            }

            break;

          case ACTION_NORTH:
            if (top + range.y < minTop) {
              range.y = minTop - top;
            }

            break;

          case ACTION_SOUTH:
            if (bottom + range.y > maxHeight) {
              range.y = maxHeight - bottom;
            }

            break;
        }
      };

      switch (action) {
        // Move crop box
        case ACTION_ALL:
          left += range.x;
          top += range.y;
          break;
        // Resize crop box

        case ACTION_EAST:
          if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }

          check(ACTION_EAST);
          width += range.x;

          if (width < 0) {
            action = ACTION_WEST;
            width = -width;
            left -= width;
          }

          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }

          break;

        case ACTION_NORTH:
          if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }

          check(ACTION_NORTH);
          height -= range.y;
          top += range.y;

          if (height < 0) {
            action = ACTION_SOUTH;
            height = -height;
            top -= height;
          }

          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }

          break;

        case ACTION_WEST:
          if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }

          check(ACTION_WEST);
          width -= range.x;
          left += range.x;

          if (width < 0) {
            action = ACTION_EAST;
            width = -width;
            left -= width;
          }

          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }

          break;

        case ACTION_SOUTH:
          if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }

          check(ACTION_SOUTH);
          height += range.y;

          if (height < 0) {
            action = ACTION_NORTH;
            height = -height;
            top -= height;
          }

          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }

          break;

        case ACTION_NORTH_EAST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
              renderable = false;
              break;
            }

            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
          } else {
            check(ACTION_NORTH);
            check(ACTION_EAST);

            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_NORTH_WEST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
              renderable = false;
              break;
            }

            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
            left += cropBoxData.width - width;
          } else {
            check(ACTION_NORTH);
            check(ACTION_WEST);

            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_SOUTH_WEST:
          if (aspectRatio) {
            if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            check(ACTION_WEST);
            width -= range.x;
            left += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_WEST);

            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_SOUTH_EAST:
          if (aspectRatio) {
            if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            check(ACTION_EAST);
            width += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_EAST);

            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            top -= height;
          }

          break;
        // Move canvas

        case ACTION_MOVE:
          this.move(range.x, range.y);
          renderable = false;
          break;
        // Zoom canvas

        case ACTION_ZOOM:
          this.zoom(getMaxZoomRatio(pointers), event);
          renderable = false;
          break;
        // Create crop box

        case ACTION_CROP:
          if (!range.x || !range.y) {
            renderable = false;
            break;
          }

          offset = getOffset(this.cropper);
          left = pointer.startX - offset.left;
          top = pointer.startY - offset.top;
          width = cropBoxData.minWidth;
          height = cropBoxData.minHeight;

          if (range.x > 0) {
            action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
          } else if (range.x < 0) {
            left -= width;
            action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
          }

          if (range.y < 0) {
            top -= height;
          } // Show the crop box if is hidden


          if (!this.cropped) {
            removeClass(this.cropBox, CLASS_HIDDEN);
            this.cropped = true;

            if (this.limited) {
              this.limitCropBox(true, true);
            }
          }

          break;
      }

      if (renderable) {
        cropBoxData.width = width;
        cropBoxData.height = height;
        cropBoxData.left = left;
        cropBoxData.top = top;
        this.action = action;
        this.renderCropBox();
      } // Override


      forEach(pointers, function (p) {
        p.startX = p.endX;
        p.startY = p.endY;
      });
    }
  };
  var methods = {
    // Show the crop box manually
    crop: function crop() {
      if (this.ready && !this.cropped && !this.disabled) {
        this.cropped = true;
        this.limitCropBox(true, true);

        if (this.options.modal) {
          addClass(this.dragBox, CLASS_MODAL);
        }

        removeClass(this.cropBox, CLASS_HIDDEN);
        this.setCropBoxData(this.initialCropBoxData);
      }

      return this;
    },
    // Reset the image and crop box to their initial states
    reset: function reset() {
      if (this.ready && !this.disabled) {
        this.imageData = assign({}, this.initialImageData);
        this.canvasData = assign({}, this.initialCanvasData);
        this.cropBoxData = assign({}, this.initialCropBoxData);
        this.renderCanvas();

        if (this.cropped) {
          this.renderCropBox();
        }
      }

      return this;
    },
    // Clear the crop box
    clear: function clear() {
      if (this.cropped && !this.disabled) {
        assign(this.cropBoxData, {
          left: 0,
          top: 0,
          width: 0,
          height: 0
        });
        this.cropped = false;
        this.renderCropBox();
        this.limitCanvas(true, true); // Render canvas after crop box rendered

        this.renderCanvas();
        removeClass(this.dragBox, CLASS_MODAL);
        addClass(this.cropBox, CLASS_HIDDEN);
      }

      return this;
    },

    /**
     * Replace the image's src and rebuild the cropper
     * @param {string} url - The new URL.
     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
     * @returns {Cropper} this
     */
    replace: function replace(url) {
      var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.disabled && url) {
        if (this.isImg) {
          this.element.src = url;
        }

        if (hasSameSize) {
          this.url = url;
          this.image.src = url;

          if (this.ready) {
            this.viewBoxImage.src = url;
            forEach(this.previews, function (element) {
              element.getElementsByTagName('img')[0].src = url;
            });
          }
        } else {
          if (this.isImg) {
            this.replaced = true;
          }

          this.options.data = null;
          this.uncreate();
          this.load(url);
        }
      }

      return this;
    },
    // Enable (unfreeze) the cropper
    enable: function enable() {
      if (this.ready && this.disabled) {
        this.disabled = false;
        removeClass(this.cropper, CLASS_DISABLED);
      }

      return this;
    },
    // Disable (freeze) the cropper
    disable: function disable() {
      if (this.ready && !this.disabled) {
        this.disabled = true;
        addClass(this.cropper, CLASS_DISABLED);
      }

      return this;
    },

    /**
     * Destroy the cropper and remove the instance from the image
     * @returns {Cropper} this
     */
    destroy: function destroy() {
      var element = this.element;

      if (!element[NAMESPACE]) {
        return this;
      }

      element[NAMESPACE] = undefined;

      if (this.isImg && this.replaced) {
        element.src = this.originalUrl;
      }

      this.uncreate();
      return this;
    },

    /**
     * Move the canvas with relative offsets
     * @param {number} offsetX - The relative offset distance on the x-axis.
     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
     * @returns {Cropper} this
     */
    move: function move(offsetX) {
      var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
      var _this$canvasData = this.canvasData,
          left = _this$canvasData.left,
          top = _this$canvasData.top;
      return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
    },

    /**
     * Move the canvas to an absolute point
     * @param {number} x - The x-axis coordinate.
     * @param {number} [y=x] - The y-axis coordinate.
     * @returns {Cropper} this
     */
    moveTo: function moveTo(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
      var canvasData = this.canvasData;
      var changed = false;
      x = Number(x);
      y = Number(y);

      if (this.ready && !this.disabled && this.options.movable) {
        if (isNumber(x)) {
          canvasData.left = x;
          changed = true;
        }

        if (isNumber(y)) {
          canvasData.top = y;
          changed = true;
        }

        if (changed) {
          this.renderCanvas(true);
        }
      }

      return this;
    },

    /**
     * Zoom the canvas with a relative ratio
     * @param {number} ratio - The target ratio.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoom: function zoom(ratio, _originalEvent) {
      var canvasData = this.canvasData;
      ratio = Number(ratio);

      if (ratio < 0) {
        ratio = 1 / (1 - ratio);
      } else {
        ratio = 1 + ratio;
      }

      return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
    },

    /**
     * Zoom the canvas to an absolute ratio
     * @param {number} ratio - The target ratio.
     * @param {Object} pivot - The zoom pivot point coordinate.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
      var options = this.options,
          canvasData = this.canvasData;
      var width = canvasData.width,
          height = canvasData.height,
          naturalWidth = canvasData.naturalWidth,
          naturalHeight = canvasData.naturalHeight;
      ratio = Number(ratio);

      if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
        var newWidth = naturalWidth * ratio;
        var newHeight = naturalHeight * ratio;

        if (dispatchEvent(this.element, EVENT_ZOOM, {
          ratio: ratio,
          oldRatio: width / naturalWidth,
          originalEvent: _originalEvent
        }) === false) {
          return this;
        }

        if (_originalEvent) {
          var pointers = this.pointers;
          var offset = getOffset(this.cropper);
          var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
            pageX: _originalEvent.pageX,
            pageY: _originalEvent.pageY
          }; // Zoom from the triggering point of the event

          canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
        } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
          canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
        } else {
          // Zoom from the center of the canvas
          canvasData.left -= (newWidth - width) / 2;
          canvasData.top -= (newHeight - height) / 2;
        }

        canvasData.width = newWidth;
        canvasData.height = newHeight;
        this.renderCanvas(true);
      }

      return this;
    },

    /**
     * Rotate the canvas with a relative degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotate: function rotate(degree) {
      return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
    },

    /**
     * Rotate the canvas to an absolute degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotateTo: function rotateTo(degree) {
      degree = Number(degree);

      if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
        this.imageData.rotate = degree % 360;
        this.renderCanvas(true, true);
      }

      return this;
    },

    /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Cropper} this
     */
    scaleX: function scaleX(_scaleX) {
      var scaleY = this.imageData.scaleY;
      return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
    },

    /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scaleY: function scaleY(_scaleY) {
      var scaleX = this.imageData.scaleX;
      return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
    },

    /**
     * Scale the image
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scale: function scale(scaleX) {
      var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
      var imageData = this.imageData;
      var transformed = false;
      scaleX = Number(scaleX);
      scaleY = Number(scaleY);

      if (this.ready && !this.disabled && this.options.scalable) {
        if (isNumber(scaleX)) {
          imageData.scaleX = scaleX;
          transformed = true;
        }

        if (isNumber(scaleY)) {
          imageData.scaleY = scaleY;
          transformed = true;
        }

        if (transformed) {
          this.renderCanvas(true, true);
        }
      }

      return this;
    },

    /**
     * Get the cropped area position and size data (base on the original image)
     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
     * @returns {Object} The result cropped data.
     */
    getData: function getData() {
      var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var options = this.options,
          imageData = this.imageData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var data;

      if (this.ready && this.cropped) {
        data = {
          x: cropBoxData.left - canvasData.left,
          y: cropBoxData.top - canvasData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
        var ratio = imageData.width / imageData.naturalWidth;
        forEach(data, function (n, i) {
          data[i] = n / ratio;
        });

        if (rounded) {
          // In case rounding off leads to extra 1px in right or bottom border
          // we should round the top-left corner and the dimension (#343).
          var bottom = Math.round(data.y + data.height);
          var right = Math.round(data.x + data.width);
          data.x = Math.round(data.x);
          data.y = Math.round(data.y);
          data.width = right - data.x;
          data.height = bottom - data.y;
        }
      } else {
        data = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }

      if (options.rotatable) {
        data.rotate = imageData.rotate || 0;
      }

      if (options.scalable) {
        data.scaleX = imageData.scaleX || 1;
        data.scaleY = imageData.scaleY || 1;
      }

      return data;
    },

    /**
     * Set the cropped area position and size with new data
     * @param {Object} data - The new data.
     * @returns {Cropper} this
     */
    setData: function setData(data) {
      var options = this.options,
          imageData = this.imageData,
          canvasData = this.canvasData;
      var cropBoxData = {};

      if (this.ready && !this.disabled && isPlainObject(data)) {
        var transformed = false;

        if (options.rotatable) {
          if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
            imageData.rotate = data.rotate;
            transformed = true;
          }
        }

        if (options.scalable) {
          if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
            imageData.scaleX = data.scaleX;
            transformed = true;
          }

          if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
            imageData.scaleY = data.scaleY;
            transformed = true;
          }
        }

        if (transformed) {
          this.renderCanvas(true, true);
        }

        var ratio = imageData.width / imageData.naturalWidth;

        if (isNumber(data.x)) {
          cropBoxData.left = data.x * ratio + canvasData.left;
        }

        if (isNumber(data.y)) {
          cropBoxData.top = data.y * ratio + canvasData.top;
        }

        if (isNumber(data.width)) {
          cropBoxData.width = data.width * ratio;
        }

        if (isNumber(data.height)) {
          cropBoxData.height = data.height * ratio;
        }

        this.setCropBoxData(cropBoxData);
      }

      return this;
    },

    /**
     * Get the container size data.
     * @returns {Object} The result container data.
     */
    getContainerData: function getContainerData() {
      return this.ready ? assign({}, this.containerData) : {};
    },

    /**
     * Get the image position and size data.
     * @returns {Object} The result image data.
     */
    getImageData: function getImageData() {
      return this.sized ? assign({}, this.imageData) : {};
    },

    /**
     * Get the canvas position and size data.
     * @returns {Object} The result canvas data.
     */
    getCanvasData: function getCanvasData() {
      var canvasData = this.canvasData;
      var data = {};

      if (this.ready) {
        forEach(['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'], function (n) {
          data[n] = canvasData[n];
        });
      }

      return data;
    },

    /**
     * Set the canvas position and size with new data.
     * @param {Object} data - The new canvas data.
     * @returns {Cropper} this
     */
    setCanvasData: function setCanvasData(data) {
      var canvasData = this.canvasData;
      var aspectRatio = canvasData.aspectRatio;

      if (this.ready && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          canvasData.left = data.left;
        }

        if (isNumber(data.top)) {
          canvasData.top = data.top;
        }

        if (isNumber(data.width)) {
          canvasData.width = data.width;
          canvasData.height = data.width / aspectRatio;
        } else if (isNumber(data.height)) {
          canvasData.height = data.height;
          canvasData.width = data.height * aspectRatio;
        }

        this.renderCanvas(true);
      }

      return this;
    },

    /**
     * Get the crop box position and size data.
     * @returns {Object} The result crop box data.
     */
    getCropBoxData: function getCropBoxData() {
      var cropBoxData = this.cropBoxData;
      var data;

      if (this.ready && this.cropped) {
        data = {
          left: cropBoxData.left,
          top: cropBoxData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
      }

      return data || {};
    },

    /**
     * Set the crop box position and size with new data.
     * @param {Object} data - The new crop box data.
     * @returns {Cropper} this
     */
    setCropBoxData: function setCropBoxData(data) {
      var cropBoxData = this.cropBoxData;
      var aspectRatio = this.options.aspectRatio;
      var widthChanged;
      var heightChanged;

      if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          cropBoxData.left = data.left;
        }

        if (isNumber(data.top)) {
          cropBoxData.top = data.top;
        }

        if (isNumber(data.width) && data.width !== cropBoxData.width) {
          widthChanged = true;
          cropBoxData.width = data.width;
        }

        if (isNumber(data.height) && data.height !== cropBoxData.height) {
          heightChanged = true;
          cropBoxData.height = data.height;
        }

        if (aspectRatio) {
          if (widthChanged) {
            cropBoxData.height = cropBoxData.width / aspectRatio;
          } else if (heightChanged) {
            cropBoxData.width = cropBoxData.height * aspectRatio;
          }
        }

        this.renderCropBox();
      }

      return this;
    },

    /**
     * Get a canvas drawn the cropped image.
     * @param {Object} [options={}] - The config options.
     * @returns {HTMLCanvasElement} - The result canvas.
     */
    getCroppedCanvas: function getCroppedCanvas() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.ready || !window.HTMLCanvasElement) {
        return null;
      }

      var canvasData = this.canvasData;
      var source = getSourceCanvas(this.image, this.imageData, canvasData, options); // Returns the source canvas if it is not cropped.

      if (!this.cropped) {
        return source;
      }

      var _this$getData = this.getData(),
          initialX = _this$getData.x,
          initialY = _this$getData.y,
          initialWidth = _this$getData.width,
          initialHeight = _this$getData.height;

      var ratio = source.width / Math.floor(canvasData.naturalWidth);

      if (ratio !== 1) {
        initialX *= ratio;
        initialY *= ratio;
        initialWidth *= ratio;
        initialHeight *= ratio;
      }

      var aspectRatio = initialWidth / initialHeight;
      var maxSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.maxWidth || Infinity,
        height: options.maxHeight || Infinity
      });
      var minSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.minWidth || 0,
        height: options.minHeight || 0
      }, 'cover');

      var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.width || (ratio !== 1 ? source.width : initialWidth),
        height: options.height || (ratio !== 1 ? source.height : initialHeight)
      }),
          width = _getAdjustedSizes.width,
          height = _getAdjustedSizes.height;

      width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
      height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = normalizeDecimalNumber(width);
      canvas.height = normalizeDecimalNumber(height);
      context.fillStyle = options.fillColor || 'transparent';
      context.fillRect(0, 0, width, height);
      var _options$imageSmoothi = options.imageSmoothingEnabled,
          imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi,
          imageSmoothingQuality = options.imageSmoothingQuality;
      context.imageSmoothingEnabled = imageSmoothingEnabled;

      if (imageSmoothingQuality) {
        context.imageSmoothingQuality = imageSmoothingQuality;
      } // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage


      var sourceWidth = source.width;
      var sourceHeight = source.height; // Source canvas parameters

      var srcX = initialX;
      var srcY = initialY;
      var srcWidth;
      var srcHeight; // Destination canvas parameters

      var dstX;
      var dstY;
      var dstWidth;
      var dstHeight;

      if (srcX <= -initialWidth || srcX > sourceWidth) {
        srcX = 0;
        srcWidth = 0;
        dstX = 0;
        dstWidth = 0;
      } else if (srcX <= 0) {
        dstX = -srcX;
        srcX = 0;
        srcWidth = Math.min(sourceWidth, initialWidth + srcX);
        dstWidth = srcWidth;
      } else if (srcX <= sourceWidth) {
        dstX = 0;
        srcWidth = Math.min(initialWidth, sourceWidth - srcX);
        dstWidth = srcWidth;
      }

      if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
        srcY = 0;
        srcHeight = 0;
        dstY = 0;
        dstHeight = 0;
      } else if (srcY <= 0) {
        dstY = -srcY;
        srcY = 0;
        srcHeight = Math.min(sourceHeight, initialHeight + srcY);
        dstHeight = srcHeight;
      } else if (srcY <= sourceHeight) {
        dstY = 0;
        srcHeight = Math.min(initialHeight, sourceHeight - srcY);
        dstHeight = srcHeight;
      }

      var params = [srcX, srcY, srcWidth, srcHeight]; // Avoid "IndexSizeError"

      if (dstWidth > 0 && dstHeight > 0) {
        var scale = width / initialWidth;
        params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
      } // All the numerical parameters should be integer for `drawImage`
      // https://github.com/fengyuanchen/cropper/issues/476


      context.drawImage.apply(context, [source].concat(_toConsumableArray(params.map(function (param) {
        return Math.floor(normalizeDecimalNumber(param));
      }))));
      return canvas;
    },

    /**
     * Change the aspect ratio of the crop box.
     * @param {number} aspectRatio - The new aspect ratio.
     * @returns {Cropper} this
     */
    setAspectRatio: function setAspectRatio(aspectRatio) {
      var options = this.options;

      if (!this.disabled && !isUndefined(aspectRatio)) {
        // 0 -> NaN
        options.aspectRatio = Math.max(0, aspectRatio) || NaN;

        if (this.ready) {
          this.initCropBox();

          if (this.cropped) {
            this.renderCropBox();
          }
        }
      }

      return this;
    },

    /**
     * Change the drag mode.
     * @param {string} mode - The new drag mode.
     * @returns {Cropper} this
     */
    setDragMode: function setDragMode(mode) {
      var options = this.options,
          dragBox = this.dragBox,
          face = this.face;

      if (this.ready && !this.disabled) {
        var croppable = mode === DRAG_MODE_CROP;
        var movable = options.movable && mode === DRAG_MODE_MOVE;
        mode = croppable || movable ? mode : DRAG_MODE_NONE;
        options.dragMode = mode;
        setData(dragBox, DATA_ACTION, mode);
        toggleClass(dragBox, CLASS_CROP, croppable);
        toggleClass(dragBox, CLASS_MOVE, movable);

        if (!options.cropBoxMovable) {
          // Sync drag mode to crop box when it is not movable
          setData(face, DATA_ACTION, mode);
          toggleClass(face, CLASS_CROP, croppable);
          toggleClass(face, CLASS_MOVE, movable);
        }
      }

      return this;
    }
  };
  var AnotherCropper = WINDOW.Cropper;

  var Cropper =
  /*#__PURE__*/
  function () {
    /**
     * Create a new Cropper.
     * @param {Element} element - The target element for cropping.
     * @param {Object} [options={}] - The configuration options.
     */
    function Cropper(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck$1(this, Cropper);

      if (!element || !REGEXP_TAG_NAME.test(element.tagName)) {
        throw new Error('The first argument is required and must be an <img> or <canvas> element.');
      }

      this.element = element;
      this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
      this.cropped = false;
      this.disabled = false;
      this.pointers = {};
      this.ready = false;
      this.reloading = false;
      this.replaced = false;
      this.sized = false;
      this.sizing = false;
      this.init();
    }

    _createClass$1(Cropper, [{
      key: "init",
      value: function init() {
        var element = this.element;
        var tagName = element.tagName.toLowerCase();
        var url;

        if (element[NAMESPACE]) {
          return;
        }

        element[NAMESPACE] = this;

        if (tagName === 'img') {
          this.isImg = true; // e.g.: "img/picture.jpg"

          url = element.getAttribute('src') || '';
          this.originalUrl = url; // Stop when it's a blank image

          if (!url) {
            return;
          } // e.g.: "https://example.com/img/picture.jpg"


          url = element.src;
        } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
          url = element.toDataURL();
        }

        this.load(url);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this = this;

        if (!url) {
          return;
        }

        this.url = url;
        this.imageData = {};
        var element = this.element,
            options = this.options;

        if (!options.rotatable && !options.scalable) {
          options.checkOrientation = false;
        } // Only IE10+ supports Typed Arrays


        if (!options.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        } // Detect the mime type of the image directly if it is a Data URL


        if (REGEXP_DATA_URL.test(url)) {
          // Read ArrayBuffer from Data URL of JPEG images directly for better performance
          if (REGEXP_DATA_URL_JPEG.test(url)) {
            this.read(dataURLToArrayBuffer(url));
          } else {
            // Only a JPEG image may contains Exif Orientation information,
            // the rest types of Data URLs are not necessary to check orientation at all.
            this.clone();
          }

          return;
        } // 1. Detect the mime type of the image by a XMLHttpRequest.
        // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.


        var xhr = new XMLHttpRequest();
        var clone = this.clone.bind(this);
        this.reloading = true;
        this.xhr = xhr; // 1. Cross origin requests are only supported for protocol schemes:
        // http, https, data, chrome, chrome-extension.
        // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
        // in some browsers as IE11 and Safari.

        xhr.onabort = clone;
        xhr.onerror = clone;
        xhr.ontimeout = clone;

        xhr.onprogress = function () {
          // Abort the request directly if it not a JPEG image for better performance
          if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) {
            xhr.abort();
          }
        };

        xhr.onload = function () {
          _this.read(xhr.response);
        };

        xhr.onloadend = function () {
          _this.reloading = false;
          _this.xhr = null;
        }; // Bust cache when there is a "crossOrigin" property to avoid browser cache error


        if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) {
          url = addTimestamp(url);
        } // The third parameter is required for avoiding side-effect (#682)


        xhr.open('GET', url, true);
        xhr.responseType = 'arraybuffer';
        xhr.withCredentials = element.crossOrigin === 'use-credentials';
        xhr.send();
      }
    }, {
      key: "read",
      value: function read(arrayBuffer) {
        var options = this.options,
            imageData = this.imageData; // Reset the orientation value to its default value 1
        // as some iOS browsers will render image with its orientation

        var orientation = resetAndGetOrientation(arrayBuffer);
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;

        if (orientation > 1) {
          // Generate a new URL which has the default orientation value
          this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);

          var _parseOrientation = parseOrientation(orientation);

          rotate = _parseOrientation.rotate;
          scaleX = _parseOrientation.scaleX;
          scaleY = _parseOrientation.scaleY;
        }

        if (options.rotatable) {
          imageData.rotate = rotate;
        }

        if (options.scalable) {
          imageData.scaleX = scaleX;
          imageData.scaleY = scaleY;
        }

        this.clone();
      }
    }, {
      key: "clone",
      value: function clone() {
        var element = this.element,
            url = this.url;
        var crossOrigin = element.crossOrigin;
        var crossOriginUrl = url;

        if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
          if (!crossOrigin) {
            crossOrigin = 'anonymous';
          } // Bust cache when there is not a "crossOrigin" property (#519)


          crossOriginUrl = addTimestamp(url);
        }

        this.crossOrigin = crossOrigin;
        this.crossOriginUrl = crossOriginUrl;
        var image = document.createElement('img');

        if (crossOrigin) {
          image.crossOrigin = crossOrigin;
        }

        image.src = crossOriginUrl || url;
        image.alt = element.alt || 'The image to crop';
        this.image = image;
        image.onload = this.start.bind(this);
        image.onerror = this.stop.bind(this);
        addClass(image, CLASS_HIDE);
        element.parentNode.insertBefore(image, element.nextSibling);
      }
    }, {
      key: "start",
      value: function start() {
        var _this2 = this;

        var image = this.image;
        image.onload = null;
        image.onerror = null;
        this.sizing = true; // Match all browsers that use WebKit as the layout engine in iOS devices,
        // such as Safari for iOS, Chrome for iOS, and in-app browsers.

        var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);

        var done = function done(naturalWidth, naturalHeight) {
          assign(_this2.imageData, {
            naturalWidth: naturalWidth,
            naturalHeight: naturalHeight,
            aspectRatio: naturalWidth / naturalHeight
          });
          _this2.initialImageData = assign({}, _this2.imageData);
          _this2.sizing = false;
          _this2.sized = true;

          _this2.build();
        }; // Most modern browsers (excepts iOS WebKit)


        if (image.naturalWidth && !isIOSWebKit) {
          done(image.naturalWidth, image.naturalHeight);
          return;
        }

        var sizingImage = document.createElement('img');
        var body = document.body || document.documentElement;
        this.sizingImage = sizingImage;

        sizingImage.onload = function () {
          done(sizingImage.width, sizingImage.height);

          if (!isIOSWebKit) {
            body.removeChild(sizingImage);
          }
        };

        sizingImage.src = image.src; // iOS WebKit will convert the image automatically
        // with its orientation once append it into DOM (#279)

        if (!isIOSWebKit) {
          sizingImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
          body.appendChild(sizingImage);
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        var image = this.image;
        image.onload = null;
        image.onerror = null;
        image.parentNode.removeChild(image);
        this.image = null;
      }
    }, {
      key: "build",
      value: function build() {
        if (!this.sized || this.ready) {
          return;
        }

        var element = this.element,
            options = this.options,
            image = this.image; // Create cropper elements

        var container = element.parentNode;
        var template = document.createElement('div');
        template.innerHTML = TEMPLATE;
        var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
        var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
        var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
        var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
        var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
        this.container = container;
        this.cropper = cropper;
        this.canvas = canvas;
        this.dragBox = dragBox;
        this.cropBox = cropBox;
        this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
        this.face = face;
        canvas.appendChild(image); // Hide the original image

        addClass(element, CLASS_HIDDEN); // Inserts the cropper after to the current image

        container.insertBefore(cropper, element.nextSibling); // Show the hidden image

        removeClass(image, CLASS_HIDE);
        this.initPreview();
        this.bind();
        options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
        options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
        options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
        addClass(cropBox, CLASS_HIDDEN);

        if (!options.guides) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
        }

        if (!options.center) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
        }

        if (options.background) {
          addClass(cropper, "".concat(NAMESPACE, "-bg"));
        }

        if (!options.highlight) {
          addClass(face, CLASS_INVISIBLE);
        }

        if (options.cropBoxMovable) {
          addClass(face, CLASS_MOVE);
          setData(face, DATA_ACTION, ACTION_ALL);
        }

        if (!options.cropBoxResizable) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
        }

        this.render();
        this.ready = true;
        this.setDragMode(options.dragMode);

        if (options.autoCrop) {
          this.crop();
        }

        this.setData(options.data);

        if (isFunction(options.ready)) {
          addListener(element, EVENT_READY, options.ready, {
            once: true
          });
        }

        dispatchEvent(element, EVENT_READY);
      }
    }, {
      key: "unbuild",
      value: function unbuild() {
        if (!this.ready) {
          return;
        }

        this.ready = false;
        this.unbind();
        this.resetPreview();
        var parentNode = this.cropper.parentNode;

        if (parentNode) {
          parentNode.removeChild(this.cropper);
        }

        removeClass(this.element, CLASS_HIDDEN);
      }
    }, {
      key: "uncreate",
      value: function uncreate() {
        if (this.ready) {
          this.unbuild();
          this.ready = false;
          this.cropped = false;
        } else if (this.sizing) {
          this.sizingImage.onload = null;
          this.sizing = false;
          this.sized = false;
        } else if (this.reloading) {
          this.xhr.onabort = null;
          this.xhr.abort();
        } else if (this.image) {
          this.stop();
        }
      }
      /**
       * Get the no conflict cropper class.
       * @returns {Cropper} The cropper class.
       */

    }], [{
      key: "noConflict",
      value: function noConflict() {
        window.Cropper = AnotherCropper;
        return Cropper;
      }
      /**
       * Change the default options.
       * @param {Object} options - The new default options.
       */

    }, {
      key: "setDefaults",
      value: function setDefaults(options) {
        assign(DEFAULTS, isPlainObject(options) && options);
      }
    }]);

    return Cropper;
  }();

  assign(Cropper.prototype, render, preview, events, handlers, change, methods);

  function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') {
      return;
    }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css_248z = ".class-cropper-modal {\r\n  position: fixed;\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.class-cropper-modal .modal-panel {\r\n  width: 880px;\r\n  height: 500px;\r\n  background: white;\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n}\r\n.class-cropper-modal .modal-panel .button-row {\r\n  height: 50px;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.class-cropper-modal .modal-panel .button-row .submit-button {\r\n  padding: 0 20px;\r\n  height: 100%;\r\n  color: #383838;\r\n  font-size: 14px;\r\n}\r\n.class-cropper-modal .modal-panel .cropper-container-container {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: space-between;\r\n  height: 100%;\r\n}\r\n.class-cropper-modal\r\n  .modal-panel\r\n  .cropper-container-container\r\n  .cropper-container {\r\n  flex: 0 0 600px;\r\n  margin-right: 20px;\r\n}\r\n.class-cropper-modal\r\n  .modal-panel\r\n  .cropper-container-container\r\n  .cropper-container\r\n  .cropper {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.class-cropper-modal\r\n  .modal-panel\r\n  .cropper-container-container\r\n  .preview-container {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: flex-end;\r\n}\r\n.class-cropper-modal\r\n  .modal-panel\r\n  .cropper-container-container\r\n  .preview-container\r\n  .cropper-preview {\r\n  width: 180px;\r\n  height: 180px;\r\n  overflow: hidden;\r\n  border: 1px solid #383838;\r\n}\r\n\r\n.uploadImage-cropperBtn-box {\r\n  z-index: 100;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 285px;\r\n  height: 60px;\r\n  justify-content: space-around;\r\n}\r\n.uploadImage-cropperBtn-box .cropperBtn {\r\n  width: 60px;\r\n  height: 60px;\r\n  line-height: 30px;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  text-align: center;\r\n}\r\n\r\n.cropper-container {\r\n  background: #000;\r\n}\r\n\r\n/*\r\n * Cropper.js v1.5.6\r\n * https://fengyuanchen.github.io/cropperjs\r\n *\r\n * Copyright 2015-present Chen Fengyuan\r\n * Released under the MIT license\r\n *\r\n * Date: 2019-10-04T04:33:44.164Z\r\n */\r\n\r\n.cropper-container {\r\n  direction: ltr;\r\n  font-size: 0;\r\n  line-height: 0;\r\n  position: relative;\r\n  -ms-touch-action: none;\r\n  touch-action: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.cropper-container img {\r\n  display: block;\r\n  height: 100%;\r\n  image-orientation: 0deg;\r\n  max-height: none !important;\r\n  max-width: none !important;\r\n  min-height: 0 !important;\r\n  min-width: 0 !important;\r\n  width: 100%;\r\n}\r\n\r\n.cropper-wrap-box,\r\n.cropper-canvas,\r\n.cropper-drag-box,\r\n.cropper-crop-box,\r\n.cropper-modal {\r\n  bottom: 0;\r\n  left: 0;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n}\r\n\r\n.cropper-wrap-box,\r\n.cropper-canvas {\r\n  overflow: hidden;\r\n}\r\n\r\n.cropper-drag-box {\r\n  background-color: #fff;\r\n  opacity: 0;\r\n}\r\n\r\n.cropper-modal {\r\n  background-color: #000;\r\n  opacity: 0.5;\r\n}\r\n\r\n.cropper-view-box {\r\n  display: block;\r\n  height: 100%;\r\n  outline: 1px solid #39f;\r\n  outline-color: rgba(51, 153, 255, 0.75);\r\n  overflow: hidden;\r\n  width: 100%;\r\n}\r\n\r\n.cropper-dashed {\r\n  border: 0 dashed #eee;\r\n  display: block;\r\n  opacity: 0.5;\r\n  position: absolute;\r\n}\r\n\r\n.cropper-dashed.dashed-h {\r\n  border-bottom-width: 1px;\r\n  border-top-width: 1px;\r\n  height: calc(100% / 3);\r\n  left: 0;\r\n  top: calc(100% / 3);\r\n  width: 100%;\r\n}\r\n\r\n.cropper-dashed.dashed-v {\r\n  border-left-width: 1px;\r\n  border-right-width: 1px;\r\n  height: 100%;\r\n  left: calc(100% / 3);\r\n  top: 0;\r\n  width: calc(100% / 3);\r\n}\r\n\r\n.cropper-center {\r\n  display: block;\r\n  height: 0;\r\n  left: 50%;\r\n  opacity: 0.75;\r\n  position: absolute;\r\n  top: 50%;\r\n  width: 0;\r\n}\r\n\r\n.cropper-center::before,\r\n.cropper-center::after {\r\n  background-color: #eee;\r\n  content: \" \";\r\n  display: block;\r\n  position: absolute;\r\n}\r\n\r\n.cropper-center::before {\r\n  height: 1px;\r\n  left: -3px;\r\n  top: 0;\r\n  width: 7px;\r\n}\r\n\r\n.cropper-center::after {\r\n  height: 7px;\r\n  left: 0;\r\n  top: -3px;\r\n  width: 1px;\r\n}\r\n\r\n.cropper-face,\r\n.cropper-line,\r\n.cropper-point {\r\n  display: block;\r\n  height: 100%;\r\n  opacity: 0.1;\r\n  position: absolute;\r\n  width: 100%;\r\n}\r\n\r\n.cropper-face {\r\n  background-color: #fff;\r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n.cropper-line {\r\n  background-color: #39f;\r\n}\r\n\r\n.cropper-line.line-e {\r\n  cursor: ew-resize;\r\n  right: -3px;\r\n  top: 0;\r\n  width: 5px;\r\n}\r\n\r\n.cropper-line.line-n {\r\n  cursor: ns-resize;\r\n  height: 5px;\r\n  left: 0;\r\n  top: -3px;\r\n}\r\n\r\n.cropper-line.line-w {\r\n  cursor: ew-resize;\r\n  left: -3px;\r\n  top: 0;\r\n  width: 5px;\r\n}\r\n\r\n.cropper-line.line-s {\r\n  bottom: -3px;\r\n  cursor: ns-resize;\r\n  height: 5px;\r\n  left: 0;\r\n}\r\n\r\n.cropper-point {\r\n  background-color: #39f;\r\n  height: 5px;\r\n  opacity: 0.75;\r\n  width: 5px;\r\n}\r\n\r\n.cropper-point.point-e {\r\n  cursor: ew-resize;\r\n  margin-top: -3px;\r\n  right: -3px;\r\n  top: 50%;\r\n}\r\n\r\n.cropper-point.point-n {\r\n  cursor: ns-resize;\r\n  left: 50%;\r\n  margin-left: -3px;\r\n  top: -3px;\r\n}\r\n\r\n.cropper-point.point-w {\r\n  cursor: ew-resize;\r\n  left: -3px;\r\n  margin-top: -3px;\r\n  top: 50%;\r\n}\r\n\r\n.cropper-point.point-s {\r\n  bottom: -3px;\r\n  cursor: s-resize;\r\n  left: 50%;\r\n  margin-left: -3px;\r\n}\r\n\r\n.cropper-point.point-ne {\r\n  cursor: nesw-resize;\r\n  right: -3px;\r\n  top: -3px;\r\n}\r\n\r\n.cropper-point.point-nw {\r\n  cursor: nwse-resize;\r\n  left: -3px;\r\n  top: -3px;\r\n}\r\n\r\n.cropper-point.point-sw {\r\n  bottom: -3px;\r\n  cursor: nesw-resize;\r\n  left: -3px;\r\n}\r\n\r\n.cropper-point.point-se {\r\n  bottom: -3px;\r\n  cursor: nwse-resize;\r\n  height: 20px;\r\n  opacity: 1;\r\n  right: -3px;\r\n  width: 20px;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .cropper-point.point-se {\r\n    height: 15px;\r\n    width: 15px;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .cropper-point.point-se {\r\n    height: 10px;\r\n    width: 10px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .cropper-point.point-se {\r\n    height: 5px;\r\n    opacity: 0.75;\r\n    width: 5px;\r\n  }\r\n}\r\n\r\n.cropper-point.point-se::before {\r\n  background-color: #39f;\r\n  bottom: -50%;\r\n  content: \" \";\r\n  display: block;\r\n  height: 200%;\r\n  opacity: 0;\r\n  position: absolute;\r\n  right: -50%;\r\n  width: 200%;\r\n}\r\n\r\n.cropper-invisible {\r\n  opacity: 0;\r\n}\r\n\r\n.cropper-hide {\r\n  display: block;\r\n  height: 0;\r\n  position: absolute;\r\n  width: 0;\r\n}\r\n\r\n.cropper-hidden {\r\n  display: none !important;\r\n}\r\n\r\n.cropper-move {\r\n  cursor: move;\r\n}\r\n\r\n.cropper-crop {\r\n  cursor: crosshair;\r\n}\r\n\r\n.cropper-disabled .cropper-drag-box,\r\n.cropper-disabled .cropper-face,\r\n.cropper-disabled .cropper-line,\r\n.cropper-disabled .cropper-point {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.cropper-container {\r\n  z-index: 100;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n\r\n.uploadImage-loading {\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  position: fixed;\r\n  z-index: 1000;\r\n  background: rgba(0,0,0,.5);\r\n  font-size: 60px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n";
  styleInject(css_248z);
  var exif = createCommonjsModule(function (module, exports) {
    (function () {
      var debug = false;

      var EXIF = function EXIF(obj) {
        if (obj instanceof EXIF) return obj;
        if (!(this instanceof EXIF)) return new EXIF(obj);
        this.EXIFwrapped = obj;
      };

      {
        if (module.exports) {
          exports = module.exports = EXIF;
        }

        exports.EXIF = EXIF;
      }
      var ExifTags = EXIF.Tags = {
        // version tags
        0x9000: "ExifVersion",
        // EXIF version
        0xA000: "FlashpixVersion",
        // Flashpix format version
        // colorspace tags
        0xA001: "ColorSpace",
        // Color space information tag
        // image configuration
        0xA002: "PixelXDimension",
        // Valid width of meaningful image
        0xA003: "PixelYDimension",
        // Valid height of meaningful image
        0x9101: "ComponentsConfiguration",
        // Information about channels
        0x9102: "CompressedBitsPerPixel",
        // Compressed bits per pixel
        // user information
        0x927C: "MakerNote",
        // Any desired information written by the manufacturer
        0x9286: "UserComment",
        // Comments by user
        // related file
        0xA004: "RelatedSoundFile",
        // Name of related sound file
        // date and time
        0x9003: "DateTimeOriginal",
        // Date and time when the original image was generated
        0x9004: "DateTimeDigitized",
        // Date and time when the image was stored digitally
        0x9290: "SubsecTime",
        // Fractions of seconds for DateTime
        0x9291: "SubsecTimeOriginal",
        // Fractions of seconds for DateTimeOriginal
        0x9292: "SubsecTimeDigitized",
        // Fractions of seconds for DateTimeDigitized
        // picture-taking conditions
        0x829A: "ExposureTime",
        // Exposure time (in seconds)
        0x829D: "FNumber",
        // F number
        0x8822: "ExposureProgram",
        // Exposure program
        0x8824: "SpectralSensitivity",
        // Spectral sensitivity
        0x8827: "ISOSpeedRatings",
        // ISO speed rating
        0x8828: "OECF",
        // Optoelectric conversion factor
        0x9201: "ShutterSpeedValue",
        // Shutter speed
        0x9202: "ApertureValue",
        // Lens aperture
        0x9203: "BrightnessValue",
        // Value of brightness
        0x9204: "ExposureBias",
        // Exposure bias
        0x9205: "MaxApertureValue",
        // Smallest F number of lens
        0x9206: "SubjectDistance",
        // Distance to subject in meters
        0x9207: "MeteringMode",
        // Metering mode
        0x9208: "LightSource",
        // Kind of light source
        0x9209: "Flash",
        // Flash status
        0x9214: "SubjectArea",
        // Location and area of main subject
        0x920A: "FocalLength",
        // Focal length of the lens in mm
        0xA20B: "FlashEnergy",
        // Strobe energy in BCPS
        0xA20C: "SpatialFrequencyResponse",
        //
        0xA20E: "FocalPlaneXResolution",
        // Number of pixels in width direction per FocalPlaneResolutionUnit
        0xA20F: "FocalPlaneYResolution",
        // Number of pixels in height direction per FocalPlaneResolutionUnit
        0xA210: "FocalPlaneResolutionUnit",
        // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
        0xA214: "SubjectLocation",
        // Location of subject in image
        0xA215: "ExposureIndex",
        // Exposure index selected on camera
        0xA217: "SensingMethod",
        // Image sensor type
        0xA300: "FileSource",
        // Image source (3 == DSC)
        0xA301: "SceneType",
        // Scene type (1 == directly photographed)
        0xA302: "CFAPattern",
        // Color filter array geometric pattern
        0xA401: "CustomRendered",
        // Special processing
        0xA402: "ExposureMode",
        // Exposure mode
        0xA403: "WhiteBalance",
        // 1 = auto white balance, 2 = manual
        0xA404: "DigitalZoomRation",
        // Digital zoom ratio
        0xA405: "FocalLengthIn35mmFilm",
        // Equivalent foacl length assuming 35mm film camera (in mm)
        0xA406: "SceneCaptureType",
        // Type of scene
        0xA407: "GainControl",
        // Degree of overall image gain adjustment
        0xA408: "Contrast",
        // Direction of contrast processing applied by camera
        0xA409: "Saturation",
        // Direction of saturation processing applied by camera
        0xA40A: "Sharpness",
        // Direction of sharpness processing applied by camera
        0xA40B: "DeviceSettingDescription",
        //
        0xA40C: "SubjectDistanceRange",
        // Distance to subject
        // other tags
        0xA005: "InteroperabilityIFDPointer",
        0xA420: "ImageUniqueID" // Identifier assigned uniquely to each image

      };
      var TiffTags = EXIF.TiffTags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x8769: "ExifIFDPointer",
        0x8825: "GPSInfoIFDPointer",
        0xA005: "InteroperabilityIFDPointer",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x011C: "PlanarConfiguration",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x0128: "ResolutionUnit",
        0x0111: "StripOffsets",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x0201: "JPEGInterchangeFormat",
        0x0202: "JPEGInterchangeFormatLength",
        0x012D: "TransferFunction",
        0x013E: "WhitePoint",
        0x013F: "PrimaryChromaticities",
        0x0211: "YCbCrCoefficients",
        0x0214: "ReferenceBlackWhite",
        0x0132: "DateTime",
        0x010E: "ImageDescription",
        0x010F: "Make",
        0x0110: "Model",
        0x0131: "Software",
        0x013B: "Artist",
        0x8298: "Copyright"
      };
      var GPSTags = EXIF.GPSTags = {
        0x0000: "GPSVersionID",
        0x0001: "GPSLatitudeRef",
        0x0002: "GPSLatitude",
        0x0003: "GPSLongitudeRef",
        0x0004: "GPSLongitude",
        0x0005: "GPSAltitudeRef",
        0x0006: "GPSAltitude",
        0x0007: "GPSTimeStamp",
        0x0008: "GPSSatellites",
        0x0009: "GPSStatus",
        0x000A: "GPSMeasureMode",
        0x000B: "GPSDOP",
        0x000C: "GPSSpeedRef",
        0x000D: "GPSSpeed",
        0x000E: "GPSTrackRef",
        0x000F: "GPSTrack",
        0x0010: "GPSImgDirectionRef",
        0x0011: "GPSImgDirection",
        0x0012: "GPSMapDatum",
        0x0013: "GPSDestLatitudeRef",
        0x0014: "GPSDestLatitude",
        0x0015: "GPSDestLongitudeRef",
        0x0016: "GPSDestLongitude",
        0x0017: "GPSDestBearingRef",
        0x0018: "GPSDestBearing",
        0x0019: "GPSDestDistanceRef",
        0x001A: "GPSDestDistance",
        0x001B: "GPSProcessingMethod",
        0x001C: "GPSAreaInformation",
        0x001D: "GPSDateStamp",
        0x001E: "GPSDifferential"
      }; // EXIF 2.3 Spec

      var IFD1Tags = EXIF.IFD1Tags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0111: "StripOffsets",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x011C: "PlanarConfiguration",
        0x0128: "ResolutionUnit",
        0x0201: "JpegIFOffset",
        // When image format is JPEG, this value show offset to JPEG data stored.(aka "ThumbnailOffset" or "JPEGInterchangeFormat")
        0x0202: "JpegIFByteCount",
        // When image format is JPEG, this value shows data size of JPEG image (aka "ThumbnailLength" or "JPEGInterchangeFormatLength")
        0x0211: "YCbCrCoefficients",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x0214: "ReferenceBlackWhite"
      };
      var StringValues = EXIF.StringValues = {
        ExposureProgram: {
          0: "Not defined",
          1: "Manual",
          2: "Normal program",
          3: "Aperture priority",
          4: "Shutter priority",
          5: "Creative program",
          6: "Action program",
          7: "Portrait mode",
          8: "Landscape mode"
        },
        MeteringMode: {
          0: "Unknown",
          1: "Average",
          2: "CenterWeightedAverage",
          3: "Spot",
          4: "MultiSpot",
          5: "Pattern",
          6: "Partial",
          255: "Other"
        },
        LightSource: {
          0: "Unknown",
          1: "Daylight",
          2: "Fluorescent",
          3: "Tungsten (incandescent light)",
          4: "Flash",
          9: "Fine weather",
          10: "Cloudy weather",
          11: "Shade",
          12: "Daylight fluorescent (D 5700 - 7100K)",
          13: "Day white fluorescent (N 4600 - 5400K)",
          14: "Cool white fluorescent (W 3900 - 4500K)",
          15: "White fluorescent (WW 3200 - 3700K)",
          17: "Standard light A",
          18: "Standard light B",
          19: "Standard light C",
          20: "D55",
          21: "D65",
          22: "D75",
          23: "D50",
          24: "ISO studio tungsten",
          255: "Other"
        },
        Flash: {
          0x0000: "Flash did not fire",
          0x0001: "Flash fired",
          0x0005: "Strobe return light not detected",
          0x0007: "Strobe return light detected",
          0x0009: "Flash fired, compulsory flash mode",
          0x000D: "Flash fired, compulsory flash mode, return light not detected",
          0x000F: "Flash fired, compulsory flash mode, return light detected",
          0x0010: "Flash did not fire, compulsory flash mode",
          0x0018: "Flash did not fire, auto mode",
          0x0019: "Flash fired, auto mode",
          0x001D: "Flash fired, auto mode, return light not detected",
          0x001F: "Flash fired, auto mode, return light detected",
          0x0020: "No flash function",
          0x0041: "Flash fired, red-eye reduction mode",
          0x0045: "Flash fired, red-eye reduction mode, return light not detected",
          0x0047: "Flash fired, red-eye reduction mode, return light detected",
          0x0049: "Flash fired, compulsory flash mode, red-eye reduction mode",
          0x004D: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
          0x004F: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
          0x0059: "Flash fired, auto mode, red-eye reduction mode",
          0x005D: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
          0x005F: "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod: {
          1: "Not defined",
          2: "One-chip color area sensor",
          3: "Two-chip color area sensor",
          4: "Three-chip color area sensor",
          5: "Color sequential area sensor",
          7: "Trilinear sensor",
          8: "Color sequential linear sensor"
        },
        SceneCaptureType: {
          0: "Standard",
          1: "Landscape",
          2: "Portrait",
          3: "Night scene"
        },
        SceneType: {
          1: "Directly photographed"
        },
        CustomRendered: {
          0: "Normal process",
          1: "Custom process"
        },
        WhiteBalance: {
          0: "Auto white balance",
          1: "Manual white balance"
        },
        GainControl: {
          0: "None",
          1: "Low gain up",
          2: "High gain up",
          3: "Low gain down",
          4: "High gain down"
        },
        Contrast: {
          0: "Normal",
          1: "Soft",
          2: "Hard"
        },
        Saturation: {
          0: "Normal",
          1: "Low saturation",
          2: "High saturation"
        },
        Sharpness: {
          0: "Normal",
          1: "Soft",
          2: "Hard"
        },
        SubjectDistanceRange: {
          0: "Unknown",
          1: "Macro",
          2: "Close view",
          3: "Distant view"
        },
        FileSource: {
          3: "DSC"
        },
        Components: {
          0: "",
          1: "Y",
          2: "Cb",
          3: "Cr",
          4: "R",
          5: "G",
          6: "B"
        }
      };

      function imageHasData(img) {
        return !!img.exifdata;
      }

      function base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'

        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);

        for (var i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i);
        }

        return buffer;
      }

      function objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";

        http.onload = function (e) {
          if (this.status == 200 || this.status === 0) {
            callback(this.response);
          }
        };

        http.send();
      }

      function getImageData(img, callback) {
        function handleBinaryFile(binFile) {
          var data = findEXIFinJPEG(binFile);
          img.exifdata = data || {};
          var iptcdata = findIPTCinJPEG(binFile);
          img.iptcdata = iptcdata || {};

          if (EXIF.isXmpEnabled) {
            var xmpdata = findXMPinJPEG(binFile);
            img.xmpdata = xmpdata || {};
          }

          if (callback) {
            callback.call(img);
          }
        }

        if (img.src) {
          if (/^data\:/i.test(img.src)) {
            // Data URI
            var arrayBuffer = base64ToArrayBuffer(img.src);
            handleBinaryFile(arrayBuffer);
          } else if (/^blob\:/i.test(img.src)) {
            // Object URL
            var fileReader = new FileReader();

            fileReader.onload = function (e) {
              handleBinaryFile(e.target.result);
            };

            objectURLToBlob(img.src, function (blob) {
              fileReader.readAsArrayBuffer(blob);
            });
          } else {
            var http = new XMLHttpRequest();

            http.onload = function () {
              if (this.status == 200 || this.status === 0) {
                handleBinaryFile(http.response);
              } else {
                throw "Could not load image";
              }

              http = null;
            };

            http.open("GET", img.src, true);
            http.responseType = "arraybuffer";
            http.send(null);
          }
        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
          var fileReader = new FileReader();

          fileReader.onload = function (e) {
            handleBinaryFile(e.target.result);
          };

          fileReader.readAsArrayBuffer(img);
        }
      }

      function findEXIFinJPEG(file) {
        var dataView = new DataView(file);

        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
          return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            marker;

        while (offset < length) {
          if (dataView.getUint8(offset) != 0xFF) {
            return false; // not a valid marker, something is wrong
          }

          marker = dataView.getUint8(offset + 1); // we could implement handling for other markers here,
          // but we're only looking for 0xFFE1 for EXIF data

          if (marker == 225) {
            return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2); // offset += 2 + file.getShortAt(offset+2, true);
          } else {
            offset += 2 + dataView.getUint16(offset + 2);
          }
        }
      }

      function findIPTCinJPEG(file) {
        var dataView = new DataView(file);

        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
          return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength;

        var isFieldSegmentStart = function isFieldSegmentStart(dataView, offset) {
          return dataView.getUint8(offset) === 0x38 && dataView.getUint8(offset + 1) === 0x42 && dataView.getUint8(offset + 2) === 0x49 && dataView.getUint8(offset + 3) === 0x4D && dataView.getUint8(offset + 4) === 0x04 && dataView.getUint8(offset + 5) === 0x04;
        };

        while (offset < length) {
          if (isFieldSegmentStart(dataView, offset)) {
            // Get the length of the name header (which is padded to an even number of bytes)
            var nameHeaderLength = dataView.getUint8(offset + 7);
            if (nameHeaderLength % 2 !== 0) nameHeaderLength += 1; // Check for pre photoshop 6 format

            if (nameHeaderLength === 0) {
              // Always 4
              nameHeaderLength = 4;
            }

            var startOffset = offset + 8 + nameHeaderLength;
            var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
            return readIPTCData(file, startOffset, sectionLength);
            break;
          } // Not the marker, continue searching


          offset++;
        }
      }

      var IptcFieldMap = {
        0x78: 'caption',
        0x6E: 'credit',
        0x19: 'keywords',
        0x37: 'dateCreated',
        0x50: 'byline',
        0x55: 'bylineTitle',
        0x7A: 'captionWriter',
        0x69: 'headline',
        0x74: 'copyright',
        0x0F: 'category'
      };

      function readIPTCData(file, startOffset, sectionLength) {
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType;
        var segmentStartPos = startOffset;

        while (segmentStartPos < startOffset + sectionLength) {
          if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
            segmentType = dataView.getUint8(segmentStartPos + 2);

            if (segmentType in IptcFieldMap) {
              dataSize = dataView.getInt16(segmentStartPos + 3);
              fieldName = IptcFieldMap[segmentType];
              fieldValue = getStringFromDB(dataView, segmentStartPos + 5, dataSize); // Check if we already stored a value with this name

              if (data.hasOwnProperty(fieldName)) {
                // Value already stored with this name, create multivalue field
                if (data[fieldName] instanceof Array) {
                  data[fieldName].push(fieldValue);
                } else {
                  data[fieldName] = [data[fieldName], fieldValue];
                }
              } else {
                data[fieldName] = fieldValue;
              }
            }
          }

          segmentStartPos++;
        }

        return data;
      }

      function readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd),
            tags = {},
            entryOffset,
            tag,
            i;

        for (i = 0; i < entries; i++) {
          entryOffset = dirStart + i * 12 + 2;
          tag = strings[file.getUint16(entryOffset, !bigEnd)];
          if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
          tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }

        return tags;
      }

      function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset + 2, !bigEnd),
            numValues = file.getUint32(entryOffset + 4, !bigEnd),
            valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart,
            offset,
            vals,
            val,
            n,
            numerator,
            denominator;

        switch (type) {
          case 1: // byte, 8-bit unsigned int

          case 7:
            // undefined, 8-bit byte, value depending on field
            if (numValues == 1) {
              return file.getUint8(entryOffset + 8, !bigEnd);
            } else {
              offset = numValues > 4 ? valueOffset : entryOffset + 8;
              vals = [];

              for (n = 0; n < numValues; n++) {
                vals[n] = file.getUint8(offset + n);
              }

              return vals;
            }

          case 2:
            // ascii, 8-bit byte
            offset = numValues > 4 ? valueOffset : entryOffset + 8;
            return getStringFromDB(file, offset, numValues - 1);

          case 3:
            // short, 16 bit int
            if (numValues == 1) {
              return file.getUint16(entryOffset + 8, !bigEnd);
            } else {
              offset = numValues > 2 ? valueOffset : entryOffset + 8;
              vals = [];

              for (n = 0; n < numValues; n++) {
                vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
              }

              return vals;
            }

          case 4:
            // long, 32 bit int
            if (numValues == 1) {
              return file.getUint32(entryOffset + 8, !bigEnd);
            } else {
              vals = [];

              for (n = 0; n < numValues; n++) {
                vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
              }

              return vals;
            }

          case 5:
            // rational = two long values, first is numerator, second is denominator
            if (numValues == 1) {
              numerator = file.getUint32(valueOffset, !bigEnd);
              denominator = file.getUint32(valueOffset + 4, !bigEnd);
              val = new Number(numerator / denominator);
              val.numerator = numerator;
              val.denominator = denominator;
              return val;
            } else {
              vals = [];

              for (n = 0; n < numValues; n++) {
                numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
                denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
                vals[n] = new Number(numerator / denominator);
                vals[n].numerator = numerator;
                vals[n].denominator = denominator;
              }

              return vals;
            }

          case 9:
            // slong, 32 bit signed int
            if (numValues == 1) {
              return file.getInt32(entryOffset + 8, !bigEnd);
            } else {
              vals = [];

              for (n = 0; n < numValues; n++) {
                vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
              }

              return vals;
            }

          case 10:
            // signed rational, two slongs, first is numerator, second is denominator
            if (numValues == 1) {
              return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
            } else {
              vals = [];

              for (n = 0; n < numValues; n++) {
                vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
              }

              return vals;
            }

        }
      }
      /**
      * Given an IFD (Image File Directory) start offset
      * returns an offset to next IFD or 0 if it's the last IFD.
      */


      function getNextIFDOffset(dataView, dirStart, bigEnd) {
        //the first 2bytes means the number of directory entries contains in this IFD
        var entries = dataView.getUint16(dirStart, !bigEnd); // After last directory entry, there is a 4bytes of data,
        // it means an offset to next IFD.
        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.

        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
      }

      function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd) {
        // get the IFD1 offset
        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart + firstIFDOffset, bigEnd);

        if (!IFD1OffsetPointer) {
          // console.log('******** IFD1Offset is empty, image thumb not found ********');
          return {};
        } else if (IFD1OffsetPointer > dataView.byteLength) {
          // this should not happen
          // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
          return {};
        } // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);


        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd); // EXIF 2.3 specification for JPEG format thumbnail
        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.

        if (thumbTags['Compression']) {
          // console.log('Thumbnail image found!');
          switch (thumbTags['Compression']) {
            case 6:
              // console.log('Thumbnail image format is JPEG');
              if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
                // extract the thumbnail
                var tOffset = tiffStart + thumbTags.JpegIFOffset;
                var tLength = thumbTags.JpegIFByteCount;
                thumbTags['blob'] = new Blob([new Uint8Array(dataView.buffer, tOffset, tLength)], {
                  type: 'image/jpeg'
                });
              }

              break;

            case 1:
              console.log("Thumbnail image format is TIFF, which is not implemented.");
              break;

            default:
              console.log("Unknown thumbnail image format '%s'", thumbTags['Compression']);
          }
        } else if (thumbTags['PhotometricInterpretation'] == 2) {
          console.log("Thumbnail image format is RGB, which is not implemented.");
        }

        return thumbTags;
      }

      function getStringFromDB(buffer, start, length) {
        var outstr = "";

        for (var n = start; n < start + length; n++) {
          outstr += String.fromCharCode(buffer.getUint8(n));
        }

        return outstr;
      }

      function readEXIFData(file, start) {
        if (getStringFromDB(file, start, 4) != "Exif") {
          return false;
        }

        var bigEnd,
            tags,
            tag,
            exifData,
            gpsData,
            tiffOffset = start + 6; // test for TIFF validity and endianness

        if (file.getUint16(tiffOffset) == 0x4949) {
          bigEnd = false;
        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
          bigEnd = true;
        } else {
          return false;
        }

        if (file.getUint16(tiffOffset + 2, !bigEnd) != 0x002A) {
          return false;
        }

        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);

        if (firstIFDOffset < 0x00000008) {
          return false;
        }

        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

        if (tags.ExifIFDPointer) {
          exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);

          for (tag in exifData) {
            switch (tag) {
              case "LightSource":
              case "Flash":
              case "MeteringMode":
              case "ExposureProgram":
              case "SensingMethod":
              case "SceneCaptureType":
              case "SceneType":
              case "CustomRendered":
              case "WhiteBalance":
              case "GainControl":
              case "Contrast":
              case "Saturation":
              case "Sharpness":
              case "SubjectDistanceRange":
              case "FileSource":
                exifData[tag] = StringValues[tag][exifData[tag]];
                break;

              case "ExifVersion":
              case "FlashpixVersion":
                exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                break;

              case "ComponentsConfiguration":
                exifData[tag] = StringValues.Components[exifData[tag][0]] + StringValues.Components[exifData[tag][1]] + StringValues.Components[exifData[tag][2]] + StringValues.Components[exifData[tag][3]];
                break;
            }

            tags[tag] = exifData[tag];
          }
        }

        if (tags.GPSInfoIFDPointer) {
          gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);

          for (tag in gpsData) {
            switch (tag) {
              case "GPSVersionID":
                gpsData[tag] = gpsData[tag][0] + "." + gpsData[tag][1] + "." + gpsData[tag][2] + "." + gpsData[tag][3];
                break;
            }

            tags[tag] = gpsData[tag];
          }
        } // extract thumbnail


        tags['thumbnail'] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);
        return tags;
      }

      function findXMPinJPEG(file) {
        if (!('DOMParser' in self)) {
          // console.warn('XML parsing not supported without DOMParser');
          return;
        }

        var dataView = new DataView(file);

        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
          return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            dom = new DOMParser();

        while (offset < length - 4) {
          if (getStringFromDB(dataView, offset, 4) == "http") {
            var startOffset = offset - 1;
            var sectionLength = dataView.getUint16(offset - 2) - 1;
            var xmpString = getStringFromDB(dataView, startOffset, sectionLength);
            var xmpEndIndex = xmpString.indexOf('xmpmeta>') + 8;
            xmpString = xmpString.substring(xmpString.indexOf('<x:xmpmeta'), xmpEndIndex);
            var indexOfXmp = xmpString.indexOf('x:xmpmeta') + 10; //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
            //Without these namespaces, XML is thought to be invalid by parsers

            xmpString = xmpString.slice(0, indexOfXmp) + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" ' + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ' + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" ' + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" ' + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" ' + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" ' + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" ' + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" ' + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" ' + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" ' + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" ' + xmpString.slice(indexOfXmp);
            var domDocument = dom.parseFromString(xmpString, 'text/xml');
            return xml2Object(domDocument);
          } else {
            offset++;
          }
        }
      }

      function xml2json(xml) {
        var json = {};

        if (xml.nodeType == 1) {
          // element node
          if (xml.attributes.length > 0) {
            json['@attributes'] = {};

            for (var j = 0; j < xml.attributes.length; j++) {
              var attribute = xml.attributes.item(j);
              json['@attributes'][attribute.nodeName] = attribute.nodeValue;
            }
          }
        } else if (xml.nodeType == 3) {
          // text node
          return xml.nodeValue;
        } // deal with children


        if (xml.hasChildNodes()) {
          for (var i = 0; i < xml.childNodes.length; i++) {
            var child = xml.childNodes.item(i);
            var nodeName = child.nodeName;

            if (json[nodeName] == null) {
              json[nodeName] = xml2json(child);
            } else {
              if (json[nodeName].push == null) {
                var old = json[nodeName];
                json[nodeName] = [];
                json[nodeName].push(old);
              }

              json[nodeName].push(xml2json(child));
            }
          }
        }

        return json;
      }

      function xml2Object(xml) {
        try {
          var obj = {};

          if (xml.children.length > 0) {
            for (var i = 0; i < xml.children.length; i++) {
              var item = xml.children.item(i);
              var attributes = item.attributes;

              for (var idx in attributes) {
                var itemAtt = attributes[idx];
                var dataKey = itemAtt.nodeName;
                var dataValue = itemAtt.nodeValue;

                if (dataKey !== undefined) {
                  obj[dataKey] = dataValue;
                }
              }

              var nodeName = item.nodeName;

              if (typeof obj[nodeName] == "undefined") {
                obj[nodeName] = xml2json(item);
              } else {
                if (typeof obj[nodeName].push == "undefined") {
                  var old = obj[nodeName];
                  obj[nodeName] = [];
                  obj[nodeName].push(old);
                }

                obj[nodeName].push(xml2json(item));
              }
            }
          } else {
            obj = xml.textContent;
          }

          return obj;
        } catch (e) {
          console.log(e.message);
        }
      }

      EXIF.enableXmp = function () {
        EXIF.isXmpEnabled = true;
      };

      EXIF.disableXmp = function () {
        EXIF.isXmpEnabled = false;
      };

      EXIF.getData = function (img, callback) {
        if ((self.Image && img instanceof self.Image || self.HTMLImageElement && img instanceof self.HTMLImageElement) && !img.complete) return false;

        if (!imageHasData(img)) {
          getImageData(img, callback);
        } else {
          if (callback) {
            callback.call(img);
          }
        }

        return true;
      };

      EXIF.getTag = function (img, tag) {
        if (!imageHasData(img)) return;
        return img.exifdata[tag];
      };

      EXIF.getIptcTag = function (img, tag) {
        if (!imageHasData(img)) return;
        return img.iptcdata[tag];
      };

      EXIF.getAllTags = function (img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.exifdata,
            tags = {};

        for (a in data) {
          if (data.hasOwnProperty(a)) {
            tags[a] = data[a];
          }
        }

        return tags;
      };

      EXIF.getAllIptcTags = function (img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.iptcdata,
            tags = {};

        for (a in data) {
          if (data.hasOwnProperty(a)) {
            tags[a] = data[a];
          }
        }

        return tags;
      };

      EXIF.pretty = function (img) {
        if (!imageHasData(img)) return "";
        var a,
            data = img.exifdata,
            strPretty = "";

        for (a in data) {
          if (data.hasOwnProperty(a)) {
            if (typeof data[a] == "object") {
              if (data[a] instanceof Number) {
                strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
              } else {
                strPretty += a + " : [" + data[a].length + " values]\r\n";
              }
            } else {
              strPretty += a + " : " + data[a] + "\r\n";
            }
          }
        }

        return strPretty;
      };

      EXIF.readFromBinaryFile = function (file) {
        return findEXIFinJPEG(file);
      };
    }).call(commonjsGlobal);
  });
  var exif_1 = exif.EXIF;
  /*!
   * Compressor.js v1.1.1
   * https://fengyuanchen.github.io/compressorjs
   *
   * Copyright 2018-present Chen Fengyuan
   * Released under the MIT license
   *
   * Date: 2021-10-05T02:32:40.212Z
   */

  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys$1(Object(source), true).forEach(function (key) {
          _defineProperty$1(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$1(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$1(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var canvasToBlob = {
    exports: {}
  };
  /*
   * JavaScript Canvas to Blob
   * https://github.com/blueimp/JavaScript-Canvas-to-Blob
   *
   * Copyright 2012, Sebastian Tschan
   * https://blueimp.net
   *
   * Licensed under the MIT license:
   * https://opensource.org/licenses/MIT
   *
   * Based on stackoverflow user Stoive's code snippet:
   * http://stackoverflow.com/q/4998908
   */

  (function (module) {
    if (typeof window === 'undefined') {
      return;
    }

    (function (window) {
      var CanvasPrototype = window.HTMLCanvasElement && window.HTMLCanvasElement.prototype;

      var hasBlobConstructor = window.Blob && function () {
        try {
          return Boolean(new Blob());
        } catch (e) {
          return false;
        }
      }();

      var hasArrayBufferViewSupport = hasBlobConstructor && window.Uint8Array && function () {
        try {
          return new Blob([new Uint8Array(100)]).size === 100;
        } catch (e) {
          return false;
        }
      }();

      var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
      var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;

      var dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window.atob && window.ArrayBuffer && window.Uint8Array && function (dataURI) {
        var matches, mediaType, isBase64, dataString, byteString, arrayBuffer, intArray, i, bb; // Parse the dataURI components as per RFC 2397

        matches = dataURI.match(dataURIPattern);

        if (!matches) {
          throw new Error('invalid data URI');
        } // Default to text/plain;charset=US-ASCII


        mediaType = matches[2] ? matches[1] : 'text/plain' + (matches[3] || ';charset=US-ASCII');
        isBase64 = !!matches[4];
        dataString = dataURI.slice(matches[0].length);

        if (isBase64) {
          // Convert base64 to raw binary data held in a string:
          byteString = atob(dataString);
        } else {
          // Convert base64/URLEncoded data component to raw binary:
          byteString = decodeURIComponent(dataString);
        } // Write the bytes of the string to an ArrayBuffer:


        arrayBuffer = new ArrayBuffer(byteString.length);
        intArray = new Uint8Array(arrayBuffer);

        for (i = 0; i < byteString.length; i += 1) {
          intArray[i] = byteString.charCodeAt(i);
        } // Write the ArrayBuffer (or ArrayBufferView) to a blob:


        if (hasBlobConstructor) {
          return new Blob([hasArrayBufferViewSupport ? intArray : arrayBuffer], {
            type: mediaType
          });
        }

        bb = new BlobBuilder();
        bb.append(arrayBuffer);
        return bb.getBlob(mediaType);
      };

      if (window.HTMLCanvasElement && !CanvasPrototype.toBlob) {
        if (CanvasPrototype.mozGetAsFile) {
          CanvasPrototype.toBlob = function (callback, type, quality) {
            var self = this;
            setTimeout(function () {
              if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) {
                callback(dataURLtoBlob(self.toDataURL(type, quality)));
              } else {
                callback(self.mozGetAsFile('blob', type));
              }
            });
          };
        } else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
          if (CanvasPrototype.msToBlob) {
            CanvasPrototype.toBlob = function (callback, type, quality) {
              var self = this;
              setTimeout(function () {
                if ((type && type !== 'image/png' || quality) && CanvasPrototype.toDataURL && dataURLtoBlob) {
                  callback(dataURLtoBlob(self.toDataURL(type, quality)));
                } else {
                  callback(self.msToBlob(type));
                }
              });
            };
          } else {
            CanvasPrototype.toBlob = function (callback, type, quality) {
              var self = this;
              setTimeout(function () {
                callback(dataURLtoBlob(self.toDataURL(type, quality)));
              });
            };
          }
        }
      }

      if (module.exports) {
        module.exports = dataURLtoBlob;
      } else {
        window.dataURLtoBlob = dataURLtoBlob;
      }
    })(window);
  })(canvasToBlob);

  var toBlob = canvasToBlob.exports;

  var isBlob = function isBlob(value) {
    if (typeof Blob === 'undefined') {
      return false;
    }

    return value instanceof Blob || Object.prototype.toString.call(value) === '[object Blob]';
  };

  var DEFAULTS$1 = {
    /**
     * Indicates if output the original image instead of the compressed one
     * when the size of the compressed image is greater than the original one's
     * @type {boolean}
     */
    strict: true,

    /**
     * Indicates if read the image's Exif Orientation information,
     * and then rotate or flip the image automatically.
     * @type {boolean}
     */
    checkOrientation: true,

    /**
     * The max width of the output image.
     * @type {number}
     */
    maxWidth: Infinity,

    /**
     * The max height of the output image.
     * @type {number}
     */
    maxHeight: Infinity,

    /**
     * The min width of the output image.
     * @type {number}
     */
    minWidth: 0,

    /**
     * The min height of the output image.
     * @type {number}
     */
    minHeight: 0,

    /**
     * The width of the output image.
     * If not specified, the natural width of the source image will be used.
     * @type {number}
     */
    width: undefined,

    /**
     * The height of the output image.
     * If not specified, the natural height of the source image will be used.
     * @type {number}
     */
    height: undefined,

    /**
     * Sets how the size of the image should be resized to the container
     * specified by the `width` and `height` options.
     * @type {string}
     */
    resize: 'none',

    /**
     * The quality of the output image.
     * It must be a number between `0` and `1`,
     * and only available for `image/jpeg` and `image/webp` images.
     * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
     * @type {number}
     */
    quality: 0.8,

    /**
     * The mime type of the output image.
     * By default, the original mime type of the source image file will be used.
     * @type {string}
     */
    mimeType: 'auto',

    /**
     * Files whose file type is included in this list,
     * and whose file size exceeds the `convertSize` value will be converted to JPEGs.
     * @type {string｜Array}
     */
    convertTypes: ['image/png'],

    /**
     * PNG files over this size (5 MB by default) will be converted to JPEGs.
     * To disable this, just set the value to `Infinity`.
     * @type {number}
     */
    convertSize: 5000000,

    /**
     * The hook function to execute before draw the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.fillStyle = '#fff';
     * }
     */
    beforeDraw: null,

    /**
     * The hook function to execute after drew the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.filter = 'grayscale(100%)';
     * }
     */
    drew: null,

    /**
     * The hook function to execute when success to compress the image.
     * @type {Function}
     * @param {File} file - The compressed image File object.
     * @example
     * function (file) {
     *   console.log(file);
     * }
     */
    success: null,

    /**
     * The hook function to execute when fail to compress the image.
     * @type {Function}
     * @param {Error} err - An Error object.
     * @example
     * function (err) {
     *   console.log(err.message);
     * }
     */
    error: null
  };
  var IS_BROWSER$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  var WINDOW$1 = IS_BROWSER$1 ? window : {};
  /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */

  var isPositiveNumber$1 = function isPositiveNumber(value) {
    return value > 0 && value < Infinity;
  };

  var slice$1 = Array.prototype.slice;
  /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */

  function toArray$1(value) {
    return Array.from ? Array.from(value) : slice$1.call(value);
  }

  var REGEXP_IMAGE_TYPE = /^image\/.+$/;
  /**
   * Check if the given value is a mime type of image.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given is a mime type of image, else `false`.
   */

  function isImageType(value) {
    return REGEXP_IMAGE_TYPE.test(value);
  }
  /**
   * Convert image type to extension.
   * @param {string} value - The image type to convert.
   * @returns {boolean} Returns the image extension.
   */


  function imageTypeToExtension(value) {
    var extension = isImageType(value) ? value.substr(6) : '';

    if (extension === 'jpeg') {
      extension = 'jpg';
    }

    return ".".concat(extension);
  }

  var fromCharCode$1 = String.fromCharCode;
  /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */

  function getStringFromCharCode$1(dataView, start, length) {
    var str = '';
    var i;
    length += start;

    for (i = start; i < length; i += 1) {
      str += fromCharCode$1(dataView.getUint8(i));
    }

    return str;
  }

  var btoa$1 = WINDOW$1.btoa;
  /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */

  function arrayBufferToDataURL$1(arrayBuffer, mimeType) {
    var chunks = [];
    var chunkSize = 8192;
    var uint8 = new Uint8Array(arrayBuffer);

    while (uint8.length > 0) {
      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
      // eslint-disable-next-line prefer-spread
      chunks.push(fromCharCode$1.apply(null, toArray$1(uint8.subarray(0, chunkSize))));
      uint8 = uint8.subarray(chunkSize);
    }

    return "data:".concat(mimeType, ";base64,").concat(btoa$1(chunks.join('')));
  }
  /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */


  function resetAndGetOrientation$1(arrayBuffer) {
    var dataView = new DataView(arrayBuffer);
    var orientation; // Ignores range error when the image does not have correct Exif information

    try {
      var littleEndian;
      var app1Start;
      var ifdStart; // Only handle JPEG image (start by 0xFFD8)

      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
        var length = dataView.byteLength;
        var offset = 2;

        while (offset + 1 < length) {
          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
            app1Start = offset;
            break;
          }

          offset += 1;
        }
      }

      if (app1Start) {
        var exifIDCode = app1Start + 4;
        var tiffOffset = app1Start + 10;

        if (getStringFromCharCode$1(dataView, exifIDCode, 4) === 'Exif') {
          var endianness = dataView.getUint16(tiffOffset);
          littleEndian = endianness === 0x4949;

          if (littleEndian || endianness === 0x4D4D
          /* bigEndian */
          ) {
              if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

                if (firstIFDOffset >= 0x00000008) {
                  ifdStart = tiffOffset + firstIFDOffset;
                }
              }
            }
        }
      }

      if (ifdStart) {
        var _length = dataView.getUint16(ifdStart, littleEndian);

        var _offset;

        var i;

        for (i = 0; i < _length; i += 1) {
          _offset = ifdStart + i * 12 + 2;

          if (dataView.getUint16(_offset, littleEndian) === 0x0112
          /* Orientation */
          ) {
              // 8 is the offset of the current tag's value
              _offset += 8; // Get the original orientation value

              orientation = dataView.getUint16(_offset, littleEndian); // Override the orientation with its default value

              dataView.setUint16(_offset, 1, littleEndian);
              break;
            }
        }
      }
    } catch (e) {
      orientation = 1;
    }

    return orientation;
  }
  /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */


  function parseOrientation$1(orientation) {
    var rotate = 0;
    var scaleX = 1;
    var scaleY = 1;

    switch (orientation) {
      // Flip horizontal
      case 2:
        scaleX = -1;
        break;
      // Rotate left 180°

      case 3:
        rotate = -180;
        break;
      // Flip vertical

      case 4:
        scaleY = -1;
        break;
      // Flip vertical and rotate right 90°

      case 5:
        rotate = 90;
        scaleY = -1;
        break;
      // Rotate right 90°

      case 6:
        rotate = 90;
        break;
      // Flip horizontal and rotate right 90°

      case 7:
        rotate = 90;
        scaleX = -1;
        break;
      // Rotate left 90°

      case 8:
        rotate = -90;
        break;
    }

    return {
      rotate: rotate,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }

  var REGEXP_DECIMALS$1 = /\.\d*(?:0|9){12}\d*$/;
  /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */

  function normalizeDecimalNumber$1(value) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
    return REGEXP_DECIMALS$1.test(value) ? Math.round(value * times) / times : value;
  }
  /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */


  function getAdjustedSizes$1(_ref) {
    var aspectRatio = _ref.aspectRatio,
        height = _ref.height,
        width = _ref.width;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    var isValidWidth = isPositiveNumber$1(width);
    var isValidHeight = isPositiveNumber$1(height);

    if (isValidWidth && isValidHeight) {
      var adjustedWidth = height * aspectRatio;

      if ((type === 'contain' || type === 'none') && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
        height = width / aspectRatio;
      } else {
        width = height * aspectRatio;
      }
    } else if (isValidWidth) {
      height = width / aspectRatio;
    } else if (isValidHeight) {
      width = height * aspectRatio;
    }

    return {
      width: width,
      height: height
    };
  }

  var ArrayBuffer$1 = WINDOW$1.ArrayBuffer,
      FileReader$1 = WINDOW$1.FileReader;
  var URL = WINDOW$1.URL || WINDOW$1.webkitURL;
  var REGEXP_EXTENSION = /\.\w+$/;
  var AnotherCompressor = WINDOW$1.Compressor;
  /**
   * Creates a new image compressor.
   * @class
   */

  var Compressor =
  /*#__PURE__*/
  function () {
    /**
     * The constructor of Compressor.
     * @param {File|Blob} file - The target image file for compressing.
     * @param {Object} [options] - The options for compressing.
     */
    function Compressor(file, options) {
      _classCallCheck$2(this, Compressor);

      this.file = file;
      this.image = new Image();
      this.options = _objectSpread2$1(_objectSpread2$1({}, DEFAULTS$1), options);
      this.aborted = false;
      this.result = null;
      this.init();
    }

    _createClass$2(Compressor, [{
      key: "init",
      value: function init() {
        var _this = this;

        var file = this.file,
            options = this.options;

        if (!isBlob(file)) {
          this.fail(new Error('The first argument must be a File or Blob object.'));
          return;
        }

        var mimeType = file.type;

        if (!isImageType(mimeType)) {
          this.fail(new Error('The first argument must be an image File or Blob object.'));
          return;
        }

        if (!URL || !FileReader$1) {
          this.fail(new Error('The current browser does not support image compression.'));
          return;
        }

        if (!ArrayBuffer$1) {
          options.checkOrientation = false;
        }

        if (URL && !options.checkOrientation) {
          this.load({
            url: URL.createObjectURL(file)
          });
        } else {
          var reader = new FileReader$1();
          var checkOrientation = options.checkOrientation && mimeType === 'image/jpeg';
          this.reader = reader;

          reader.onload = function (_ref) {
            var target = _ref.target;
            var result = target.result;
            var data = {};

            if (checkOrientation) {
              // Reset the orientation value to its default value 1
              // as some iOS browsers will render image with its orientation
              var orientation = resetAndGetOrientation$1(result);

              if (orientation > 1 || !URL) {
                // Generate a new URL which has the default orientation value
                data.url = arrayBufferToDataURL$1(result, mimeType);

                if (orientation > 1) {
                  _extends(data, parseOrientation$1(orientation));
                }
              } else {
                data.url = URL.createObjectURL(file);
              }
            } else {
              data.url = result;
            }

            _this.load(data);
          };

          reader.onabort = function () {
            _this.fail(new Error('Aborted to read the image with FileReader.'));
          };

          reader.onerror = function () {
            _this.fail(new Error('Failed to read the image with FileReader.'));
          };

          reader.onloadend = function () {
            _this.reader = null;
          };

          if (checkOrientation) {
            reader.readAsArrayBuffer(file);
          } else {
            reader.readAsDataURL(file);
          }
        }
      }
    }, {
      key: "load",
      value: function load(data) {
        var _this2 = this;

        var file = this.file,
            image = this.image;

        image.onload = function () {
          _this2.draw(_objectSpread2$1(_objectSpread2$1({}, data), {}, {
            naturalWidth: image.naturalWidth,
            naturalHeight: image.naturalHeight
          }));
        };

        image.onabort = function () {
          _this2.fail(new Error('Aborted to load the image.'));
        };

        image.onerror = function () {
          _this2.fail(new Error('Failed to load the image.'));
        }; // Match all browsers that use WebKit as the layout engine in iOS devices,
        // such as Safari for iOS, Chrome for iOS, and in-app browsers.


        if (WINDOW$1.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW$1.navigator.userAgent)) {
          // Fix the `The operation is insecure` error (#57)
          image.crossOrigin = 'anonymous';
        }

        image.alt = file.name;
        image.src = data.url;
      }
    }, {
      key: "draw",
      value: function draw(_ref2) {
        var _this3 = this;

        var naturalWidth = _ref2.naturalWidth,
            naturalHeight = _ref2.naturalHeight,
            _ref2$rotate = _ref2.rotate,
            rotate = _ref2$rotate === void 0 ? 0 : _ref2$rotate,
            _ref2$scaleX = _ref2.scaleX,
            scaleX = _ref2$scaleX === void 0 ? 1 : _ref2$scaleX,
            _ref2$scaleY = _ref2.scaleY,
            scaleY = _ref2$scaleY === void 0 ? 1 : _ref2$scaleY;
        var file = this.file,
            image = this.image,
            options = this.options;
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var is90DegreesRotated = Math.abs(rotate) % 180 === 90;
        var resizable = (options.resize === 'contain' || options.resize === 'cover') && isPositiveNumber$1(options.width) && isPositiveNumber$1(options.height);
        var maxWidth = Math.max(options.maxWidth, 0) || Infinity;
        var maxHeight = Math.max(options.maxHeight, 0) || Infinity;
        var minWidth = Math.max(options.minWidth, 0) || 0;
        var minHeight = Math.max(options.minHeight, 0) || 0;
        var aspectRatio = naturalWidth / naturalHeight;
        var width = options.width,
            height = options.height;

        if (is90DegreesRotated) {
          var _ref3 = [maxHeight, maxWidth];
          maxWidth = _ref3[0];
          maxHeight = _ref3[1];
          var _ref4 = [minHeight, minWidth];
          minWidth = _ref4[0];
          minHeight = _ref4[1];
          var _ref5 = [height, width];
          width = _ref5[0];
          height = _ref5[1];
        }

        if (resizable) {
          aspectRatio = width / height;
        }

        var _getAdjustedSizes = getAdjustedSizes$1({
          aspectRatio: aspectRatio,
          width: maxWidth,
          height: maxHeight
        }, 'contain');

        maxWidth = _getAdjustedSizes.width;
        maxHeight = _getAdjustedSizes.height;

        var _getAdjustedSizes2 = getAdjustedSizes$1({
          aspectRatio: aspectRatio,
          width: minWidth,
          height: minHeight
        }, 'cover');

        minWidth = _getAdjustedSizes2.width;
        minHeight = _getAdjustedSizes2.height;

        if (resizable) {
          var _getAdjustedSizes3 = getAdjustedSizes$1({
            aspectRatio: aspectRatio,
            width: width,
            height: height
          }, options.resize);

          width = _getAdjustedSizes3.width;
          height = _getAdjustedSizes3.height;
        } else {
          var _getAdjustedSizes4 = getAdjustedSizes$1({
            aspectRatio: aspectRatio,
            width: width,
            height: height
          });

          var _getAdjustedSizes4$wi = _getAdjustedSizes4.width;
          width = _getAdjustedSizes4$wi === void 0 ? naturalWidth : _getAdjustedSizes4$wi;
          var _getAdjustedSizes4$he = _getAdjustedSizes4.height;
          height = _getAdjustedSizes4$he === void 0 ? naturalHeight : _getAdjustedSizes4$he;
        }

        width = Math.floor(normalizeDecimalNumber$1(Math.min(Math.max(width, minWidth), maxWidth)));
        height = Math.floor(normalizeDecimalNumber$1(Math.min(Math.max(height, minHeight), maxHeight)));
        var destX = -width / 2;
        var destY = -height / 2;
        var destWidth = width;
        var destHeight = height;
        var params = [];

        if (resizable) {
          var srcX = 0;
          var srcY = 0;
          var srcWidth = naturalWidth;
          var srcHeight = naturalHeight;

          var _getAdjustedSizes5 = getAdjustedSizes$1({
            aspectRatio: aspectRatio,
            width: naturalWidth,
            height: naturalHeight
          }, {
            contain: 'cover',
            cover: 'contain'
          }[options.resize]);

          srcWidth = _getAdjustedSizes5.width;
          srcHeight = _getAdjustedSizes5.height;
          srcX = (naturalWidth - srcWidth) / 2;
          srcY = (naturalHeight - srcHeight) / 2;
          params.push(srcX, srcY, srcWidth, srcHeight);
        }

        params.push(destX, destY, destWidth, destHeight);

        if (is90DegreesRotated) {
          var _ref6 = [height, width];
          width = _ref6[0];
          height = _ref6[1];
        }

        canvas.width = width;
        canvas.height = height;

        if (!isImageType(options.mimeType)) {
          options.mimeType = file.type;
        }

        var fillStyle = 'transparent'; // Converts PNG files over the `convertSize` to JPEGs.

        if (file.size > options.convertSize && options.convertTypes.indexOf(options.mimeType) >= 0) {
          options.mimeType = 'image/jpeg';
        }

        if (options.mimeType === 'image/jpeg') {
          fillStyle = '#fff';
        } // Override the default fill color (#000, black)


        context.fillStyle = fillStyle;
        context.fillRect(0, 0, width, height);

        if (options.beforeDraw) {
          options.beforeDraw.call(this, context, canvas);
        }

        if (this.aborted) {
          return;
        }

        context.save();
        context.translate(width / 2, height / 2);
        context.rotate(rotate * Math.PI / 180);
        context.scale(scaleX, scaleY);
        context.drawImage.apply(context, [image].concat(params));
        context.restore();

        if (options.drew) {
          options.drew.call(this, context, canvas);
        }

        if (this.aborted) {
          return;
        }

        var done = function done(result) {
          if (!_this3.aborted) {
            _this3.done({
              naturalWidth: naturalWidth,
              naturalHeight: naturalHeight,
              result: result
            });
          }
        };

        if (canvas.toBlob) {
          canvas.toBlob(done, options.mimeType, options.quality);
        } else {
          done(toBlob(canvas.toDataURL(options.mimeType, options.quality)));
        }
      }
    }, {
      key: "done",
      value: function done(_ref7) {
        var naturalWidth = _ref7.naturalWidth,
            naturalHeight = _ref7.naturalHeight,
            result = _ref7.result;
        var file = this.file,
            image = this.image,
            options = this.options;

        if (URL && !options.checkOrientation) {
          URL.revokeObjectURL(image.src);
        }

        if (result) {
          // Returns original file if the result is greater than it and without size related options
          if (options.strict && result.size > file.size && options.mimeType === file.type && !(options.width > naturalWidth || options.height > naturalHeight || options.minWidth > naturalWidth || options.minHeight > naturalHeight || options.maxWidth < naturalWidth || options.maxHeight < naturalHeight)) {
            result = file;
          } else {
            var date = new Date();
            result.lastModified = date.getTime();
            result.lastModifiedDate = date;
            result.name = file.name; // Convert the extension to match its type

            if (result.name && result.type !== file.type) {
              result.name = result.name.replace(REGEXP_EXTENSION, imageTypeToExtension(result.type));
            }
          }
        } else {
          // Returns original file if the result is null in some cases.
          result = file;
        }

        this.result = result;

        if (options.success) {
          options.success.call(this, result);
        }
      }
    }, {
      key: "fail",
      value: function fail(err) {
        var options = this.options;

        if (options.error) {
          options.error.call(this, err);
        } else {
          throw err;
        }
      }
    }, {
      key: "abort",
      value: function abort() {
        if (!this.aborted) {
          this.aborted = true;

          if (this.reader) {
            this.reader.abort();
          } else if (!this.image.complete) {
            this.image.onload = null;
            this.image.onabort();
          } else {
            this.fail(new Error('The compression process has been aborted.'));
          }
        }
      }
      /**
       * Get the no conflict compressor class.
       * @returns {Compressor} The compressor class.
       */

    }], [{
      key: "noConflict",
      value: function noConflict() {
        window.Compressor = AnotherCompressor;
        return Compressor;
      }
      /**
       * Change the default options.
       * @param {Object} options - The new default options.
       */

    }, {
      key: "setDefaults",
      value: function setDefaults(options) {
        _extends(DEFAULTS$1, options);
      }
    }]);

    return Compressor;
  }();

  var md5 = createCommonjsModule(function (module) {
    /**
     * [js-md5]{@link https://github.com/emn178/js-md5}
     *
     * @namespace md5
     * @version 0.7.3
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2014-2017
     * @license MIT
     */
    (function () {
      var ERROR = 'input is invalid type';
      var WINDOW = typeof window === 'object';
      var root = WINDOW ? window : {};

      if (root.JS_MD5_NO_WINDOW) {
        WINDOW = false;
      }

      var WEB_WORKER = !WINDOW && typeof self === 'object';
      var NODE_JS = !root.JS_MD5_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;

      if (NODE_JS) {
        root = commonjsGlobal;
      } else if (WEB_WORKER) {
        root = self;
      }

      var COMMON_JS = !root.JS_MD5_NO_COMMON_JS && 'object' === 'object' && module.exports;
      var ARRAY_BUFFER = !root.JS_MD5_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
      var HEX_CHARS = '0123456789abcdef'.split('');
      var EXTRA = [128, 32768, 8388608, -2147483648];
      var SHIFT = [0, 8, 16, 24];
      var OUTPUT_TYPES = ['hex', 'array', 'digest', 'buffer', 'arrayBuffer', 'base64'];
      var BASE64_ENCODE_CHAR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
      var blocks = [],
          buffer8;

      if (ARRAY_BUFFER) {
        var buffer = new ArrayBuffer(68);
        buffer8 = new Uint8Array(buffer);
        blocks = new Uint32Array(buffer);
      }

      if (root.JS_MD5_NO_NODE_JS || !Array.isArray) {
        Array.isArray = function (obj) {
          return Object.prototype.toString.call(obj) === '[object Array]';
        };
      }

      if (ARRAY_BUFFER && (root.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
        ArrayBuffer.isView = function (obj) {
          return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
        };
      }
      /**
       * @method hex
       * @memberof md5
       * @description Output hash as hex string
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {String} Hex string
       * @example
       * md5.hex('The quick brown fox jumps over the lazy dog');
       * // equal to
       * md5('The quick brown fox jumps over the lazy dog');
       */

      /**
       * @method digest
       * @memberof md5
       * @description Output hash as bytes array
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {Array} Bytes array
       * @example
       * md5.digest('The quick brown fox jumps over the lazy dog');
       */

      /**
       * @method array
       * @memberof md5
       * @description Output hash as bytes array
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {Array} Bytes array
       * @example
       * md5.array('The quick brown fox jumps over the lazy dog');
       */

      /**
       * @method arrayBuffer
       * @memberof md5
       * @description Output hash as ArrayBuffer
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {ArrayBuffer} ArrayBuffer
       * @example
       * md5.arrayBuffer('The quick brown fox jumps over the lazy dog');
       */

      /**
       * @method buffer
       * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
       * @memberof md5
       * @description Output hash as ArrayBuffer
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {ArrayBuffer} ArrayBuffer
       * @example
       * md5.buffer('The quick brown fox jumps over the lazy dog');
       */

      /**
       * @method base64
       * @memberof md5
       * @description Output hash as base64 string
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {String} base64 string
       * @example
       * md5.base64('The quick brown fox jumps over the lazy dog');
       */


      var createOutputMethod = function createOutputMethod(outputType) {
        return function (message) {
          return new Md5(true).update(message)[outputType]();
        };
      };
      /**
       * @method create
       * @memberof md5
       * @description Create Md5 object
       * @returns {Md5} Md5 object.
       * @example
       * var hash = md5.create();
       */

      /**
       * @method update
       * @memberof md5
       * @description Create and update Md5 object
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {Md5} Md5 object.
       * @example
       * var hash = md5.update('The quick brown fox jumps over the lazy dog');
       * // equal to
       * var hash = md5.create();
       * hash.update('The quick brown fox jumps over the lazy dog');
       */


      var createMethod = function createMethod() {
        var method = createOutputMethod('hex');

        if (NODE_JS) {
          method = nodeWrap(method);
        }

        method.create = function () {
          return new Md5();
        };

        method.update = function (message) {
          return method.create().update(message);
        };

        for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
          var type = OUTPUT_TYPES[i];
          method[type] = createOutputMethod(type);
        }

        return method;
      };

      var nodeWrap = function nodeWrap(method) {
        var crypto = eval("require('crypto')");
        var Buffer = eval("require('buffer').Buffer");

        var nodeMethod = function nodeMethod(message) {
          if (typeof message === 'string') {
            return crypto.createHash('md5').update(message, 'utf8').digest('hex');
          } else {
            if (message === null || message === undefined) {
              throw ERROR;
            } else if (message.constructor === ArrayBuffer) {
              message = new Uint8Array(message);
            }
          }

          if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) {
            return crypto.createHash('md5').update(new Buffer(message)).digest('hex');
          } else {
            return method(message);
          }
        };

        return nodeMethod;
      };
      /**
       * Md5 class
       * @class Md5
       * @description This is internal class.
       * @see {@link md5.create}
       */


      function Md5(sharedMemory) {
        if (sharedMemory) {
          blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
          this.blocks = blocks;
          this.buffer8 = buffer8;
        } else {
          if (ARRAY_BUFFER) {
            var buffer = new ArrayBuffer(68);
            this.buffer8 = new Uint8Array(buffer);
            this.blocks = new Uint32Array(buffer);
          } else {
            this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          }
        }

        this.h0 = this.h1 = this.h2 = this.h3 = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
      }
      /**
       * @method update
       * @memberof Md5
       * @instance
       * @description Update hash
       * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
       * @returns {Md5} Md5 object.
       * @see {@link md5.update}
       */


      Md5.prototype.update = function (message) {
        if (this.finalized) {
          return;
        }

        var notString,
            type = typeof message;

        if (type !== 'string') {
          if (type === 'object') {
            if (message === null) {
              throw ERROR;
            } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
              message = new Uint8Array(message);
            } else if (!Array.isArray(message)) {
              if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
                throw ERROR;
              }
            }
          } else {
            throw ERROR;
          }

          notString = true;
        }

        var code,
            index = 0,
            i,
            length = message.length,
            blocks = this.blocks;
        var buffer8 = this.buffer8;

        while (index < length) {
          if (this.hashed) {
            this.hashed = false;
            blocks[0] = blocks[16];
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
          }

          if (notString) {
            if (ARRAY_BUFFER) {
              for (i = this.start; index < length && i < 64; ++index) {
                buffer8[i++] = message[index];
              }
            } else {
              for (i = this.start; index < length && i < 64; ++index) {
                blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
              }
            }
          } else {
            if (ARRAY_BUFFER) {
              for (i = this.start; index < length && i < 64; ++index) {
                code = message.charCodeAt(index);

                if (code < 0x80) {
                  buffer8[i++] = code;
                } else if (code < 0x800) {
                  buffer8[i++] = 0xc0 | code >> 6;
                  buffer8[i++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                  buffer8[i++] = 0xe0 | code >> 12;
                  buffer8[i++] = 0x80 | code >> 6 & 0x3f;
                  buffer8[i++] = 0x80 | code & 0x3f;
                } else {
                  code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                  buffer8[i++] = 0xf0 | code >> 18;
                  buffer8[i++] = 0x80 | code >> 12 & 0x3f;
                  buffer8[i++] = 0x80 | code >> 6 & 0x3f;
                  buffer8[i++] = 0x80 | code & 0x3f;
                }
              }
            } else {
              for (i = this.start; index < length && i < 64; ++index) {
                code = message.charCodeAt(index);

                if (code < 0x80) {
                  blocks[i >> 2] |= code << SHIFT[i++ & 3];
                } else if (code < 0x800) {
                  blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                  blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                  code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                  blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
              }
            }
          }

          this.lastByteIndex = i;
          this.bytes += i - this.start;

          if (i >= 64) {
            this.start = i - 64;
            this.hash();
            this.hashed = true;
          } else {
            this.start = i;
          }
        }

        if (this.bytes > 4294967295) {
          this.hBytes += this.bytes / 4294967296 << 0;
          this.bytes = this.bytes % 4294967296;
        }

        return this;
      };

      Md5.prototype.finalize = function () {
        if (this.finalized) {
          return;
        }

        this.finalized = true;
        var blocks = this.blocks,
            i = this.lastByteIndex;
        blocks[i >> 2] |= EXTRA[i & 3];

        if (i >= 56) {
          if (!this.hashed) {
            this.hash();
          }

          blocks[0] = blocks[16];
          blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }

        blocks[14] = this.bytes << 3;
        blocks[15] = this.hBytes << 3 | this.bytes >>> 29;
        this.hash();
      };

      Md5.prototype.hash = function () {
        var a,
            b,
            c,
            d,
            bc,
            da,
            blocks = this.blocks;

        if (this.first) {
          a = blocks[0] - 680876937;
          a = (a << 7 | a >>> 25) - 271733879 << 0;
          d = (-1732584194 ^ a & 2004318071) + blocks[1] - 117830708;
          d = (d << 12 | d >>> 20) + a << 0;
          c = (-271733879 ^ d & (a ^ -271733879)) + blocks[2] - 1126478375;
          c = (c << 17 | c >>> 15) + d << 0;
          b = (a ^ c & (d ^ a)) + blocks[3] - 1316259209;
          b = (b << 22 | b >>> 10) + c << 0;
        } else {
          a = this.h0;
          b = this.h1;
          c = this.h2;
          d = this.h3;
          a += (d ^ b & (c ^ d)) + blocks[0] - 680876936;
          a = (a << 7 | a >>> 25) + b << 0;
          d += (c ^ a & (b ^ c)) + blocks[1] - 389564586;
          d = (d << 12 | d >>> 20) + a << 0;
          c += (b ^ d & (a ^ b)) + blocks[2] + 606105819;
          c = (c << 17 | c >>> 15) + d << 0;
          b += (a ^ c & (d ^ a)) + blocks[3] - 1044525330;
          b = (b << 22 | b >>> 10) + c << 0;
        }

        a += (d ^ b & (c ^ d)) + blocks[4] - 176418897;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[5] + 1200080426;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[6] - 1473231341;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[7] - 45705983;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (d ^ b & (c ^ d)) + blocks[8] + 1770035416;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[9] - 1958414417;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[10] - 42063;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[11] - 1990404162;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (d ^ b & (c ^ d)) + blocks[12] + 1804603682;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[13] - 40341101;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[14] - 1502002290;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[15] + 1236535329;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[1] - 165796510;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[6] - 1069501632;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[11] + 643717713;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[0] - 373897302;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[5] - 701558691;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[10] + 38016083;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[15] - 660478335;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[4] - 405537848;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[9] + 568446438;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[14] - 1019803690;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[3] - 187363961;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[8] + 1163531501;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[13] - 1444681467;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[2] - 51403784;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[7] + 1735328473;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[12] - 1926607734;
        b = (b << 20 | b >>> 12) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[5] - 378558;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[8] - 2022574463;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[11] + 1839030562;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[14] - 35309556;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[1] - 1530992060;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[4] + 1272893353;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[7] - 155497632;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[10] - 1094730640;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[13] + 681279174;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[0] - 358537222;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[3] - 722521979;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[6] + 76029189;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[9] - 640364487;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[12] - 421815835;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[15] + 530742520;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[2] - 995338651;
        b = (b << 23 | b >>> 9) + c << 0;
        a += (c ^ (b | ~d)) + blocks[0] - 198630844;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[7] + 1126891415;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[14] - 1416354905;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[5] - 57434055;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[12] + 1700485571;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[3] - 1894986606;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[10] - 1051523;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[1] - 2054922799;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[8] + 1873313359;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[15] - 30611744;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[6] - 1560198380;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[13] + 1309151649;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[4] - 145523070;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[11] - 1120210379;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[2] + 718787259;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[9] - 343485551;
        b = (b << 21 | b >>> 11) + c << 0;

        if (this.first) {
          this.h0 = a + 1732584193 << 0;
          this.h1 = b - 271733879 << 0;
          this.h2 = c - 1732584194 << 0;
          this.h3 = d + 271733878 << 0;
          this.first = false;
        } else {
          this.h0 = this.h0 + a << 0;
          this.h1 = this.h1 + b << 0;
          this.h2 = this.h2 + c << 0;
          this.h3 = this.h3 + d << 0;
        }
      };
      /**
       * @method hex
       * @memberof Md5
       * @instance
       * @description Output hash as hex string
       * @returns {String} Hex string
       * @see {@link md5.hex}
       * @example
       * hash.hex();
       */


      Md5.prototype.hex = function () {
        this.finalize();
        var h0 = this.h0,
            h1 = this.h1,
            h2 = this.h2,
            h3 = this.h3;
        return HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F];
      };
      /**
       * @method toString
       * @memberof Md5
       * @instance
       * @description Output hash as hex string
       * @returns {String} Hex string
       * @see {@link md5.hex}
       * @example
       * hash.toString();
       */


      Md5.prototype.toString = Md5.prototype.hex;
      /**
       * @method digest
       * @memberof Md5
       * @instance
       * @description Output hash as bytes array
       * @returns {Array} Bytes array
       * @see {@link md5.digest}
       * @example
       * hash.digest();
       */

      Md5.prototype.digest = function () {
        this.finalize();
        var h0 = this.h0,
            h1 = this.h1,
            h2 = this.h2,
            h3 = this.h3;
        return [h0 & 0xFF, h0 >> 8 & 0xFF, h0 >> 16 & 0xFF, h0 >> 24 & 0xFF, h1 & 0xFF, h1 >> 8 & 0xFF, h1 >> 16 & 0xFF, h1 >> 24 & 0xFF, h2 & 0xFF, h2 >> 8 & 0xFF, h2 >> 16 & 0xFF, h2 >> 24 & 0xFF, h3 & 0xFF, h3 >> 8 & 0xFF, h3 >> 16 & 0xFF, h3 >> 24 & 0xFF];
      };
      /**
       * @method array
       * @memberof Md5
       * @instance
       * @description Output hash as bytes array
       * @returns {Array} Bytes array
       * @see {@link md5.array}
       * @example
       * hash.array();
       */


      Md5.prototype.array = Md5.prototype.digest;
      /**
       * @method arrayBuffer
       * @memberof Md5
       * @instance
       * @description Output hash as ArrayBuffer
       * @returns {ArrayBuffer} ArrayBuffer
       * @see {@link md5.arrayBuffer}
       * @example
       * hash.arrayBuffer();
       */

      Md5.prototype.arrayBuffer = function () {
        this.finalize();
        var buffer = new ArrayBuffer(16);
        var blocks = new Uint32Array(buffer);
        blocks[0] = this.h0;
        blocks[1] = this.h1;
        blocks[2] = this.h2;
        blocks[3] = this.h3;
        return buffer;
      };
      /**
       * @method buffer
       * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
       * @memberof Md5
       * @instance
       * @description Output hash as ArrayBuffer
       * @returns {ArrayBuffer} ArrayBuffer
       * @see {@link md5.buffer}
       * @example
       * hash.buffer();
       */


      Md5.prototype.buffer = Md5.prototype.arrayBuffer;
      /**
       * @method base64
       * @memberof Md5
       * @instance
       * @description Output hash as base64 string
       * @returns {String} base64 string
       * @see {@link md5.base64}
       * @example
       * hash.base64();
       */

      Md5.prototype.base64 = function () {
        var v1,
            v2,
            v3,
            base64Str = '',
            bytes = this.array();

        for (var i = 0; i < 15;) {
          v1 = bytes[i++];
          v2 = bytes[i++];
          v3 = bytes[i++];
          base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] + BASE64_ENCODE_CHAR[(v1 << 4 | v2 >>> 4) & 63] + BASE64_ENCODE_CHAR[(v2 << 2 | v3 >>> 6) & 63] + BASE64_ENCODE_CHAR[v3 & 63];
        }

        v1 = bytes[i];
        base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] + BASE64_ENCODE_CHAR[v1 << 4 & 63] + '==';
        return base64Str;
      };

      var exports = createMethod();

      if (COMMON_JS) {
        module.exports = exports;
      } else {
        /**
         * @method md5
         * @description Md5 hash function, export to global in browsers.
         * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
         * @returns {String} md5 hashes
         * @example
         * md5(''); // d41d8cd98f00b204e9800998ecf8427e
         * md5('The quick brown fox jumps over the lazy dog'); // 9e107d9d372bb6826bd81d3542a419d6
         * md5('The quick brown fox jumps over the lazy dog.'); // e4d909c290d0fb1ca068ffaddf22cbd0
         *
         * // It also supports UTF-8 encoding
         * md5('中文'); // a7bac2239fcdcb3a067903d8077c4a07
         *
         * // It also supports byte `Array`, `Uint8Array`, `ArrayBuffer`
         * md5([]); // d41d8cd98f00b204e9800998ecf8427e
         * md5(new Uint8Array([])); // d41d8cd98f00b204e9800998ecf8427e
         */
        root.md5 = exports;
      }
    })();
  });
  var main_min = createCommonjsModule(function (module, exports) {
    !function (t, r) {
      module.exports = r();
    }(commonjsGlobal, function () {
      var t = {
        str2Json: function str2Json(t) {
          var r = {};
          if ("[object String]" === Object.prototype.toString.call(t)) try {
            r = JSON.parse(t);
          } catch (t) {
            r = {};
          }
          return r;
        },
        json2Str: function json2Str(t) {
          var r = t;
          if ("string" != typeof t) try {
            r = JSON.stringify(t);
          } catch (t) {
            r = "";
          }
          return r;
        },
        _extend: function _extend(t, r) {
          if (r) for (var o in t) {
            r.hasOwnProperty(o) || (r[o] = t[o]);
          }
          return r;
        },
        formatURL: {
          browser: "",
          url: ""
        },
        formatSong: {
          filename: "",
          filesize: "",
          hash: "",
          bitrate: "",
          extname: "",
          duration: "",
          mvhash: "",
          m4afilesize: "",
          "320hash": "",
          "320filesize": "",
          sqhash: "",
          sqfilesize: 0,
          feetype: 0,
          isfirst: 0
        },
        formatMV: {
          filename: "",
          singername: "",
          hash: "",
          imgurl: ""
        },
        formatShare: {
          shareName: "",
          topicName: "",
          hash: "",
          listID: "",
          type: "",
          suid: "",
          slid: "",
          imgUrl: "",
          filename: "",
          duration: "",
          shareData: {
            linkUrl: "",
            picUrl: "",
            content: "",
            title: ""
          }
        },
        cbNum: 0,
        isIOS: !!navigator.userAgent.match(/KGBrowser/gi),
        isKugouAndroid: !!navigator.userAgent.match(/kugouandroid/gi),
        isAndroid: "undefined" != typeof external && void 0 !== external.superCall,
        loadUrl: function loadUrl(t) {
          var r = document.createElement("iframe");
          r.setAttribute("src", t), r.setAttribute("style", "display:none;"), r.setAttribute("height", "0px"), r.setAttribute("width", "0px"), r.setAttribute("frameborder", "0"), document.body.appendChild(r), r.parentNode.removeChild(r), r = null;
        },
        callCmd: function callCmd(r) {
          var o = t;

          if (o.isKugouAndroid) {
            var n = {},
                e = "";

            if (r.cmd && (n.cmd = r.cmd), r.jsonStr && (n.jsonStr = r.jsonStr), r.callback && (e = "kgandroidmobilecall" + ++o.cbNum + Math.random().toString().substr(2, 9), n.callback = e, window[e] = function (t, n) {
              void 0 !== t && ("[object String]" === Object.prototype.toString.call(t) ? (t = "#" === n ? decodeURIComponent(t) : decodeURIComponent(decodeURIComponent(t)), r.callback(o.str2Json(t))) : r.callback(t));
            }), r.AndroidCallback) {
              var i = o.str2Json(r.jsonStr);
              i.AndroidCallback = e, r.jsonStr = o.json2Str(i), r.jsonStr && (n.jsonStr = r.jsonStr);
            }

            var a = encodeURIComponent(JSON.stringify(n)),
                l = "kugoujsbridge://start.kugou_jsbridge/?".concat(a);
            o.loadUrl(l);
          } else if (o.isAndroid) {
            var c = "",
                s = "";

            if (r.jsonStr) {
              if (r.callback && "" !== r.callback && !0 === r.AndroidCallback) {
                s = "kgmobilecall" + ++o.cbNum + Math.random().toString().substr(2, 9), window[s] = function (t, n) {
                  void 0 !== t && ("[object String]" === Object.prototype.toString.call(t) ? (t = "#" === n ? decodeURIComponent(t) : decodeURIComponent(decodeURIComponent(t)), r.callback(o.str2Json(t))) : r.callback(t));
                };
                var d = o.str2Json(r.jsonStr);
                d.AndroidCallback = s, r.jsonStr = o.json2Str(d);
              }

              try {
                c = external.superCall(r.cmd, r.jsonStr);
              } catch (t) {}
            } else try {
              c = external.superCall(r.cmd);
            } catch (t) {}

            r.callback && "" !== r.callback && "AndroidCallback" != c && (c = o.str2Json(c), r.callback(c));
          } else {
            var u = "",
                m = "";
            r.callback && (m = "kgmobilecall" + ++o.cbNum + Math.random().toString().substr(2, 9), window[m] = function (t) {
              void 0 !== t && r.callback && ("[object String]" === Object.prototype.toString.call(t) ? r.callback(o.str2Json(t)) : r.callback(t));
            }), m && "" != m && r.jsonStr && (u = 'kugouurl://start.music/?{"cmd":' + r.cmd + ', "jsonStr":' + r.jsonStr + ', "callback":"' + m + '"}'), m && "" != m && !r.jsonStr && (u = 'kugouurl://start.music/?{"cmd":' + r.cmd + ', "callback":"' + m + '"}'), "" == m && r.jsonStr && (u = 'kugouurl://start.music/?{"cmd":' + r.cmd + ', "jsonStr":' + r.jsonStr + "}"), "" != m || r.jsonStr || (u = 'kugouurl://start.music/?{"cmd":' + r.cmd + "}"), o.loadUrl(u);
          }
        },
        formartData: function formartData(r, o) {
          r && 123 == r && o && (o = t._extend(t.formatURL, o)), r && 123 == r && o && (o = t._extend(t.formatURL, o));
        }
      };
      return {
        isIOS: t.isIOS,
        isKugouAndroid: t.isKugouAndroid,
        isAndroid: t.isAndroid,
        isInClient: function isInClient() {
          return !(!t.isAndroid && !t.isKugouAndroid) || !!t.isIOS;
        },
        mobileCall: function mobileCall(r, o, n) {
          var e = "";
          if (o && (e = t.json2Str(o)), !r) return console.error("请输入命令号！"), !1;
          var i = {};
          r && (i.cmd = r), "" != e && (i.jsonStr = e), n && (i.callback = n), r && 186 == r && n && (i.AndroidCallback = !0), t.callCmd(i);
        },
        KgWebMobileCall: function KgWebMobileCall(t, r) {
          if (t) try {
            var o = t.split(".");
            o.reduce(function (n, e) {
              if (n[e]) {
                if (e === o[o.length - 1]) {
                  var i = n[e];
                  return "function" == typeof i ? (n[e] = function (t) {
                    i && i(t), r && r(t);
                  }, n[e]) : (console.error("请检查，当前环境变量已注册了对象：" + t + "，且该对象不是方法"), null);
                }

                return n[e];
              }

              return e === o[o.length - 1] ? n[e] = function (t) {
                r && r(t);
              } : n[e] = new Object(), n[e];
            }, window);
          } catch (t) {}
        }
      };
    });
  });
  var main_min$1 = createCommonjsModule(function (module, exports) {
    !function (e, n) {
      module.exports = n();
    }(commonjsGlobal, function () {
      var c = {
        Cookie: {
          write: function write(e, n, t, i, r, o) {
            /^\w*$/.test(e) || alert("cookie格式不正确"), /; /.test(n) && alert("cookie格式不正确");
            e = e + "=" + n;
            t && ((n = new Date()).setTime(n.getTime() + 1e3 * t), e += "; expires=" + n.toGMTString()), i && (e += "; path=" + i), r && (e += "; domain=" + r), o && (e += "; secure"), document.cookie = e;
          },
          rewriteKey: function rewriteKey(e, n, t, i, r, o, a) {
            var l,
                c = n;
            t && (l = this.read(e), n = new RegExp("\\b" + n + "=([^&]*)\\b", "g"), c = l.replace(n, function (e, n) {
              return e.replace(n, t);
            })), /^\d+(s|m|h|d)$/i.test(i) ? (/^\d+s$/i.test(i) && this.setSec(e, c, i.replace(/s$/i, ""), r, o, a), /^\d+m$/i.test(i) && this.setMin(e, c, i.replace(/m$/i, ""), r, o, a), /^\d+h$/i.test(i) && this.setHour(e, c, i.replace(/h$/i, ""), r, o, a), /^\d+d$/i.test(i) && this.setDay(e, c, i.replace(/d$/i, ""), r, o, a)) : this.write(e, c, i, r, o, a);
          },
          setDay: function setDay(e, n, t, i, r, o) {
            this.write(e, n, 24 * t * 60 * 60, i, r, o);
          },
          setHour: function setHour(e, n, t, i, r, o) {
            this.write(e, n, 60 * t * 60, i, r, o);
          },
          setMin: function setMin(e, n, t, i, r, o) {
            this.write(e, n, 60 * t, i, r, o);
          },
          setSec: function setSec(e, n, t, i, r, o) {
            this.write(e, n, t, i, r, o);
          },
          read: function read(e, n, t) {
            for (var i = "", r = document.cookie.split("; "), o = 0; o < r.length; o++) {
              var a = r[o].match(/^(\w+)=(.+)$/);

              if (a && 1 < a.length && a[1] == e) {
                i = a[2];
                break;
              }
            }

            return "" == i ? null : n ? (t ? JSON : new c.Param()).parse(i)[n] : i;
          },
          remove: function remove(e, n, t) {
            e += "=";
            n && (e += "; path=" + n), t && (e += ";domain=" + t), e += "; expires=Fri, 02-Jan-1970 00:00:00 GMT", document.cookie = e;
          }
        },
        Md5: function Md5(e) {
          var n,
              r = 8;

          function l(e, n, t, i, r, o) {
            return g((o = g(g(n, e), g(i, o))) << r | o >>> 32 - r, t);
          }

          function d(e, n, t, i, r, o, a) {
            return l(n & t | ~n & i, e, n, r, o, a);
          }

          function m(e, n, t, i, r, o, a) {
            return l(n & i | t & ~i, e, n, r, o, a);
          }

          function p(e, n, t, i, r, o, a) {
            return l(n ^ t ^ i, e, n, r, o, a);
          }

          function f(e, n, t, i, r, o, a) {
            return l(t ^ (n | ~i), e, n, r, o, a);
          }

          function g(e, n) {
            var t = (65535 & e) + (65535 & n);
            return (e >> 16) + (n >> 16) + (t >> 16) << 16 | 65535 & t;
          }

          return e = e ? function (e) {
            for (var n = "0123456789abcdef", t = "", i = 0; i < 4 * e.length; i++) {
              t += n.charAt(e[i >> 2] >> i % 4 * 8 + 4 & 15) + n.charAt(e[i >> 2] >> i % 4 * 8 & 15);
            }

            return t;
          }(function (e, n) {
            e[n >> 5] |= 128 << n % 32, e[14 + (n + 64 >>> 9 << 4)] = n;

            for (var t = 1732584193, i = -271733879, r = -1732584194, o = 271733878, a = 0; a < e.length; a += 16) {
              var l = t,
                  c = i,
                  s = r,
                  u = o;
              t = d(t, i, r, o, e[a + 0], 7, -680876936), o = d(o, t, i, r, e[a + 1], 12, -389564586), r = d(r, o, t, i, e[a + 2], 17, 606105819), i = d(i, r, o, t, e[a + 3], 22, -1044525330), t = d(t, i, r, o, e[a + 4], 7, -176418897), o = d(o, t, i, r, e[a + 5], 12, 1200080426), r = d(r, o, t, i, e[a + 6], 17, -1473231341), i = d(i, r, o, t, e[a + 7], 22, -45705983), t = d(t, i, r, o, e[a + 8], 7, 1770035416), o = d(o, t, i, r, e[a + 9], 12, -1958414417), r = d(r, o, t, i, e[a + 10], 17, -42063), i = d(i, r, o, t, e[a + 11], 22, -1990404162), t = d(t, i, r, o, e[a + 12], 7, 1804603682), o = d(o, t, i, r, e[a + 13], 12, -40341101), r = d(r, o, t, i, e[a + 14], 17, -1502002290), i = d(i, r, o, t, e[a + 15], 22, 1236535329), t = m(t, i, r, o, e[a + 1], 5, -165796510), o = m(o, t, i, r, e[a + 6], 9, -1069501632), r = m(r, o, t, i, e[a + 11], 14, 643717713), i = m(i, r, o, t, e[a + 0], 20, -373897302), t = m(t, i, r, o, e[a + 5], 5, -701558691), o = m(o, t, i, r, e[a + 10], 9, 38016083), r = m(r, o, t, i, e[a + 15], 14, -660478335), i = m(i, r, o, t, e[a + 4], 20, -405537848), t = m(t, i, r, o, e[a + 9], 5, 568446438), o = m(o, t, i, r, e[a + 14], 9, -1019803690), r = m(r, o, t, i, e[a + 3], 14, -187363961), i = m(i, r, o, t, e[a + 8], 20, 1163531501), t = m(t, i, r, o, e[a + 13], 5, -1444681467), o = m(o, t, i, r, e[a + 2], 9, -51403784), r = m(r, o, t, i, e[a + 7], 14, 1735328473), i = m(i, r, o, t, e[a + 12], 20, -1926607734), t = p(t, i, r, o, e[a + 5], 4, -378558), o = p(o, t, i, r, e[a + 8], 11, -2022574463), r = p(r, o, t, i, e[a + 11], 16, 1839030562), i = p(i, r, o, t, e[a + 14], 23, -35309556), t = p(t, i, r, o, e[a + 1], 4, -1530992060), o = p(o, t, i, r, e[a + 4], 11, 1272893353), r = p(r, o, t, i, e[a + 7], 16, -155497632), i = p(i, r, o, t, e[a + 10], 23, -1094730640), t = p(t, i, r, o, e[a + 13], 4, 681279174), o = p(o, t, i, r, e[a + 0], 11, -358537222), r = p(r, o, t, i, e[a + 3], 16, -722521979), i = p(i, r, o, t, e[a + 6], 23, 76029189), t = p(t, i, r, o, e[a + 9], 4, -640364487), o = p(o, t, i, r, e[a + 12], 11, -421815835), r = p(r, o, t, i, e[a + 15], 16, 530742520), i = p(i, r, o, t, e[a + 2], 23, -995338651), t = f(t, i, r, o, e[a + 0], 6, -198630844), o = f(o, t, i, r, e[a + 7], 10, 1126891415), r = f(r, o, t, i, e[a + 14], 15, -1416354905), i = f(i, r, o, t, e[a + 5], 21, -57434055), t = f(t, i, r, o, e[a + 12], 6, 1700485571), o = f(o, t, i, r, e[a + 3], 10, -1894986606), r = f(r, o, t, i, e[a + 10], 15, -1051523), i = f(i, r, o, t, e[a + 1], 21, -2054922799), t = f(t, i, r, o, e[a + 8], 6, 1873313359), o = f(o, t, i, r, e[a + 15], 10, -30611744), r = f(r, o, t, i, e[a + 6], 15, -1560198380), i = f(i, r, o, t, e[a + 13], 21, 1309151649), t = f(t, i, r, o, e[a + 4], 6, -145523070), o = f(o, t, i, r, e[a + 11], 10, -1120210379), r = f(r, o, t, i, e[a + 2], 15, 718787259), i = f(i, r, o, t, e[a + 9], 21, -343485551), t = g(t, l), i = g(i, c), r = g(r, s), o = g(o, u);
            }

            return Array(t, i, r, o);
          }(function (e) {
            for (var n = Array(), t = (1 << r) - 1, i = 0; i < e.length * r; i += r) {
              n[i >> 5] |= (e.charCodeAt(i / r) & t) << i % 32;
            }

            return n;
          }(n = e), n.length * r)) : "";
        },
        Param: function Param() {
          var t = [],
              o = {};
          this.parse = function (e) {
            for (var n = e.split("&"), t = 0, i = n.length; t < i; t++) {
              var r = n[t].split("=");
              o[r[0]] = r[1];
            }

            return o;
          }, this.toString = function (e) {
            return t.join(e = e || "&");
          }, this.add = function (e, n) {
            return t.push(e + "=" + n), this;
          };
        },
        IsEmpty: function IsEmpty(e) {
          return void 0 === e || null == e || "" == e;
        },
        Guid: function Guid() {
          function e() {
            return (65536 * (1 + Math.random()) | 0).toString(16).substring(1);
          }

          return e() + e() + "-" + e() + "-" + e() + "-" + e() + "-" + e() + e() + e();
        },
        getKgMid: function getKgMid() {
          var e = c.Cookie.read("kg_mid");

          if (navigator.cookieEnabled) {
            if (c.IsEmpty(e)) {
              var n = c.Guid(),
                  e = c.Md5(n);

              try {
                c.Cookie.write("kg_mid", c.Md5(n), 864e6, "/", "kugou.com");
              } catch (e) {}
            }
          } else {
            var t = navigator.userAgent,
                i = function () {
              var e = navigator.plugins,
                  n = "";

              if (0 < e.length) {
                for (var t = [], i = 0, r = e.length; i < r; i++) {
                  var o = e[i].name;
                  t.push(o);
                }

                n = t.toString();
              }

              return n;
            }(),
                r = screen.width + "x" + screen.height,
                o = screen.colorDepth || "",
                a = screen.pixelDepth || "",
                n = function () {
              var e = ["canvas"];

              try {
                var n,
                    t = document.createElement("canvas");
                t.getContext && t.getContext("2d") && (t.width = 200, t.height = 200, t.style.display = "inline", (n = t.getContext("2d")).rect(0, 0, 10, 10), n.rect(2, 2, 6, 6), e.push("canvas winding:" + (!1 === n.isPointInPath(5, 5, "evenodd") ? "yes" : "no")), n.textBaseline = "alphabetic", n.fillStyle = "#f60", n.fillRect(125, 1, 62, 20), n.fillStyle = "#069", n.font = "14px 'Arial'", n.fillText("hello kugou", 2, 15), n.fillStyle = "rgba(102, 204, 0, 0.2)", n.font = "18pt Arial", n.fillText("hello kugou", 4, 45), n.globalCompositeOperation = "multiply", n.fillStyle = "rgb(255,0,255)", n.beginPath(), n.arc(50, 50, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = "rgb(0,255,255)", n.beginPath(), n.arc(100, 50, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = "rgb(255,255,0)", n.beginPath(), n.arc(75, 100, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = "rgb(255,0,255)", n.arc(75, 75, 75, 0, 2 * Math.PI, !0), n.arc(75, 75, 25, 0, 2 * Math.PI, !0), n.fill("evenodd"), t.toDataURL && e.push("canvas fp:" + t.toDataURL()));
              } catch (e) {}

              return c.Md5(e.toString());
            }();

            e = c.Md5(t + i + r + o + a + n);
          }

          return e;
        },
        isiOS: function isiOS() {
          var e = navigator.userAgent,
              n = e.match(/(iPad).*OS\s([\d_]+)/),
              t = e.match(/(iPod)(.*OS\s([\d_]+))?/),
              e = !n && e.match(/(iPhone\sOS)\s([\d_]+)/);
          return !!(n || t || e);
        },
        GetPCClientUserInfo: function GetPCClientUserInfo(n) {
          var t = "KGSupercall_GetUserInfo" + Math.random().toString().substr(2, 9),
              e = null;

          window[t] = function (e) {
            n && n(e), window[t] = null;
          };

          try {
            e = external.SuperCall(504, '{"callback":"' + t + '"}');
          } catch (e) {}

          if (void 0 === e || !n) return n ? void 0 : (window[t] = null, e);
          window[t](e);
        },
        getPCMID_APPID: function getPCMID_APPID(n) {
          try {
            var t;
            "function" == typeof n ? (t = "KGSupercall_getMID_APPID" + Math.random().toString().substr(2, 9), top.window[t] = function (e) {
              e && (top.window[t] = null, n && n(e));
            }, external.SuperCall(822, '{"callback":"' + t + '"}')) : external.SuperCall(822, n);
          } catch (e) {}
        },
        isPCClient: function isPCClient() {
          var e = !1;
          return e = window.external && window.external.SuperCall && "function" == typeof window.external.SuperCall && window.external.GetVersion && 0 < window.external.GetVersion() ? !0 : e;
        }
      };
      var e,
          s = (function (e) {
        function n(n, e) {
          var t,
              i = Object.keys(n);
          return Object.getOwnPropertySymbols && (t = Object.getOwnPropertySymbols(n), e && (t = t.filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          })), i.push.apply(i, t)), i;
        }

        function o(i) {
          for (var e = 1; e < arguments.length; e++) {
            var r = null != arguments[e] ? arguments[e] : {};
            e % 2 ? n(Object(r), !0).forEach(function (e) {
              var n,
                  t = i;
              e = r[n = e], n in t ? Object.defineProperty(t, n, {
                value: e,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }) : t[n] = e;
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (e) {
              Object.defineProperty(i, e, Object.getOwnPropertyDescriptor(r, e));
            });
          }

          return i;
        }

        var c;
        e.exports = (c = {
          str2Json: function str2Json(e) {
            var n = {};
            if ("[object String]" === Object.prototype.toString.call(e)) try {
              n = JSON.parse(e);
            } catch (e) {
              n = {};
            }
            return n;
          },
          json2Str: function json2Str(e) {
            var n = e;
            if ("string" != typeof e) try {
              n = JSON.stringify(e);
            } catch (e) {
              n = "";
            }
            return n;
          },
          cbNum: 0,
          isIOS: !!navigator.userAgent.match(/KGBrowser/gi),
          isKugouAndroid: !!navigator.userAgent.match(/kugouandroid/gi),
          isAndroid: "undefined" != typeof external && void 0 !== external.superCall,
          isDKAPP: !!navigator.userAgent.match(/kgshortvideo/gi),
          isKGRing: !!navigator.userAgent.match(/KGRingCode/gi),
          isFXAPP: !!navigator.userAgent.match(/Fanxing/gi),
          isFXQianBanAPP: !!navigator.userAgent.match(/QianBan/gi),
          isIframePage: window.parent && window.parent != window,
          isInClient: function isInClient() {
            return !!(c.isAndroid || c.isKugouAndroid || c.isIOS || c.isFXAPP || c.isFXQianBanAPP || c.isDKAPP || c.isKGRing);
          },
          loadUrl: function loadUrl(e) {
            var n = document.createElement("iframe");
            n.setAttribute("src", e), n.setAttribute("style", "display:none;"), n.setAttribute("height", "0px"), n.setAttribute("width", "0px"), n.setAttribute("frameborder", "0"), document.body.appendChild(n), n.parentNode.removeChild(n);
          },
          mobileCallInIframe: function mobileCallInIframe(e, n, t) {
            e = {
              type: "KgMobileCall",
              cmd: e
            }, n && (e.dataJson = n), t && (e.cbName = t), e.source = "personal", window.parent.postMessage(e, "*");
          },
          receiveMessage: function receiveMessage(e) {
            var n = e.data;
            "KgMobileCall" == n.type && window[n.cbName] && (n.dataJson ? window[n.cbName](n.dataJson) : window[n.cbName](), window[n.cbName] = null), "KgWebMobileCall" == n.type && (e = n.funcName.split("."), KgWebMobileCall[e[1]] && (n.dataJson ? KgWebMobileCall[e[1]](n.dataJson) : KgWebMobileCall[e[1]]()));
          },
          callCmd: function callCmd(t) {
            var e,
                n,
                i = c,
                r = "kugouurl",
                r = i.isKugouAndroid ? "kugoujsbridge" : i.isAndroid ? "superCall" : i.isFXAPP || i.isFXQianBanAPP ? "fanxing2" : "kugouurl";

            if ("kugoujsbridge" == (r = t && t.useMobileCallType ? t.useMobileCallType : r)) {
              var o = {},
                  a = "";
              t.cmd && (o.cmd = t.cmd), t.jsonStr && (o.jsonStr = t.jsonStr), t.callback && (i.cbNum++, a = "kgandroidmobilecall_" + (t.cmd || 0) + "_" + i.cbNum + Math.random().toString().substr(2, 9), o.callback = a, window[a] = function (e, n) {
                if (void 0 !== e) if ("[object String]" === Object.prototype.toString.call(e)) {
                  try {
                    e = "#" === n ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e));
                  } catch (e) {
                    console.error("decodeURIComponent", e);
                  }

                  t.callback(i.str2Json(e));
                } else t.callback(e);
              }), t.AndroidCallback && ((l = i.str2Json(t.jsonStr)).AndroidCallback = a, t.jsonStr = i.json2Str(l), t.jsonStr && (o.jsonStr = t.jsonStr));
              var l = encodeURIComponent(JSON.stringify(o)),
                  l = "kugoujsbridge://start.kugou_jsbridge/?".concat(l);
              i.isIframePage ? i.mobileCallInIframe(o.cmd, o.jsonStr, a) : i.loadUrl(l);
            } else if ("superCall" == r) {
              if (a = o = "", t.jsonStr) {
                if (t.callback && "" !== t.callback && !0 === t.AndroidCallback && (i.cbNum++, a = "kgmobilecall_" + (t.cmd || 0) + "_" + i.cbNum + Math.random().toString().substr(2, 9), window[a] = function (e, n) {
                  if (void 0 !== e) if ("[object String]" === Object.prototype.toString.call(e)) {
                    try {
                      e = "#" === n ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e));
                    } catch (e) {
                      console.error("decodeURIComponent", decodeURIComponent);
                    }

                    t.callback(i.str2Json(e));
                  } else t.callback(e);
                }, (l = i.str2Json(t.jsonStr)).AndroidCallback = a, t.jsonStr = i.json2Str(l)), i.isIframePage && t.AndroidCallback) i.mobileCallInIframe(t.cmd, t.jsonStr, a);else try {
                  o = external.superCall(t.cmd, t.jsonStr);
                } catch (e) {}
              } else try {
                o = external.superCall(t.cmd);
              } catch (e) {}
              t.AndroidCallback || t.callback && "" !== t.callback && "AndroidCallback" != o && (o = i.str2Json(o), t.callback(o));
            } else "fanxing2" == r ? (r = n = "", n = t.callback ? (i.cbNum++, r = "kgmobilecall_" + (t.cmd || 0) + "_" + i.cbNum + Math.random().toString().substr(2, 9), window[r] = function (e) {
              void 0 !== e && t.callback && ("[object String]" === Object.prototype.toString.call(e) ? t.callback(i.str2Json(e)) : t.callback(e));
            }, t.jsonStr ? 'fanxing2://send.message/?{"cmd":' + t.cmd + ', "jsonStr":' + t.jsonStr + ', "callback":"' + r + '"}' : 'fanxing2://send.message/?{"cmd":' + t.cmd + ', "callback":"' + r + '"}') : t.jsonStr ? 'fanxing2://send.message/?{"cmd":' + t.cmd + ', "jsonStr":' + t.jsonStr + "}" : 'fanxing2://send.message/?{"cmd":' + t.cmd + "}", i.isIframePage ? i.mobileCallInIframe(t.cmd, t.jsonStr, r) : navigator.userAgent.match(/(Android);?[\s\/]+([\d.]+)?/) ? external && external.callFanxing ? (e = {
              cmd: t.cmd,
              jsonStr: t.jsonStr || "",
              callback: r
            }, external.callFanxing(JSON.stringify(e))) : window.prompt(n) : i.loadUrl(n)) : (n = e = "", t.callback && (i.cbNum++, n = "kgmobilecall_" + (t.cmd || 0) + "_" + i.cbNum + Math.random().toString().substr(2, 9), window[n] = function (e) {
              void 0 !== e && t.callback && ("[object String]" === Object.prototype.toString.call(e) ? t.callback(i.str2Json(e)) : t.callback(e));
            }), n && "" != n && t.jsonStr && (e = 'kugouurl://start.music/?{"cmd":' + t.cmd + ', "jsonStr":' + t.jsonStr + ', "callback":"' + n + '"}'), n && "" != n && !t.jsonStr && (e = 'kugouurl://start.music/?{"cmd":' + t.cmd + ', "callback":"' + n + '"}'), "" == n && t.jsonStr && (e = 'kugouurl://start.music/?{"cmd":' + t.cmd + ', "jsonStr":' + t.jsonStr + "}"), "" != n || t.jsonStr || (e = 'kugouurl://start.music/?{"cmd":' + t.cmd + "}"), i.isIframePage ? i.mobileCallInIframe(t.cmd, t.jsonStr, n) : i.loadUrl(e));
          },
          sendCommandOrder: function sendCommandOrder(e) {
            var n = window.location.origin,
                t = ~n.indexOf("voo.kugou.com") || ~n.indexOf("http://10.16.4.19:8099") || ~n.indexOf("http://test.kugou.com:8099"),
                i = window._VO_ACT_ID_;
            t && i && e && (e = {
              actId: i,
              cmd: e
            }, e = c.json2Str({
              url: "".concat(n, "/public/addCommandOrder"),
              method: "post",
              param: c.json2Str(e),
              header: {
                "Content-Type": "application/json"
              },
              AndroidCallback: !0
            }), c.callCmd({
              cmd: 186,
              jsonStr: e,
              callback: function callback(e) {
                ~window.location.href.indexOf("debugCmd") && console.log(e);
              }
            }));
          }
        }, e = {
          isIOS: c.isIOS,
          isKugouAndroid: c.isKugouAndroid,
          isAndroid: c.isAndroid,
          isFXAPP: c.isFXAPP,
          isFXQianBanAPP: c.isFXQianBanAPP,
          isDKAPP: c.isDKAPP,
          isKGRing: c.isKGRing,
          isInClient: function isInClient() {
            return c.isInClient();
          },
          mobileCall: function mobileCall(e, n, t, i) {
            var r = "";
            if (n && (r = c.json2Str(n)), !e) return console.error("请输入命令号！"), !1;

            if (n = {}, e && (n.cmd = e), "" != r && (n.jsonStr = r), t && (n.callback = t), n = o(o({}, n), i), !e || 186 != e && 225 != e || t && (n.AndroidCallback = !0), n.AndroidCallback && !n.jsonStr && (n.jsonStr = {}), c.isInClient()) {
              c.callCmd(n);

              try {
                c.sendCommandOrder(e);
              } catch (e) {}
            }
          },
          KgWebMobileCall: function KgWebMobileCall(i, r) {
            if (i) try {
              c.isIframePage && window.parent.postMessage({
                type: "KgWebMobileCall",
                funcName: i
              }, "*");
              var o = i.split(".");
              o.reduce(function (e, n) {
                if (e[n]) {
                  if (n !== o[o.length - 1]) return e[n];
                  var t = e[n];
                  return "function" == typeof t ? (e[n] = function () {
                    t && t.apply(void 0, arguments), r && r.apply(void 0, arguments);
                  }, e[n]) : (console.error("请检查，当前环境变量已注册了对象：" + i + "，且该对象不是方法"), null);
                }

                return n === o[o.length - 1] ? e[n] = function () {
                  r && r.apply(void 0, arguments);
                } : e[n] = new Object(), e[n];
              }, window);
            } catch (e) {}
          }
        }, window.addEventListener("message", function (e) {
          c.receiveMessage(e);
        }, !1), e);
      }(e = {
        exports: {}
      }), e.exports);
      return function (e, n, t) {
        var i = {
          useMobileCallType: ""
        };
        t && s.isKugouAndroid && !s.isIOS && (i = {
          useMobileCallType: "superCall"
        });
        var r = 101,
            o = 122,
            a = 124,
            l = {
          appid: null,
          mid: null,
          uuid: null,
          plat: null,
          dfid: null,
          userid: null,
          userpic: null,
          userNickName: null,
          token: null,
          clientver: null
        };
        s.isInClient() && !s.isFXAPP ? s.mobileCall(r, null, function (e) {
          1 == e.status ? (l.userid = e.kugouID, l.token = e.token, l.userpic = e.photo, l.userNickName = e.nickName, l.isVIP = e.isVIP || e.isVip) : (l.userid = null, l.token = null, l.userpic = null, l.userNickName = null), l.appid = e.appid, s.mobileCall(o, null, function (e) {
            l.clientver = e.version, l.platform = e.platform || "", s.mobileCall(a, null, function (e) {
              l.mid = e.mid_v2 || e.mid, l.dfid = e.dfid || "-", l.uuid = e.uuid || l.mid, l.osVersion = e.osVersion || "", s.isIOS ? l.plat = 2 : l.plat = 1, n && n(l);
            }, i);
          }, i);
        }, i) : s.isInClient() && s.isFXAPP ? s.mobileCall(625, null, function (e) {
          e = JSON.parse(e.jsonStr);
          l.clientver = e.version, l.mid = e.mid, l.uuid = e.uuid || l.mid, l.dfid = e.dfid || "-", l.appid = e.appId, c.isiOS() ? l.plat = 2 : l.plat = 1, s.mobileCall(410, null, function (e) {
            1 == JSON.parse(e.jsonStr).status ? s.mobileCall(411, {}, function (e) {
              e = JSON.parse(e.jsonStr).jsonStr ? JSON.parse(e.jsonStr).jsonStr : JSON.parse(e.jsonStr);
              l.userid = e.kugouId, l.token = e.token, l.pic = e.userLogo, l.nickName = e.nickName, n && n(l);
            }) : (l.userid = null, l.token = null, l.userpic = null, l.userNickName = null, n && n(l));
          });
        }) : c.isPCClient() ? c.GetPCClientUserInfo(function (e) {
          try {
            e = JSON.parse(e);
          } catch (e) {}

          l.userid = e.kugouid || "", l.token = e.token || "", l.userNickName = e.nickname || "", l.userpic = e.usrPic || "", l.userNickName = l.userNickName ? unescape(l.userNickName) : "", c.getPCMID_APPID(function (e) {
            try {
              e = JSON.parse(e);
            } catch (e) {}

            l.appid = e.appid || 1001, l.dfid = e.dfid || "-", l.mid = e.mid || "", l.uuid = e.uuid || l.mid, l.plat = 3, l.clientver = window.external.GetVersion(), n && n(l);
          });
        }) : (t = c.Cookie.read("a_id"), r = c.Cookie.read("KuGoo", "a_id"), l.appid = e || null, l.mid = c.getKgMid(), l.uuid = l.mid, l.plat = 4, l.dfid = c.Cookie.read("kg_dfid") || "-", l.userid = c.Cookie.read("KuGoo", "KugooID"), l.userpic = c.Cookie.read("KuGoo", "Pic"), l.userNickName = c.Cookie.read("KuGoo", "NickName"), l.token = c.Cookie.read("KuGoo", "t"), l.appid = l.appid || r || t || null, r && r != l.appid && l.appid && (l.userid = null, l.token = null, l.userpic = null, l.userNickName = null), l.clientver = 1e3, l.userNickName = l.userNickName ? unescape(l.userNickName) : "", n && n(l));
      };
    });
  });
  var main_min$2 = createCommonjsModule(function (module, exports) {
    !function (e, t) {
      module.exports = t();
    }(commonjsGlobal, function () {
      function c(e) {
        return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      function t(t, e) {
        var n = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }

        return n;
      }

      function m(o) {
        for (var e = 1; e < arguments.length; e++) {
          var i = null != arguments[e] ? arguments[e] : {};
          e % 2 ? t(i, !0).forEach(function (e) {
            var t, n, r;
            t = o, r = i[n = e], n in t ? Object.defineProperty(t, n, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[n] = r;
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(i)) : t(i).forEach(function (e) {
            Object.defineProperty(o, e, Object.getOwnPropertyDescriptor(i, e));
          });
        }

        return o;
      }

      function i(e, t) {
        if (null != e) if ("object" !== c(e) && (e = [e]), a(e)) for (var n = 0, r = e.length; n < r; n++) {
          t.call(null, e[n], n, e);
        } else for (var o in e) {
          Object.prototype.hasOwnProperty.call(e, o) && t.call(null, e[o], o, e);
        }
      }

      function a(e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      }

      function n(e) {
        return null == e || "" === e;
      }

      var l = {
        forEach: i,
        isArray: a,
        trim: function trim(e) {
          return n(e) ? "" : e.replace(/^\s*/, "").replace(/\s*$/, "");
        },
        isEmpty: n,
        deepMerge: function n() {
          var r = {};

          function e(e, t) {
            "object" === c(r[t]) && "object" === c(e) && !e instanceof Array ? r[t] = n(r[t], e) : "object" === c(e) && !e instanceof Array ? r[t] = n({}, e) : r[t] = e;
          }

          for (var t = 0, o = arguments.length; t < o; t++) {
            i(arguments[t], e);
          }

          return r;
        },
        extend: function extend(n, e, r) {
          return i(e, function (e, t) {
            n[t] = r && "function" == typeof e ? e.bind(r) : e;
          }), n;
        },
        objToParamStr: function objToParamStr(t) {
          var n = "";
          return Object.keys(t).forEach(function (e) {
            n += "" == n ? e + "=" + t[e] : "&" + e + "=" + t[e];
          }), n;
        },
        toast: function toast(e) {
          var t = document.createElement("div"),
              n = document.createElement("div");
          e.duration = e.duration ? e.duration : 3e3, t.style.cssText = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; z-index:100000; text-align:center;", t.id = "toastCover", n.style.cssText = "background:rgba(0, 0, 0, .6); border-radius: 0.10rem; color: #fff; min-width: 40%; max-width: 80%; padding: 0.20rem; font-size: 0.28rem;", n.id = "toastText", n.innerText = e.message, t.appendChild(n), document.body.appendChild(t), setTimeout(function () {
            document.querySelector("#toastCover") && t.parentNode.removeChild(t);
          }, e.duration);
        }
      };

      function r() {
        this.toDoFunctionChain = [];
      }

      function u(e, t, n, r, o) {
        e = e || "";
        var i = new Error(e);
        return i.config = t, i.request = r, i.response = o, l.isEmpty(n) || (i.code = n), i;
      }

      function o(a) {
        return new Promise(function (n, r) {
          var e = a.params,
              t = a.data,
              o = new XMLHttpRequest();
          o = window.XMLHttpRequest ? new XMLHttpRequest() : new window.ActiveXObject();
          var i = a.baseURL + a.url;
          a.paramsSerializer ? i = i + "?" + a.paramsSerializer(e) : l.isEmpty(a.params) || (i = i + "?" + l.objToParamStr(e));
          o.open(a.method, i, a.async), l.isEmpty(a.headers) || l.forEach(a.headers, function (e) {
            o.setRequestHeader(Object.keys(e)[0], e[Object.keys(e)[0]]);
          }), o.timeout = a.timeout, l.isEmpty(a.withCredentials) || (o.withCredentials = a.withCredentials), o.onreadystatechange = function () {
            if (o && 4 === o.readyState && (0 !== o.status || o.responseURL && 0 === o.responseURL.indexOf("file:"))) {
              var e = "getAllResponseHeaders" in o ? function (e) {
                var t = "";
                t = l.isArray(e) ? e : e.split(/\r\n/);

                for (var n = {}, r = 0; r < t.length; r++) {
                  var o = t[r].indexOf(":"),
                      i = l.trim(t[r].substr(0, o)).toLowerCase(),
                      a = l.trim(t[r].substr(o + 1));
                  i && (n[i] = "set-cookie" === i ? (n[i] ? n[i] : []).concat([a]) : n[i] ? n[i] + ", " + a : a);
                }

                return n;
              }(o.getAllResponseHeaders()) : null,
                  t = {
                data: a.responseType && "text" !== a.responseType ? o.response : o.responseText,
                headers: e,
                config: a,
                status: o.status,
                request: o
              };
              o && 200 === o.status ? n(t) : (r(u("Request Error", a, o.status || -1, o, t)), o = null);
            }
          }, o.onabort = function () {
            o && (r(u("Request aborted", a, "ECONNABORTED", o)), o = null);
          }, o.onerror = function () {
            r(u("Network Error", a, "ECONNERROR", o)), o = null;
          }, o.ontimeout = function () {
            r(u("request timeout", a, "ECONNTIMEOUT", o)), o = null;
          }, a && a.isFormData ? o.send(t) : l.isEmpty(t) ? o.send() : "string" == typeof t ? o.send(t) : o.send(JSON.stringify(t));
        });
      }

      r.prototype.on = function (e, t) {
        return this.toDoFunctionChain.push({
          fulfilled: e,
          rejected: t
        }), this.toDoFunctionChain.length - 1;
      }, r.prototype.off = function (e) {
        this.toDoFunctionChain[e] && (this.toDoFunctionChain[e] = null);
      }, r.prototype.forEach = function (t) {
        l.forEach(this.toDoFunctionChain, function (e) {
          null !== e && t(e);
        });
      };
      var b = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof commonjsGlobal ? commonjsGlobal : "undefined" != typeof self ? self : {};

      function e(e, t) {
        return e(t = {
          exports: {}
        }, t.exports), t.exports;
      }

      var h = e(function (e, t) {
        function n(t, e) {
          var n,
              r = Object.keys(t);
          return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n)), r;
        }

        function i(r) {
          for (var e = 1; e < arguments.length; e++) {
            var o = null != arguments[e] ? arguments[e] : {};
            e % 2 ? n(Object(o), !0).forEach(function (e) {
              var t, n;
              t = r, e = o[n = e], n in t ? Object.defineProperty(t, n, {
                value: e,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }) : t[n] = e;
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o)) : n(Object(o)).forEach(function (e) {
              Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(o, e));
            });
          }

          return r;
        }

        var c, r;
        e.exports = (c = {
          str2Json: function str2Json(e) {
            var t = {};
            if ("[object String]" === Object.prototype.toString.call(e)) try {
              t = JSON.parse(e);
            } catch (e) {
              t = {};
            }
            return t;
          },
          json2Str: function json2Str(e) {
            var t = e;
            if ("string" != typeof e) try {
              t = JSON.stringify(e);
            } catch (e) {
              t = "";
            }
            return t;
          },
          cbNum: 0,
          isIOS: !!navigator.userAgent.match(/KGBrowser/gi),
          isKugouAndroid: !!navigator.userAgent.match(/kugouandroid/gi),
          isAndroid: "undefined" != typeof external && void 0 !== external.superCall,
          isFXAPP: !!navigator.userAgent.match(/Fanxing/gi),
          isFXQianBanAPP: !!navigator.userAgent.match(/QianBan/gi),
          isIframePage: window.parent && window.parent != window,
          loadUrl: function loadUrl(e) {
            var t = document.createElement("iframe");
            t.setAttribute("src", e), t.setAttribute("style", "display:none;"), t.setAttribute("height", "0px"), t.setAttribute("width", "0px"), t.setAttribute("frameborder", "0"), document.body.appendChild(t), t.parentNode.removeChild(t), t = null;
          },
          mobileCallInIframe: function mobileCallInIframe(e, t, n) {
            e = {
              type: "KgMobileCall",
              cmd: e
            }, t && (e.dataJson = t), n && (e.cbName = n), e.source = "personal", window.parent.postMessage(e, "*");
          },
          receiveMessage: function receiveMessage(e) {
            var t = e.data;
            "KgMobileCall" == t.type && window[t.cbName] && (t.dataJson ? window[t.cbName](t.dataJson) : window[t.cbName](), window[t.cbName] = null), "KgWebMobileCall" == t.type && (e = t.funcName.split("."), KgWebMobileCall[e[1]] && (t.dataJson ? KgWebMobileCall[e[1]](t.dataJson) : KgWebMobileCall[e[1]]()));
          },
          callCmd: function callCmd(n) {
            var e,
                t,
                r = c;

            if (r.isKugouAndroid) {
              var o = {},
                  i = "";
              n.cmd && (o.cmd = n.cmd), n.jsonStr && (o.jsonStr = n.jsonStr), n.callback && (r.cbNum++, i = "kgandroidmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), o.callback = i, window[i] = function (e, t) {
                if (void 0 !== e) if ("[object String]" === Object.prototype.toString.call(e)) {
                  try {
                    e = "#" === t ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e));
                  } catch (e) {
                    console.error("decodeURIComponent", e);
                  }

                  n.callback(r.str2Json(e));
                } else n.callback(e);
              }), n.AndroidCallback && ((a = r.str2Json(n.jsonStr)).AndroidCallback = i, n.jsonStr = r.json2Str(a), n.jsonStr && (o.jsonStr = n.jsonStr));
              var a = encodeURIComponent(JSON.stringify(o));
              a = "kugoujsbridge://start.kugou_jsbridge/?".concat(a);
              r.isIframePage ? r.mobileCallInIframe(o.cmd, o.jsonStr, i) : r.loadUrl(a);
            } else if (r.isAndroid) {
              var s = "";
              i = "";
              if (n.jsonStr) {
                if (n.callback && "" !== n.callback && !0 === n.AndroidCallback && (r.cbNum++, i = "kgmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), window[i] = function (e, t) {
                  if (void 0 !== e) if ("[object String]" === Object.prototype.toString.call(e)) {
                    try {
                      e = "#" === t ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e));
                    } catch (e) {
                      console.error("decodeURIComponent", decodeURIComponent);
                    }

                    n.callback(r.str2Json(e));
                  } else n.callback(e);
                }, (a = r.str2Json(n.jsonStr)).AndroidCallback = i, n.jsonStr = r.json2Str(a)), r.isIframePage && n.AndroidCallback) r.mobileCallInIframe(n.cmd, n.jsonStr, i);else try {
                  s = external.superCall(n.cmd, n.jsonStr);
                } catch (e) {}
              } else try {
                s = external.superCall(n.cmd);
              } catch (e) {}
              n.AndroidCallback || n.callback && "" !== n.callback && "AndroidCallback" != s && (s = r.str2Json(s), n.callback(s));
            } else r.isFXAPP || r.isFXQianBanAPP ? (s = t = "", t = n.callback ? (r.cbNum++, s = "kgmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), window[s] = function (e) {
              void 0 !== e && n.callback && ("[object String]" === Object.prototype.toString.call(e) ? n.callback(r.str2Json(e)) : n.callback(e));
            }, n.jsonStr ? 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + ', "callback":"' + s + '"}' : 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "callback":"' + s + '"}') : n.jsonStr ? 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + "}" : 'fanxing2://send.message/?{"cmd":' + n.cmd + "}", r.isIframePage ? r.mobileCallInIframe(n.cmd, n.jsonStr, s) : navigator.userAgent.match(/(Android);?[\s\/]+([\d.]+)?/) ? external && external.callFanxing ? (e = {
              cmd: n.cmd,
              jsonStr: n.jsonStr || "",
              callback: s
            }, external.callFanxing(JSON.stringify(e))) : window.prompt(t) : r.loadUrl(t)) : (t = e = "", n.callback && (r.cbNum++, t = "kgmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), window[t] = function (e) {
              void 0 !== e && n.callback && ("[object String]" === Object.prototype.toString.call(e) ? n.callback(r.str2Json(e)) : n.callback(e));
            }), t && "" != t && n.jsonStr && (e = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + ', "callback":"' + t + '"}'), t && "" != t && !n.jsonStr && (e = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "callback":"' + t + '"}'), "" == t && n.jsonStr && (e = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + "}"), "" != t || n.jsonStr || (e = 'kugouurl://start.music/?{"cmd":' + n.cmd + "}"), r.isIframePage ? r.mobileCallInIframe(n.cmd, n.jsonStr, t) : r.loadUrl(e));
          }
        }, r = {
          isIOS: c.isIOS,
          isKugouAndroid: c.isKugouAndroid,
          isAndroid: c.isAndroid,
          isFXAPP: c.isFXAPP,
          isFXQianBanAPP: c.isFXQianBanAPP,
          isInClient: function isInClient() {
            return !!(c.isAndroid || c.isKugouAndroid || c.isIOS || c.isFXAPP || c.isFXQianBanAPP);
          },
          mobileCall: function mobileCall(e, t, n, r) {
            var o = "";
            if (t && (o = c.json2Str(t)), !e) return console.error("请输入命令号！"), !1;
            t = {}, e && (t.cmd = e), "" != o && (t.jsonStr = o), n && (t.callback = n), t = i(i({}, t), r), !e || 186 != e && 225 != e || n && (t.AndroidCallback = !0), t.AndroidCallback && !t.jsonStr && (t.jsonStr = {}), c.callCmd(t);
          },
          KgWebMobileCall: function KgWebMobileCall(r, o) {
            if (r) try {
              c.isIframePage && window.parent.postMessage({
                type: "KgWebMobileCall",
                funcName: r
              }, "*");
              var i = r.split(".");
              i.reduce(function (e, t) {
                if (e[t]) {
                  if (t !== i[i.length - 1]) return e[t];
                  var n = e[t];
                  return "function" == typeof n ? (e[t] = function () {
                    n && n.apply(void 0, arguments), o && o.apply(void 0, arguments);
                  }, e[t]) : (console.error("请检查，当前环境变量已注册了对象：" + r + "，且该对象不是方法"), null);
                }

                return t === i[i.length - 1] ? e[t] = function () {
                  o && o.apply(void 0, arguments);
                } : e[t] = new Object(), e[t];
              }, window);
            } catch (e) {}
          }
        }, window.addEventListener("message", function (e) {
          c.receiveMessage(e);
        }, !1), r);
      });

      function s(e) {
        return e.useMobileCall || e.requestMethod && "mobilecall" == e.requestMethod ? (s = e, new Promise(function (r, o) {
          var e = "",
              t = s.data ? s.data : "";
          s.paramsSerializer ? e = s.paramsSerializer(s.params) : l.isEmpty(s.params) || (e = l.objToParamStr(s.params));
          var n = s.baseURL + s.url;
          l.isEmpty(s.params) || (n = n + "?" + e);
          var i = {
            url: n,
            method: s.method,
            timeout: s.timeout
          };
          l.isEmpty(t) || "object" === c(i.param = t) && (i.param = JSON.stringify(t)), l.isEmpty(s.headers) || (i.header = {}, l.forEach(s.headers, function (e) {
            i.header[Object.keys(e)[0]] = e[Object.keys(e)[0]];
          })), h.mobileCall(186, i, function (e) {
            try {
              e = JSON.parse(e);
            } catch (e) {}

            if (s.isVipWebview && !e.hasOwnProperty("status")) return null;
            var t = {
              data: e.data,
              config: s,
              verify: e.verify || null,
              resHeaders: e.resHeaders || null,
              time: e.time || 0
            };

            if (e && 1 == e.status) {
              if (e && e.verify && 0 == e.verify.status && s.kgAntiBushErrFun) if ((h.isKugouAndroid || h.isAndroid) && e.resHeaders) {
                if (e.resHeaders["SSA-CODE"] || e.resHeaders["ssa-code"]) return s.kgAntiBushErrFun && s.kgAntiBushErrFun(), s.kgAntiBushErrorReject && o(u("client verify Error: 0", s, null, null, null)), null;
              } else if (e.resHeaders["SSA-CODE"] || e.resHeaders["ssa-code"]) return s.kgAntiBushErrFun && s.kgAntiBushErrFun(), s.kgAntiBushErrorReject && o(u("client verify Error: 0", s, null, null, null)), null;
              r(t);
            } else {
              if (e && e.errno && 30021 == e.errno && s.kgAntiBushErrFun) return s.kgAntiBushErrFun && s.kgAntiBushErrFun(), s.kgAntiBushErrorReject && o(u("client verify Error: 0", s, null, null, null)), null;
              var n = e.errMsg || "Request Error: " + e.errno;
              o(u(n, s, e.errno, null, t));
            }
          });
        }).then(function (e) {
          return e;
        }, function (e) {
          return Promise.reject(e);
        })) : e.requestMethod && "miniapp" == e.requestMethod ? (a = e, new Promise(function (n, t) {
          var e = "",
              r = a.data ? a.data : "";
          a.paramsSerializer ? e = a.paramsSerializer(a.params) : l.isEmpty(a.params) || (e = l.objToParamStr(a.params));
          var o = a.baseURL + a.url;
          l.isEmpty(a.params) || (o = o + "?" + e);
          var i = {
            url: o,
            method: a.method,
            timeout: a.timeout
          };
          l.isEmpty(r) || "object" === c(i.data = r) && (i.data = JSON.stringify(r)), l.isEmpty(a.headers) || (i.header = {}, l.forEach(a.headers, function (e) {
            i.header[Object.keys(e)[0]] = e[Object.keys(e)[0]];
          })), i.dataType = a.dataType || "json", i.success = function (e) {
            var t = {
              data: e.data,
              statusCode: e.statusCode,
              responseHeader: e.header,
              config: a
            };
            n(t);
          }, i.fail = function (e) {
            t(u(e.errMsg, a, e.errCode, null, null));
          }, window.MiniApp && window.MiniApp.request(i);
        }).then(function (e) {
          return e;
        }, function (e) {
          return Promise.reject(e);
        })) : o(e).then(function (e) {
          return e;
        }, function (e) {
          return Promise.reject(e);
        });
        var a, s;
      }

      function d(n) {
        return new Promise(function (e, t) {
          if (n && n.isAllowKGAntiBush) {
            if (n.kgAntiBushURL = n.kgAntiBushURL ? n.kgAntiBushURL : window.location.href, n.kgAntiBushAppid = n.kgAntiBushAppid ? n.kgAntiBushAppid : n.params.appid ? n.params.appid : "", n.kgAntiBushMid = n.kgAntiBushMid ? n.kgAntiBushMid : n.params.mid ? n.params.mid : "", n.kgAntiBushUserid = n.kgAntiBushUserid ? n.kgAntiBushUserid : n.params.userid ? n.params.userid : 0, l.isEmpty(n.kgAntiBushAppid)) return console.error("使用了 isAllowKGAntiBush=true，但是没有传 appid"), t(n), null;
            if (l.isEmpty(n.kgAntiBushMid)) return console.error("使用了 isAllowKGAntiBush=true，但是没有传 mid"), t(n), null;
            e(n);
          } else e(n);
        });
      }

      var f = {
        url: "",
        baseURL: "",
        retryURL: "",
        isGateway: !0,
        gatewayURL: "",
        retryList: [],
        retry: 1,
        timeout: 15e3,
        params: null,
        data: null,
        method: "get",
        async: !0,
        useMobileCall: !1,
        kgAntiBushUrl: window.location.href,
        isAllowKGAntiBush: !0,
        kgAntiBushURL: "",
        kgAntiBushAppid: "",
        kgAntiBushMid: "",
        kgAntiBushUserid: "",
        sign: "",
        signSalt: "",
        isAllowSign: !0,
        cdnApiParamsSerializer: function cdnApiParamsSerializer(t) {
          var n = "",
              e = [];

          for (var r in t) {
            e.push(r);
          }

          return e.sort(), e.forEach(function (e) {
            n += "" == n ? e + "=" + t[e] : "&" + e + "=" + t[e];
          }), n;
        }
      };

      function p(e) {
        this.requestConfig = e, this.interceptors = {
          request: new r(),
          response: new r()
        };
      }

      p.prototype.request = function (e) {
        e = function (e) {
          e = e || {};
          var t = {};

          if ((t = l.deepMerge(f, e)).headers = t.headers ? t.headers : [], t.url = l.trim(t.url), l.isEmpty(t.url) || 0 == t.url.indexOf("/") || (t.url = "/" + t.url), t.baseURL = l.trim(t.baseURL), l.isEmpty(t.baseURL) || "/" !== t.baseURL.charAt(t.baseURL.length - 1) || (t.baseURL = t.baseURL.substring(0, t.baseURL.length - 1)), t.retryURL = l.trim(t.retryURL), l.isEmpty(t.retryURL) && (t.retryURL = t.baseURL), l.isEmpty(t.retryURL) || "/" !== t.retryURL.charAt(t.retryURL.length - 1) || (t.retryURL = t.retryURL.substring(0, t.retryURL.length - 1)), t.isGateway = !0 === t.isGateway, t.isGateway && !t.isSetGatewayConfig) {
            t.gatewayURL = t.gatewayURL ? t.gatewayURL : t.baseURL;
            var n = t.gatewayURL.replace(/https:\/\/|http:\/\//gi, ""),
                r = new Array();
            l.forEach(t.headers, function (e) {
              "x-router" in e || r.push(e);
            }), t.headers = r;
            var o = n.replace(".kugou.com", "");
            t.retryList = ["https://gateway.kugou.com/".concat(o), "https://gatewayretry.kugou.com/".concat(o), "https://gateway3.kugou.com/".concat(o), "https://".concat(o, ".kugou.com"), t.retryURL], t.retryIndex = 0, t.baseURL = t.retryList[t.retryIndex], t.retry = t.retryList.length * t.retry, t.isSetGatewayConfig = !0;
          }

          return t.timeout = t.timeout ? t.timeout : 15e3, t.retry = t.retry, t.data = t.data ? t.data : "", "{}" !== JSON.stringify(t.data) || t.isFormData || (t.data = null), t.method = t.method ? t.method : "get", t.method = t.method.toLowerCase(), t.async = !0 === t.async, t.useMobileCall = !0 === t.useMobileCall, l.isEmpty(t.withCredentials) || (t.withCredentials = !0 === t.withCredentials), t.isAllowKGAntiBush = !0 === t.isAllowKGAntiBush, t && t.useMobileCall && (t.kgAntiBushErrFun = t.kgAntiBushErrFun || function () {
            l.toast({
              message: "操作过于频繁，请稍后再试",
              duration: "2000"
            });
          }), t && t.isCDN && (t.paramsSerializer = t.cdnApiParamsSerializer), t;
        }((this.requestConfig, e));

        var t = Promise.resolve(e),
            n = new Array();

        for (this.interceptors.request.forEach(function (e) {
          n.unshift(e.fulfilled, e.rejected);
        }), n.push(d, void 0), n.push(s, void 0), this.interceptors.response.forEach(function (e) {
          n.push(e.fulfilled, e.rejected);
        }); n.length;) {
          t = t.then(n.shift(), n.shift());
        }

        return t;
      };

      var g,
          y,
          v = e(function (e) {
        function d(e, t) {
          var n = (65535 & e) + (65535 & t);
          return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
        }

        function s(e, t, n, r, o, i) {
          return d((a = d(d(t, e), d(r, i))) << (s = o) | a >>> 32 - s, n);
          var a, s;
        }

        function f(e, t, n, r, o, i, a) {
          return s(t & n | ~t & r, e, t, o, i, a);
        }

        function p(e, t, n, r, o, i, a) {
          return s(t & r | n & ~r, e, t, o, i, a);
        }

        function g(e, t, n, r, o, i, a) {
          return s(t ^ n ^ r, e, t, o, i, a);
        }

        function m(e, t, n, r, o, i, a) {
          return s(n ^ (t | ~r), e, t, o, i, a);
        }

        function c(e, t) {
          var n, r, o, i, a;
          e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
          var s = 1732584193,
              c = -271733879,
              l = -1732584194,
              u = 271733878;

          for (n = 0; n < e.length; n += 16) {
            s = f(r = s, o = c, i = l, a = u, e[n], 7, -680876936), u = f(u, s, c, l, e[n + 1], 12, -389564586), l = f(l, u, s, c, e[n + 2], 17, 606105819), c = f(c, l, u, s, e[n + 3], 22, -1044525330), s = f(s, c, l, u, e[n + 4], 7, -176418897), u = f(u, s, c, l, e[n + 5], 12, 1200080426), l = f(l, u, s, c, e[n + 6], 17, -1473231341), c = f(c, l, u, s, e[n + 7], 22, -45705983), s = f(s, c, l, u, e[n + 8], 7, 1770035416), u = f(u, s, c, l, e[n + 9], 12, -1958414417), l = f(l, u, s, c, e[n + 10], 17, -42063), c = f(c, l, u, s, e[n + 11], 22, -1990404162), s = f(s, c, l, u, e[n + 12], 7, 1804603682), u = f(u, s, c, l, e[n + 13], 12, -40341101), l = f(l, u, s, c, e[n + 14], 17, -1502002290), s = p(s, c = f(c, l, u, s, e[n + 15], 22, 1236535329), l, u, e[n + 1], 5, -165796510), u = p(u, s, c, l, e[n + 6], 9, -1069501632), l = p(l, u, s, c, e[n + 11], 14, 643717713), c = p(c, l, u, s, e[n], 20, -373897302), s = p(s, c, l, u, e[n + 5], 5, -701558691), u = p(u, s, c, l, e[n + 10], 9, 38016083), l = p(l, u, s, c, e[n + 15], 14, -660478335), c = p(c, l, u, s, e[n + 4], 20, -405537848), s = p(s, c, l, u, e[n + 9], 5, 568446438), u = p(u, s, c, l, e[n + 14], 9, -1019803690), l = p(l, u, s, c, e[n + 3], 14, -187363961), c = p(c, l, u, s, e[n + 8], 20, 1163531501), s = p(s, c, l, u, e[n + 13], 5, -1444681467), u = p(u, s, c, l, e[n + 2], 9, -51403784), l = p(l, u, s, c, e[n + 7], 14, 1735328473), s = g(s, c = p(c, l, u, s, e[n + 12], 20, -1926607734), l, u, e[n + 5], 4, -378558), u = g(u, s, c, l, e[n + 8], 11, -2022574463), l = g(l, u, s, c, e[n + 11], 16, 1839030562), c = g(c, l, u, s, e[n + 14], 23, -35309556), s = g(s, c, l, u, e[n + 1], 4, -1530992060), u = g(u, s, c, l, e[n + 4], 11, 1272893353), l = g(l, u, s, c, e[n + 7], 16, -155497632), c = g(c, l, u, s, e[n + 10], 23, -1094730640), s = g(s, c, l, u, e[n + 13], 4, 681279174), u = g(u, s, c, l, e[n], 11, -358537222), l = g(l, u, s, c, e[n + 3], 16, -722521979), c = g(c, l, u, s, e[n + 6], 23, 76029189), s = g(s, c, l, u, e[n + 9], 4, -640364487), u = g(u, s, c, l, e[n + 12], 11, -421815835), l = g(l, u, s, c, e[n + 15], 16, 530742520), s = m(s, c = g(c, l, u, s, e[n + 2], 23, -995338651), l, u, e[n], 6, -198630844), u = m(u, s, c, l, e[n + 7], 10, 1126891415), l = m(l, u, s, c, e[n + 14], 15, -1416354905), c = m(c, l, u, s, e[n + 5], 21, -57434055), s = m(s, c, l, u, e[n + 12], 6, 1700485571), u = m(u, s, c, l, e[n + 3], 10, -1894986606), l = m(l, u, s, c, e[n + 10], 15, -1051523), c = m(c, l, u, s, e[n + 1], 21, -2054922799), s = m(s, c, l, u, e[n + 8], 6, 1873313359), u = m(u, s, c, l, e[n + 15], 10, -30611744), l = m(l, u, s, c, e[n + 6], 15, -1560198380), c = m(c, l, u, s, e[n + 13], 21, 1309151649), s = m(s, c, l, u, e[n + 4], 6, -145523070), u = m(u, s, c, l, e[n + 11], 10, -1120210379), l = m(l, u, s, c, e[n + 2], 15, 718787259), c = m(c, l, u, s, e[n + 9], 21, -343485551), s = d(s, r), c = d(c, o), l = d(l, i), u = d(u, a);
          }

          return [s, c, l, u];
        }

        function l(e) {
          var t,
              n = "",
              r = 32 * e.length;

          for (t = 0; t < r; t += 8) {
            n += String.fromCharCode(e[t >> 5] >>> t % 32 & 255);
          }

          return n;
        }

        function u(e) {
          var t,
              n = [];

          for (n[(e.length >> 2) - 1] = void 0, t = 0; t < n.length; t += 1) {
            n[t] = 0;
          }

          var r = 8 * e.length;

          for (t = 0; t < r; t += 8) {
            n[t >> 5] |= (255 & e.charCodeAt(t / 8)) << t % 32;
          }

          return n;
        }

        function r(e) {
          var t,
              n,
              r = "0123456789abcdef",
              o = "";

          for (n = 0; n < e.length; n += 1) {
            t = e.charCodeAt(n), o += r.charAt(t >>> 4 & 15) + r.charAt(15 & t);
          }

          return o;
        }

        function n(e) {
          return unescape(encodeURIComponent(e));
        }

        function o(e) {
          return l(c(u(t = n(e)), 8 * t.length));
          var t;
        }

        function i(e, t) {
          return function (e, t) {
            var n,
                r,
                o = u(e),
                i = [],
                a = [];

            for (i[15] = a[15] = void 0, 16 < o.length && (o = c(o, 8 * e.length)), n = 0; n < 16; n += 1) {
              i[n] = 909522486 ^ o[n], a[n] = 1549556828 ^ o[n];
            }

            return r = c(i.concat(u(t)), 512 + 8 * t.length), l(c(a.concat(r), 640));
          }(n(e), n(t));
        }

        function t(e, t, n) {
          return t ? n ? i(t, e) : r(i(t, e)) : n ? o(e) : r(o(e));
        }

        var a;
        a = b, e.exports ? e.exports = t : a.md5 = t;
      }),
          k = e(function (e, t) {
        var c, i;
        e.exports = (c = {
          Cookie: {
            write: function write(e, t, n, r, o, i) {
              /^\w*$/.test(e) || alert("cookie格式不正确"), /; /.test(t) && alert("cookie格式不正确");
              var a = e + "=" + t;

              if (n) {
                var s = new Date();
                s.setTime(s.getTime() + 1e3 * n), a += "; expires=" + s.toGMTString();
              }

              r && (a += "; path=" + r), o && (a += "; domain=" + o), i && (a += "; secure"), document.cookie = a;
            },
            rewriteKey: function rewriteKey(e, t, n, r, o, i, a) {
              var s = t;

              if (n) {
                var c = this.read(e),
                    l = new RegExp("\\b" + t + "=([^&]*)\\b", "g");
                s = c.replace(l, function (e, t) {
                  return e.replace(t, n);
                });
              }

              /^\d+(s|m|h|d)$/i.test(r) ? (/^\d+s$/i.test(r) && this.setSec(e, s, r.replace(/s$/i, ""), o, i, a), /^\d+m$/i.test(r) && this.setMin(e, s, r.replace(/m$/i, ""), o, i, a), /^\d+h$/i.test(r) && this.setHour(e, s, r.replace(/h$/i, ""), o, i, a), /^\d+d$/i.test(r) && this.setDay(e, s, r.replace(/d$/i, ""), o, i, a)) : this.write(e, s, r, o, i, a);
            },
            setDay: function setDay(e, t, n, r, o, i) {
              this.write(e, t, 24 * n * 60 * 60, r, o, i);
            },
            setHour: function setHour(e, t, n, r, o, i) {
              this.write(e, t, 60 * n * 60, r, o, i);
            },
            setMin: function setMin(e, t, n, r, o, i) {
              this.write(e, t, 60 * n, r, o, i);
            },
            setSec: function setSec(e, t, n, r, o, i) {
              this.write(e, t, n, r, o, i);
            },
            read: function read(e, t, n) {
              for (var r = "", o = document.cookie.split("; "), i = 0; i < o.length; i++) {
                var a = o[i].match(/^(\w+)=(.+)$/);

                if (a && 1 < a.length && a[1] == e) {
                  r = a[2];
                  break;
                }
              }

              return "" == r ? null : t ? n ? JSON.parse(r)[t] : new c.Param().parse(r)[t] : r;
            },
            remove: function remove(e, t, n) {
              var r = e + "=";
              t && (r += "; path=" + t), n && (r += ";domain=" + n), r += "; expires=Fri, 02-Jan-1970 00:00:00 GMT", document.cookie = r;
            }
          },
          Md5: function Md5(e) {
            function s(e, t, n, r, o, i) {
              return m((a = m(m(t, e), m(r, i))) << (s = o) | a >>> 32 - s, n);
              var a, s;
            }

            function d(e, t, n, r, o, i, a) {
              return s(t & n | ~t & r, e, t, o, i, a);
            }

            function f(e, t, n, r, o, i, a) {
              return s(t & r | n & ~r, e, t, o, i, a);
            }

            function p(e, t, n, r, o, i, a) {
              return s(t ^ n ^ r, e, t, o, i, a);
            }

            function g(e, t, n, r, o, i, a) {
              return s(n ^ (t | ~r), e, t, o, i, a);
            }

            function m(e, t) {
              var n = (65535 & e) + (65535 & t);
              return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
            }

            var t;
            return e ? function (e) {
              for (var t = "", n = 0; n < 4 * e.length; n++) {
                t += "0123456789abcdef".charAt(e[n >> 2] >> n % 4 * 8 + 4 & 15) + "0123456789abcdef".charAt(e[n >> 2] >> n % 4 * 8 & 15);
              }

              return t;
            }(function (e, t) {
              e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;

              for (var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, a = 0; a < e.length; a += 16) {
                var s = n,
                    c = r,
                    l = o,
                    u = i;
                r = g(r = g(r = g(r = g(r = p(r = p(r = p(r = p(r = f(r = f(r = f(r = f(r = d(r = d(r = d(r = d(r, o = d(o, i = d(i, n = d(n, r, o, i, e[a + 0], 7, -680876936), r, o, e[a + 1], 12, -389564586), n, r, e[a + 2], 17, 606105819), i, n, e[a + 3], 22, -1044525330), o = d(o, i = d(i, n = d(n, r, o, i, e[a + 4], 7, -176418897), r, o, e[a + 5], 12, 1200080426), n, r, e[a + 6], 17, -1473231341), i, n, e[a + 7], 22, -45705983), o = d(o, i = d(i, n = d(n, r, o, i, e[a + 8], 7, 1770035416), r, o, e[a + 9], 12, -1958414417), n, r, e[a + 10], 17, -42063), i, n, e[a + 11], 22, -1990404162), o = d(o, i = d(i, n = d(n, r, o, i, e[a + 12], 7, 1804603682), r, o, e[a + 13], 12, -40341101), n, r, e[a + 14], 17, -1502002290), i, n, e[a + 15], 22, 1236535329), o = f(o, i = f(i, n = f(n, r, o, i, e[a + 1], 5, -165796510), r, o, e[a + 6], 9, -1069501632), n, r, e[a + 11], 14, 643717713), i, n, e[a + 0], 20, -373897302), o = f(o, i = f(i, n = f(n, r, o, i, e[a + 5], 5, -701558691), r, o, e[a + 10], 9, 38016083), n, r, e[a + 15], 14, -660478335), i, n, e[a + 4], 20, -405537848), o = f(o, i = f(i, n = f(n, r, o, i, e[a + 9], 5, 568446438), r, o, e[a + 14], 9, -1019803690), n, r, e[a + 3], 14, -187363961), i, n, e[a + 8], 20, 1163531501), o = f(o, i = f(i, n = f(n, r, o, i, e[a + 13], 5, -1444681467), r, o, e[a + 2], 9, -51403784), n, r, e[a + 7], 14, 1735328473), i, n, e[a + 12], 20, -1926607734), o = p(o, i = p(i, n = p(n, r, o, i, e[a + 5], 4, -378558), r, o, e[a + 8], 11, -2022574463), n, r, e[a + 11], 16, 1839030562), i, n, e[a + 14], 23, -35309556), o = p(o, i = p(i, n = p(n, r, o, i, e[a + 1], 4, -1530992060), r, o, e[a + 4], 11, 1272893353), n, r, e[a + 7], 16, -155497632), i, n, e[a + 10], 23, -1094730640), o = p(o, i = p(i, n = p(n, r, o, i, e[a + 13], 4, 681279174), r, o, e[a + 0], 11, -358537222), n, r, e[a + 3], 16, -722521979), i, n, e[a + 6], 23, 76029189), o = p(o, i = p(i, n = p(n, r, o, i, e[a + 9], 4, -640364487), r, o, e[a + 12], 11, -421815835), n, r, e[a + 15], 16, 530742520), i, n, e[a + 2], 23, -995338651), o = g(o, i = g(i, n = g(n, r, o, i, e[a + 0], 6, -198630844), r, o, e[a + 7], 10, 1126891415), n, r, e[a + 14], 15, -1416354905), i, n, e[a + 5], 21, -57434055), o = g(o, i = g(i, n = g(n, r, o, i, e[a + 12], 6, 1700485571), r, o, e[a + 3], 10, -1894986606), n, r, e[a + 10], 15, -1051523), i, n, e[a + 1], 21, -2054922799), o = g(o, i = g(i, n = g(n, r, o, i, e[a + 8], 6, 1873313359), r, o, e[a + 15], 10, -30611744), n, r, e[a + 6], 15, -1560198380), i, n, e[a + 13], 21, 1309151649), o = g(o, i = g(i, n = g(n, r, o, i, e[a + 4], 6, -145523070), r, o, e[a + 11], 10, -1120210379), n, r, e[a + 2], 15, 718787259), i, n, e[a + 9], 21, -343485551), n = m(n, s), r = m(r, c), o = m(o, l), i = m(i, u);
              }

              return Array(n, r, o, i);
            }(function (e) {
              for (var t = Array(), n = 0; n < 8 * e.length; n += 8) {
                t[n >> 5] |= (255 & e.charCodeAt(n / 8)) << n % 32;
              }

              return t;
            }(t = e), 8 * t.length)) : "";
          },
          Param: function Param() {
            var r = [],
                i = {};
            this.parse = function (e) {
              for (var t = e.split("&"), n = 0, r = t.length; n < r; n++) {
                var o = t[n].split("=");
                i[o[0]] = o[1];
              }

              return i;
            }, this.toString = function (e) {
              return e = e || "&", r.join(e);
            }, this.add = function (e, t) {
              var n = e + "=" + t;
              return r.push(n), this;
            };
          },
          IsEmpty: function IsEmpty(e) {
            return void 0 === e || null == e || "" == e;
          },
          Guid: function Guid() {
            function e() {
              return (65536 * (1 + Math.random()) | 0).toString(16).substring(1);
            }

            return e() + e() + "-" + e() + "-" + e() + "-" + e() + "-" + e() + e() + e();
          },
          getKgMid: function getKgMid() {
            var e = c.Cookie.read("kg_mid");

            if (navigator.cookieEnabled) {
              if (c.IsEmpty(e)) {
                var t = c.Guid();
                e = c.Md5(t);

                try {
                  c.Cookie.write("kg_mid", c.Md5(t), 864e6, "/", "kugou.com");
                } catch (e) {}
              }
            } else {
              var n = navigator.userAgent,
                  r = function () {
                var e = navigator.plugins,
                    t = "";

                if (0 < e.length) {
                  for (var n = [], r = 0, o = e.length; r < o; r++) {
                    var i = e[r].name;
                    n.push(i);
                  }

                  t = n.toString();
                }

                return t;
              }(),
                  o = screen.width + "x" + screen.height,
                  i = screen.colorDepth ? screen.colorDepth : "",
                  a = screen.pixelDepth ? screen.pixelDepth : "",
                  s = function () {
                var e = ["canvas"];

                try {
                  var t = document.createElement("canvas");

                  if (t.getContext && t.getContext("2d")) {
                    t.width = 200, t.height = 200, t.style.display = "inline";
                    var n = t.getContext("2d");
                    n.rect(0, 0, 10, 10), n.rect(2, 2, 6, 6), e.push("canvas winding:" + (!1 === n.isPointInPath(5, 5, "evenodd") ? "yes" : "no")), n.textBaseline = "alphabetic", n.fillStyle = "#f60", n.fillRect(125, 1, 62, 20), n.fillStyle = "#069", n.font = "14px 'Arial'", n.fillText("hello kugou", 2, 15), n.fillStyle = "rgba(102, 204, 0, 0.2)", n.font = "18pt Arial", n.fillText("hello kugou", 4, 45), n.globalCompositeOperation = "multiply", n.fillStyle = "rgb(255,0,255)", n.beginPath(), n.arc(50, 50, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = "rgb(0,255,255)", n.beginPath(), n.arc(100, 50, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = "rgb(255,255,0)", n.beginPath(), n.arc(75, 100, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = "rgb(255,0,255)", n.arc(75, 75, 75, 0, 2 * Math.PI, !0), n.arc(75, 75, 25, 0, 2 * Math.PI, !0), n.fill("evenodd"), t.toDataURL && e.push("canvas fp:" + t.toDataURL());
                  }
                } catch (e) {}

                return c.Md5(e.toString());
              }();

              e = c.Md5(n + r + o + i + a + s);
            }

            return e;
          },
          isiOS: function isiOS() {
            var e = navigator.userAgent,
                t = e.match(/(iPad).*OS\s([\d_]+)/),
                n = e.match(/(iPod)(.*OS\s([\d_]+))?/),
                r = !t && e.match(/(iPhone\sOS)\s([\d_]+)/);
            return !!(t || n || r);
          }
        }, i = function (e) {
          return t = e = {
            exports: {}
          }, function () {
            var m, e;
            t.exports = (m = {
              str2Json: function str2Json(e) {
                var t = {};
                if ("[object String]" === Object.prototype.toString.call(e)) try {
                  t = JSON.parse(e);
                } catch (e) {
                  t = {};
                }
                return t;
              },
              json2Str: function json2Str(e) {
                var t = e;
                if ("string" != typeof e) try {
                  t = JSON.stringify(e);
                } catch (e) {
                  t = "";
                }
                return t;
              },
              cbNum: 0,
              isIOS: !!navigator.userAgent.match(/KGBrowser/gi),
              isKugouAndroid: !!navigator.userAgent.match(/kugouandroid/gi),
              isAndroid: "undefined" != typeof external && void 0 !== external.superCall,
              isFXAPP: !!navigator.userAgent.match(/Fanxing/gi),
              isFXQianBanAPP: !!navigator.userAgent.match(/QianBan/gi),
              isIframePage: window.parent && window.parent != window,
              loadUrl: function loadUrl(e) {
                var t = document.createElement("iframe");
                t.setAttribute("src", e), t.setAttribute("style", "display:none;"), t.setAttribute("height", "0px"), t.setAttribute("width", "0px"), t.setAttribute("frameborder", "0"), document.body.appendChild(t), t.parentNode.removeChild(t), t = null;
              },
              mobileCallInIframe: function mobileCallInIframe(e, t, n) {
                var r = {
                  type: "KgMobileCall",
                  cmd: e
                };
                t && (r.dataJson = t), n && (r.cbName = n), r.source = "personal", window.parent.postMessage(r, "*");
              },
              receiveMessage: function receiveMessage(e) {
                var t = e.data;

                if ("KgMobileCall" == t.type && window[t.cbName] && (t.dataJson ? window[t.cbName](t.dataJson) : window[t.cbName](), window[t.cbName] = null), "KgWebMobileCall" == t.type) {
                  var n = t.funcName.split(".");
                  KgWebMobileCall[n[1]] && (t.dataJson ? KgWebMobileCall[n[1]](t.dataJson) : KgWebMobileCall[n[1]]());
                }
              },
              callCmd: function callCmd(n) {
                var r = m;

                if (r.isKugouAndroid) {
                  var e = {},
                      t = "";

                  if (n.cmd && (e.cmd = n.cmd), n.jsonStr && (e.jsonStr = n.jsonStr), n.callback && (r.cbNum++, t = "kgandroidmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), e.callback = t, window[t] = function (e, t) {
                    void 0 !== e && ("[object String]" === Object.prototype.toString.call(e) ? (e = "#" === t ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e)), n.callback(r.str2Json(e))) : n.callback(e));
                  }), n.AndroidCallback) {
                    var o = r.str2Json(n.jsonStr);
                    o.AndroidCallback = t, n.jsonStr = r.json2Str(o), n.jsonStr && (e.jsonStr = n.jsonStr);
                  }

                  var i = encodeURIComponent(JSON.stringify(e)),
                      a = "kugoujsbridge://start.kugou_jsbridge/?".concat(i);
                  r.isIframePage ? r.mobileCallInIframe(e.cmd, e.jsonStr, t) : r.loadUrl(a);
                } else if (r.isAndroid) {
                  var s = "",
                      c = "";

                  if (n.jsonStr) {
                    if (n.callback && "" !== n.callback && !0 === n.AndroidCallback) {
                      r.cbNum++, c = "kgmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), window[c] = function (e, t) {
                        void 0 !== e && ("[object String]" === Object.prototype.toString.call(e) ? (e = "#" === t ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e)), n.callback(r.str2Json(e))) : n.callback(e));
                      };
                      var l = r.str2Json(n.jsonStr);
                      l.AndroidCallback = c, n.jsonStr = r.json2Str(l);
                    }

                    if (r.isIframePage && n.AndroidCallback) r.mobileCallInIframe(n.cmd, n.jsonStr, c);else try {
                      s = external.superCall(n.cmd, n.jsonStr);
                    } catch (e) {}
                  } else try {
                    s = external.superCall(n.cmd);
                  } catch (e) {}

                  (!r.isIframePage || r.isIframePage && !n.AndroidCallback) && n.callback && "" !== n.callback && "AndroidCallback" != s && (s = r.str2Json(s), n.callback(s));
                } else if (r.isFXAPP || r.isFXQianBanAPP) {
                  var u = "",
                      d = "";
                  if (u = n.callback ? (r.cbNum++, d = "kgmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), window[d] = function (e) {
                    void 0 !== e && n.callback && ("[object String]" === Object.prototype.toString.call(e) ? n.callback(r.str2Json(e)) : n.callback(e));
                  }, n.jsonStr ? 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + ', "callback":"' + d + '"}' : 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "callback":"' + d + '"}') : n.jsonStr ? 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + "}" : 'fanxing2://send.message/?{"cmd":' + n.cmd + "}", r.isIframePage) r.mobileCallInIframe(n.cmd, n.jsonStr, d);else if (navigator.userAgent.match(/(Android);?[\s\/]+([\d.]+)?/)) {
                    if (external && external.callFanxing) {
                      var f = {
                        cmd: n.cmd,
                        jsonStr: n.jsonStr || "",
                        callback: d
                      };
                      external.callFanxing(JSON.stringify(f));
                    } else window.prompt(u);
                  } else r.loadUrl(u);
                } else {
                  var p = "",
                      g = "";
                  n.callback && (r.cbNum++, g = "kgmobilecall_" + (n.cmd || 0) + "_" + r.cbNum + Math.random().toString().substr(2, 9), window[g] = function (e) {
                    void 0 !== e && n.callback && ("[object String]" === Object.prototype.toString.call(e) ? n.callback(r.str2Json(e)) : n.callback(e));
                  }), g && "" != g && n.jsonStr && (p = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + ', "callback":"' + g + '"}'), g && "" != g && !n.jsonStr && (p = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "callback":"' + g + '"}'), "" == g && n.jsonStr && (p = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + "}"), "" != g || n.jsonStr || (p = 'kugouurl://start.music/?{"cmd":' + n.cmd + "}"), r.isIframePage ? r.mobileCallInIframe(n.cmd, n.jsonStr, g) : r.loadUrl(p);
                }
              }
            }, e = {
              isIOS: m.isIOS,
              isKugouAndroid: m.isKugouAndroid,
              isAndroid: m.isAndroid,
              isFXAPP: m.isFXAPP,
              isFXQianBanAPP: m.isFXQianBanAPP,
              isInClient: function isInClient() {
                return !!(m.isAndroid || m.isKugouAndroid || m.isIOS || m.isFXAPP || m.isFXQianBanAPP);
              },
              mobileCall: function mobileCall(e, t, n) {
                var r = "";
                if (t && (r = m.json2Str(t)), !e) return console.error("请输入命令号！"), !1;
                var o = {};
                e && (o.cmd = e), "" != r && (o.jsonStr = r), n && (o.callback = n), !e || 186 != e && 225 != e || n && (o.AndroidCallback = !0), m.callCmd(o);
              },
              KgWebMobileCall: function KgWebMobileCall(r, o) {
                if (r) try {
                  m.isIframePage && window.parent.postMessage({
                    type: "KgWebMobileCall",
                    funcName: r
                  }, "*");
                  var i = r.split(".");
                  i.reduce(function (e, t) {
                    if (e[t]) {
                      if (t !== i[i.length - 1]) return e[t];
                      var n = e[t];
                      return "function" == typeof n ? (e[t] = function () {
                        n && n.apply(void 0, arguments), o && o.apply(void 0, arguments);
                      }, e[t]) : (console.error("请检查，当前环境变量已注册了对象：" + r + "，且该对象不是方法"), null);
                    }

                    return t === i[i.length - 1] ? e[t] = function () {
                      o && o.apply(void 0, arguments);
                    } : e[t] = new Object(), e[t];
                  }, window);
                } catch (e) {}
              }
            }, window.addEventListener("message", function (e) {
              m.receiveMessage(e);
            }, !1), e);
          }(), e.exports;
          var t;
        }(), function (e, n) {
          var t = {
            getUserInfo: 101,
            getVersion: 122,
            getMobileInfo: 124
          },
              r = {
            appid: null,
            mid: null,
            uuid: null,
            plat: null,
            dfid: null,
            userid: null,
            userpic: null,
            userNickName: null,
            token: null,
            clientver: null
          };
          if (i.isInClient() && !i.isFXAP) i.mobileCall(t.getUserInfo, null, function (e) {
            1 == e.status ? (r.userid = e.kugouID, r.token = e.token, r.userpic = e.photo, r.userNickName = e.nickName, r.isVIP = e.isVIP || e.isVip) : (r.userid = null, r.token = null, r.userpic = null, r.userNickName = null), r.appid = e.appid, i.mobileCall(t.getVersion, null, function (e) {
              r.clientver = e.version, i.mobileCall(t.getMobileInfo, null, function (e) {
                r.mid = e.mid_v2 ? e.mid_v2 : e.mid, r.dfid = e.dfid ? e.dfid : "-", r.uuid = e.uuid ? e.uuid : r.mid, r.osVersion = e.osVersion ? e.osVersion : "", i.isIOS ? r.plat = 2 : r.plat = 1, n && n(r);
              });
            });
          });else if (i.isInClient() && i.isFXAP) i.mobileCall(625, null, function (e) {
            var t = JSON.parse(e.jsonStr);
            r.clientver = t.version, r.mid = t.mid, r.uuid = t.uuid ? t.uuid : r.mid, r.dfid = t.dfid ? t.dfid : "-", r.appid = t.appId, c.isiOS() ? r.plat = 2 : r.plat = 1, i.mobileCall(410, null, function (e) {
              1 == JSON.parse(e.jsonStr).status ? i.mobileCall(411, {}, function (e) {
                var t = JSON.parse(e.jsonStr).jsonStr ? JSON.parse(e.jsonStr).jsonStr : JSON.parse(e.jsonStr);
                r.userid = t.kugouId, r.token = t.token, r.pic = t.userLogo, r.nickName = t.nickName, n && n(r);
              }) : (r.userid = null, r.token = null, r.userpic = null, r.userNickName = null, n && n(r));
            });
          });else {
            r.appid = e || null, r.mid = c.getKgMid(), r.uuid = r.mid, r.plat = 4, r.dfid = c.Cookie.read("kg_dfid") || "-", r.userid = c.Cookie.read("KuGoo", "KugooID"), r.userpic = c.Cookie.read("KuGoo", "Pic"), r.userNickName = c.Cookie.read("KuGoo", "NickName"), r.token = c.Cookie.read("KuGoo", "t");
            var o = c.Cookie.read("KuGoo", "a_id");
            o && o != r.appid && (r.userid = null, r.token = null, r.userpic = null, r.userNickName = null), r.clientver = 1e3, r.userNickName = r.userNickName ? unescape(r.userNickName) : "", n && n(r);
          }
        });
      });

      function S(e, t, n) {
        var a,
            s = 1 < arguments.length && void 0 !== t ? t : "",
            c = 2 < arguments.length && void 0 !== n ? n : {},
            r = !1,
            o = !1,
            l = "json",
            i = m({}, 0 < arguments.length && void 0 !== e ? e : {}),
            u = h.isInClient(),
            d = !1;
        "function" == typeof c ? a = c : (a = c.callback, r = c.useH5 || !1, l = c.postType || "json", o = c.isCDN || !1, d = c.isFormData || !1), !s || "[object Object]" == Object.prototype.toString.call(s) && "urlencoded" != l || (u = !1);

        function f(t) {
          var e = [],
              n = [],
              r = "NVPh5oo715z5DIWAeQlhMDsWXXQV4hwt";

          for (var o in c && c.appkey && (delete t.srcappid, r = c.appkey), t) {
            e.push(o);
          }

          if (e.sort(), e.forEach(function (e) {
            n.push(e + "=" + t[e]);
          }), console.debug("isFormData: ", d, c), s && !d) if ("[object Object]" == Object.prototype.toString.call(s)) {
            if ("json" == l) n.push(JSON.stringify(s));else {
              var i = [];

              for (var o in s) {
                i.push(o + "=" + s[o]);
              }

              n.push(i.join("&"));
            }
          } else n.push(s);
          n.unshift(r), n.push(r), t.signature = v(n.join("")), c.log && (console.log("H5签名前参数排序结果", n), console.log("H5签名前md5原字符串", n.join("")), console.log("H5签名后返回", t)), s ? a && a(t, "[object Object]" == Object.prototype.toString.call(s) && "json" == l ? JSON.stringify(s) : s) : a && a(t);
        }

        function p() {
          var e = new Date().getTime(),
              t = {
            srcappid: "2919",
            clientver: "20000",
            clienttime: e,
            mid: e,
            uuid: e,
            dfid: "-"
          };
          i && i.appid && i.clientver && i.mid && i.uuid && i.dfid ? (i.srcappid = "2919", i.clienttime = i.clienttime || e, f(i)) : k(1058, function (e) {
            t.appid = e.appid, t.clientver = e.clientver, t.mid = e.mid, t.uuid = e.uuid, t.dfid = e.dfid, i.appid || delete i.appid, o && (delete t.clienttime, delete t.mid, delete t.uuid, delete t.dfid), i = m({}, t, {}, i), f(i);
          });
        }

        if (u && !r) {
          var g = !1;
          h.mobileCall(764, {
            get: i,
            post: s
          }, function (e) {
            return !g && (g = !0, e && e.status ? (delete e.status, c.log && (console.log("客户端签名前参数", {
              get: i,
              post: s
            }), console.log("客户端签名后返回", m({}, i, {}, e))), i = m({}, i, {}, e), s ? a && a(i, "[object Object]" == Object.prototype.toString.call(s) && "json" == l ? JSON.stringify(s) : s) : a && a(i), !1) : (u = !1, void p()));
          });
        } else u = !1, p();
      }

      return g = new p(f), y = p.prototype.request.bind(g), l.extend(y, p.prototype, g), l.extend(y, g), y.interceptors.request.on(function (c) {
        return new Promise(function (s) {
          var e = !1;
          "h5" == c.sign && (e = !0), c.isAllowSign ? "openapi" == c.sign ? function (e, t, n, r) {
            var o,
                i = 1 < arguments.length && void 0 !== t ? t : "",
                a = 2 < arguments.length && void 0 !== n ? n : "",
                s = 3 < arguments.length && void 0 !== r ? r : {},
                c = "json",
                l = m({}, 0 < arguments.length && void 0 !== e ? e : {});
            "function" == typeof s ? o = s : (o = s.callback, c = s.postType || "json"), function () {
              var e = [],
                  t = [];

              for (var n in l) {
                e.push(n);
              }

              if (e.sort(), e.forEach(function (e) {
                t.push(e + "=" + l[e]);
              }), i) if ("[object Object]" == Object.prototype.toString.call(i)) {
                if ("json" == c) t.push(JSON.stringify(i));else {
                  var r = [];

                  for (var n in i) {
                    r.push(n + "=" + i[n]);
                  }

                  t.push(r.join("&"));
                }
              } else t.push(i);
              t.unshift(a), t.push(a), l.signature = v(t.join("")), s.log && (console.debug("sign: ", t.join("")), console.log("H5签名前参数", t), console.log("H5签名后返回", l)), o && o(l);
            }();
          }(c.params, c.data, c.signSalt, {
            postType: "json",
            log: !1,
            callback: function callback(e) {
              c.params = e, s(c);
            }
          }) : S(c.params, c.data, {
            useH5: e,
            postType: "json",
            log: c.signLog || !1,
            appkey: c.signAppkey || c.appkey || null,
            isCDN: c.isCDN,
            isFormData: c.isFormData || !1,
            callback: function callback(e) {
              if (c.params = e, c && c.needEncodeData && c.needEncodeData.getDataKeyList && 0 < c.needEncodeData.getDataKeyList.length) for (var t = 0, n = c.needEncodeData.getDataKeyList.length; t < n; t++) {
                var r = c.needEncodeData.getDataKeyList[t];
                r && c.params[r] && (c.params[r] = encodeURIComponent(c.params[r]));
              }
              if (c && c.needEncodeData && c.needEncodeData.postDataKeyList && 0 < c.needEncodeData.postDataKeyList.length) for (var o = 0, i = c.needEncodeData.postDataKeyList.length; o < i; o++) {
                var a = c.needEncodeData.postDataKeyList[o];
                a && c.data[a] && (c.data[a] = encodeURIComponent(c.data[a]));
              }
              s(c);
            }
          }) : s(c);
        });
      }), y.interceptors.request.on(function (t) {
        return new Promise(function (e) {
          window.kmRequestListener && window.kmRequestListener(1), e(t);
        });
      }), y.interceptors.response.on(void 0, function (e) {
        if (e && e.config && 0 < e.config.retry) {
          if (e.config.retryIndex = (e.config.retryIndex + 1) % e.config.retryList.length, e.config.baseURL = e.config.retryList[e.config.retryIndex] || e.config.baseURL, e.config.retry--, e.request && (e.request.abort(), e.request = null), e.config && e.config.params && e.config.params.signature && delete e.config.params.signature, e.config && e.config.needEncodeData && e.config.needEncodeData.getDataKeyList && 0 < e.config.needEncodeData.getDataKeyList.length) for (var t = 0, n = e.config.needEncodeData.getDataKeyList.length; t < n; t++) {
            var r = e.config.needEncodeData.getDataKeyList[t];
            r && e.config.params[r] && (e.config.params[r] = decodeURIComponent(e.config.params[r]));
          }
          if (e.config && e.config.needEncodeData && e.config.needEncodeData.postDataKeyList && 0 < e.config.needEncodeData.postDataKeyList.length) for (var o = 0, i = e.config.needEncodeData.postDataKeyList.length; o < i; o++) {
            var a = e.config.needEncodeData.postDataKeyList[o];
            a && e.config.data[a] && (e.config.data[a] = decodeURIComponent(e.config.data[a]));
          }
          return y(e.config);
        }

        return window.kmRequestListener && window.kmRequestListener(2, e.code || 0), Promise.reject(e);
      }), y.interceptors.response.on(function (e) {
        try {
          e.data = JSON.parse(e.data);
        } catch (e) {}

        return e;
      }), y.interceptors.response.on(function (e) {
        return window.kmRequestListener && window.kmRequestListener(2, 200), e;
      }), y.interceptors.response.on(function (e) {
        if (e && e.config && e.config.isAllowKGAntiBush && e.data && 0 === e.data.status) {
          var t = "",
              n = "";

          try {
            t = e.headers["ssa-code"], n = e.headers["ssa-hmid"];
          } catch (e) {}

          n = n || e.config.kgAntiBushMid || e.config.params.mid || "";
          var r = e.config.kgAntiBushAppid || e.config.params.appid || "";

          if (t) {
            if (r) {
              var o = e.config.kgAntiBushURL ? e.config.kgAntiBushURL : "https://m3ws.kugou.com";
              o = encodeURIComponent(o);
              var i = "https://h5.kugou.com/apps/verify-h5/dist/#/index/".concat(t, "/").concat(e.config.kgAntiBushAppid, "/").concat(o, "/").concat(n);
              window.location.replace(i);
            } else console.error("请输入正确的参数。eventid 和 appid 不允许为空！");

            return e.config.kgAntiBushErrorReject ? e : null;
          }

          return e;
        }

        return e;
      }), y;
    });
  });

  function _defineProperty$2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2$2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys$2(Object(source), true).forEach(function (key) {
          _defineProperty$2(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$2(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function styleInject$1(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') {
      return;
    }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css = ".kg-loading-wrap{\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 10000;\r\n}\r\n.kg-loading .kg-loading-container .kg-loading-msg span {\r\n    color: #000;\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container .kg-loading-icon {\r\n    width: .55em;\r\n    height: .55em;\r\n    position: relative;\r\n    -ms-flex-negative: 0;\r\n        flex-shrink: 0;\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container .kg-loading-icon canvas {\r\n    position: absolute;\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container .kg-loading-msg {\r\n    -ms-flex-negative: 1;\r\n        flex-shrink: 1;\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container .kg-loading-msg span {\r\n    font-size: .24em;\r\n    display: block;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n\r\n.kg-loading.block .kg-loading-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n}\r\n\r\n.kg-loading.block .kg-loading-container .kg-loading-icon {\r\n    width: .88em;\r\n    height: .88em;\r\n    position: relative;\r\n    -ms-flex-negative: 0;\r\n        flex-shrink: 0;\r\n}\r\n\r\n.kg-loading.block .kg-loading-container .kg-loading-icon canvas {\r\n    position: absolute;\r\n}\r\n\r\n.kg-loading.block .kg-loading-container .kg-loading-msg {\r\n    margin-top: .1em;\r\n    -ms-flex-negative: 1;\r\n        flex-shrink: 1;\r\n}\r\n\r\n.kg-loading.block .kg-loading-container .kg-loading-msg span {\r\n    font-size: .24em;\r\n    display: block;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.kg-loading.pop {\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10000;\r\n}\r\n\r\n.kg-loading.pop .kg-loading-container {\r\n    padding: .2em;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    border-radius: .1em;\r\n    overflow: hidden;\r\n    z-index: 10000;\r\n}\r\n\r\n.kg-loading.pop .kg-loading-container .kg-loading-msg span {\r\n    color: #fff;\r\n}\r\n\r\n.kg-loading.pop.popBg .kg-loading-bg {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 9999;\r\n}\r\n\r\n\r\n\r\n.kg-loading-icon.blue {\r\n    background: url(https://webimg.kgimg.com/c47e54633d8bd65701629ac3f3e6ee9f.png) no-repeat top center;\r\n    background-size: 100%;\r\n}\r\n\r\n.kg-loading-icon.blue:before {\r\n    content: \"\";\r\n    width: 100%;\r\n    height: 100%;\r\n    background: url(https://webimg.kgimg.com/a76d10d8a9d930969330a396361f9a4a.png) no-repeat;\r\n    background-size: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    -webkit-animation: rotateAni 1s linear infinite;\r\n    animation: rotateAni 1s linear infinite;\r\n}\r\n\r\n.kg-loading-icon.red {\r\n    background: url(https://webimg.kgimg.com/d882096843e8ba444368cb31e77e975d.png) no-repeat top center;\r\n    background-size: 100%;\r\n}\r\n\r\n.kg-loading-icon.red:before {\r\n    content: \"\";\r\n    width: 100%;\r\n    height: 100%;\r\n    background: url(https://webimg.kgimg.com/44b471990022a7f0673aee8d0933145e.png) no-repeat;\r\n    background-size: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    -webkit-animation: rotateAni 1s linear infinite;\r\n    animation: rotateAni 1s linear infinite;\r\n}\r\n\r\n@-webkit-keyframes rotateAni {\r\n    0% {\r\n        -webkit-transform: rotate(0);\r\n        transform: rotate(0);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes rotateAni {\r\n    0% {\r\n        -webkit-transform: rotate(0);\r\n        transform: rotate(0);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n.kg-loading-svg{width:100%;display:block;}\r\n\r\n/* kugou11版本 */\r\n/*\r\n  计算方法: (dashoffset_min / dashoffset_max * rotate / 2)\r\n  比如: 620/916*360/2\r\n*/\r\n@-webkit-keyframes kg-loading_roll_11 {\r\n  0%{-webkit-transform:rotate(0deg);transform:rotate(0deg);}\r\n  50%{-webkit-transform:rotate(122deg);transform:rotate(122deg);}\r\n  100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}\r\n}\r\n@keyframes kg-loading_roll_11 {\r\n  0%{-webkit-transform:rotate(0deg);transform:rotate(0deg);}\r\n  50%{-webkit-transform:rotate(122deg);transform:rotate(122deg);}\r\n  100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}\r\n}\r\n\r\n@-webkit-keyframes kg-loading_dashoffset_11 {\r\n  0%{stroke-dashoffset:220;}\r\n  50%{stroke-dashoffset:149;}\r\n  100%{stroke-dashoffset:220;}\r\n}\r\n@keyframes kg-loading_dashoffset_11 {\r\n  0%{stroke-dashoffset:220;}\r\n  50%{stroke-dashoffset:149;}\r\n  100%{stroke-dashoffset:220;}\r\n}\r\n\r\n.kg-loading-svg .kg-loading-K,\r\n.kg-loading-svg .kg-loading-R{stroke:rgb(94, 206, 247);\r\n    -webkit-transition:stroke 0.3s;\r\n    transition:stroke 0.3s;\r\n}\r\n.kg-loading-svg .kg-loading-R{\r\n    -webkit-animation:kg-loading_roll_11 1.08s linear infinite;\r\n    animation:kg-loading_roll_11 1.08s linear infinite;\r\n    -webkit-transform-origin:50% 50%;\r\n    transform-origin:50% 50%;\r\n}\r\n.kg-loading-svg .kg-loading-C{\r\n    -webkit-animation:kg-loading_dashoffset_11 1.08s linear infinite;\r\n    animation:kg-loading_dashoffset_11 1.08s linear infinite;\r\n}\r\n.kg-loading-svg .kg-loading-BG{fill:rgba(94, 206, 247, 0.1);}\r\n.kg-loading-svg.kg-loading-warn .kg-loading-BG{fill:rgba(254, 180, 84, 0.1);}\r\n.kg-loading-svg.kg-loading-warn .kg-loading-K,\r\n.kg-loading-svg.kg-loading-warn .kg-loading-R{stroke:rgb(254, 180, 84);}";
  styleInject$1(css);
  /**
   * Canvas
   * @param {*} elem 
   * @param {*} opts 
   */

  var iconInit = function iconInit(elem, opts) {
    if (typeof elem === 'string') {
      elem = document.querySelector(elem);
    } else if (elem.nodeType !== 1) {
      console.error('elem is not an Element Node');
      return;
    }

    var defaultOptions = {
      color: false,
      // 'normal', 'error', other_colors
      width: 48,
      stop: false,
      dpr: window.devicePixelRatio || 2
    };
    opts = Object.assign({}, defaultOptions, opts || {});
    var colorBlue = '#409EFF';
    var colorError = '#FF6C00';
    var KWBase = 6.6 / 144;
    var KPBase = [['moveTo', 59 / 144, 44 / 144], ['lineTo', 55 / 144, 100 / 144], ['moveTo', 90 / 144, 48 / 144], ['lineTo', 65 / 144, 70 / 144], ['lineTo', 89 / 144, 100 / 144]];
    var cache = {
      moveAngle: 0,
      secondAngle: Math.PI,
      endAngle: Math.PI / 8,
      add: 1,
      defaultSpeed: 1280 / (2 * Math.PI),
      // 根据options变化
      cvsWidth: 0,
      // 画布宽
      lineWidth: 0,
      // 线条宽
      radius: 0,
      // 半径
      center: {
        x: 0,
        y: 0
      },
      // 中心点
      KPoints: [],
      // K的路径关键点
      color: colorBlue,
      drawing: false
    };
    var cvs = document.createElement('canvas');

    if (!cvs.getContext) {
      return false;
    }

    var ctx = cvs.getContext("2d");
    cvs.style.maxWidth = '100%';
    cvs.style.maxHeight = '100%';
    cvs.style.verticalAlign = 'top';

    var changeOptions = function changeOptions(newOptions) {
      Object.assign(opts, newOptions || {});
      var W = cache.cvsWidth = (opts.width || 144) * opts.dpr;
      cache.color = !opts.color || opts.color === 'normal' ? colorBlue : opts.color === 'error' ? colorError : opts.color;
      cache.lineWidth = W * KWBase;
      cache.KPoints = KPBase.map(function (_) {
        return _.map(function (__) {
          return typeof __ === 'string' ? __ : W * __;
        });
      });
      cache.center = {
        x: W / 2,
        y: W / 2
      };
      cache.radius = W / 2 - cache.lineWidth;
      cvs.width = W;
      cvs.height = W;
      cvs.style.width = opts.width + 'px';
      cvs.style.height = opts.width + 'px';

      if (!opts.stop && cache.drawing === false) {
        draw();
      }
    };

    var draw = function draw(step) {
      cache.drawing = true;
      var C = cache.center;
      var R = cache.radius; // const KP = cache.KPoints

      var SP = step || cache.defaultSpeed;
      ctx.clearRect(0, 0, cache.cvsWidth, cache.cvsWidth);
      ctx.lineCap = "round";
      ctx.fillStyle = "#f2f2f2";
      ctx.strokeStyle = cache.color; // 绘制背景

      ctx.beginPath();
      ctx.arc(C.x, C.y, R - cache.lineWidth * 1.5, 0, Math.PI * 2, false);
      ctx.fill();
      ctx.save(); // 绘制K

      ctx.lineWidth = cache.lineWidth * 1.82;
      ctx.beginPath();
      cache.KPoints.map(function (_) {
        ctx[_[0]](_[1], _[2]);
      }); // ctx.moveTo(KP[0][0], KP[0][1])
      // ctx.lineTo(KP[1][0], KP[1][1])
      // ctx.moveTo(KP[2][0], KP[2][1])
      // ctx.lineTo(KP[3][0], KP[3][1])
      // ctx.lineTo(KP[4][0], KP[4][1])

      ctx.stroke(); // 绘制外框线条动画

      ctx.lineWidth = cache.lineWidth;
      ctx.beginPath();
      ctx.arc(C.x, C.y, R, cache.moveAngle, cache.moveAngle + cache.endAngle, false);
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(C.x, C.y, R, cache.moveAngle + cache.secondAngle, cache.moveAngle + cache.secondAngle + cache.endAngle, false);
      ctx.stroke();
      cache.moveAngle += SP;

      if (cache.moveAngle >= 2 * Math.PI) {
        cache.moveAngle = 0;
      }

      if (cache.endAngle >= Math.PI / 3) {
        cache.endAngle = Math.PI / 3;
        cache.add = 0;
      } else if (cache.endAngle <= Math.PI / 24) {
        cache.endAngle = Math.PI / 24;
        cache.add = 1;
      }

      if (cache.add) {
        cache.endAngle += SP / 2;
      } else {
        cache.endAngle -= SP / 2;
        cache.moveAngle += SP / 2;
      }

      cache.lastTime = Date.now();
      requestAnimationFrame(function () {
        // 如果元素被删除，就不继续循环了
        // if (cvs.parentNode && cvs.parentNode.parentNode && !opts.stop) {//<----有bug，实际上没删掉dom的引用
        if (cvs.offsetWidth != 0 && !opts.stop) {
          // 动画时长1280ms
          var _step = (Date.now() - cache.lastTime) * 2 * Math.PI / 1280;

          draw(_step);
        } else {
          cache.drawing = false;
          cvs = null;
        }
      });
    };

    elem.appendChild(cvs);
    changeOptions();
    return {
      draw: draw,
      changeOptions: changeOptions
    };
  };
  /**
   * 酷狗11
   * @param {*} elem 
   * @param {*} opts 
   * @returns 
   */


  var kg11Init = function kg11Init(elem, opts) {
    if (typeof elem === 'string') {
      elem = document.querySelector(elem);
    } else if (elem.nodeType !== 1) {
      console.error('elem is not an Element Node');
      return false;
    }

    var supportSVG = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect;

    if (!supportSVG) {
      return false;
    }

    opts = opts || {};
    elem.innerHTML = "\n    <svg class=\"kg-loading-svg ".concat(opts && opts.type ? "kg-loading-" + opts.type : "", "\" viewBox=\"0 0 88 88\" version=\"1.1\">\n        <circle class=\"kg-loading-BG\" cx=\"44\" cy=\"44\" r=\"26\" stroke=\"none\"/>\n        <g class=\"kg-loading-K\" fill=\"none\" stroke-width=\"7\" stroke-linecap=\"round\">\n            <line x1=\"39.2\" y1=\"35.5\" x2=\"39.2\" y2=\"51.5\"/>\n            <polyline points=\"50.1 35.6 41.3 43.4 50.2 50.8\"/>\n        </g>\n        <g class=\"kg-loading-R\" fill=\"none\" stroke-width=\"8\" stroke-linecap=\"round\" stroke-dasharray=\"220.1\" stroke-dashoffset=\"220\">\n            <circle class=\"kg-loading-C\" cx=\"44\" cy=\"44\" r=\"35\" transform=\"translate(88,88) rotate(180)\"/>\n            <circle class=\"kg-loading-C\" cx=\"44\" cy=\"44\" r=\"35\"/>\n        </g>\n    </svg>\n    ");

    var changeOptions = function changeOptions(options) {
      var svg = elem.querySelector(".kg-loading-svg");
      var list = [];

      for (var i = 0; i < svg.classList.length; i++) {
        list.push(svg.classList[i]);
      }

      for (var i = 0; i < list.length; i++) {
        svg.classList.remove(list[i]);
      }

      svg.classList.add("kg-loading-svg");

      if (options && options.type) {
        svg.classList.add("kg-loading-" + options.type);
      }
    };

    setTimeout(function () {
      changeOptions(opts);
    }, 100);
    return {
      changeOptions: changeOptions
    };
  };
  /**
   * 获取DOM HTML
   * @param {Object} options 
   */


  var getHTML = function getHTML(options) {
    var getLoadClass = function getLoadClass() {
      var classlist = ["kg-loading"]; //显示类型

      if (options.type) {
        classlist.push(options.type);
      } //是否弹窗


      if (options.showPop) {
        classlist.push('pop');
      } // 是否显示弹窗背景


      if (options.popConfig.showBg) {
        classlist.push('popBg');
      } //是否红菊


      if (options.showLongLoad) {
        classlist.push('longLoad');
      }

      return classlist.join(" ");
    };

    var getColor = function getColor(color, styles) {
      return color ? "".concat(styles ? styles : 'background-color', ":").concat(color, ";") : '';
    };

    var kgLoad = document.createElement("div");
    kgLoad.className = getLoadClass();
    kgLoad.innerHTML = "\n        <div class=\"kg-loading-container\" style=\"".concat(getColor(options.popConfig.popColor), "\">\n            <div class=\"kg-loading-icon ").concat(options.icon || '', "\"></div>\n            <div class=\"kg-loading-msg\" style=\"").concat(options.msg && 'margin-left: .1em;', "\"><span style=\"").concat(getColor(options.color, "color"), "\">").concat(options.msg || '', "</span></div>\n        </div>\n        <div class=\"kg-loading-bg\" style=\"").concat(getColor(options.popConfig.bgColor), "\"></div>\n    ");
    kgLoad.style.fontSize = Math.min(document.querySelector("html").offsetWidth / 7.2, 60) + "px";
    return kgLoad;
  };
  /**
   * 获取DOM容器
   * @param {Object} options 
   */


  var getEle = function getEle(options) {
    if (options.ele) {
      if (typeof options.ele == "string") {
        return document.getElementById(options.ele);
      } else {
        return options.ele;
      }
    } else {
      var rand = document.createElement("div");
      rand.id = "kg-loading-" + new Date().getTime();
      rand.className = options.showPop ? "kg-loading-wrap" : "";
      document.body.appendChild(rand);
      return rand;
    }
  };
  /**
   * 删除DOM节点
   * @param {Object} ele 
   */


  var removeEle = function removeEle(ele) {
    if (ele.getElementsByClassName("kg-loading").length > 0) {
      ele.removeChild(ele.getElementsByClassName("kg-loading")[0]);

      if (ele.id && /kg-loading/.test(ele.id)) {
        document.body.removeChild(ele);
      }
    }
  };
  /**
   * 后置处理
   * @param {Object} ele 
   * @param {Object} options 
   */


  var postProcess = function postProcess(ele, options) {
    if (options.icon == 'blue_v3') {
      var canvas = ele.getElementsByClassName('blue_v3')[0];

      if (options.showLongLoad) {
        var obj = kg11Init(canvas);

        if (obj == false) {
          //加载失败降级
          downGrade(ele, _objectSpread2$2({}, options, {}, {
            icon: 'blue'
          }));
        } else {
          setTimeout(function () {
            obj.changeOptions({
              type: "warn"
            });
            ele.getElementsByClassName("kg-loading-msg")[0] && (ele.getElementsByClassName("kg-loading-msg")[0].innerHTML = "<span>".concat(options.longLoadConfig.msg || '加载缓慢', "</span>"));
          }, Math.ceil(options.longLoadConfig.time / 1000) * 1000 || 3000);
        }
      } else {
        var obj = kg11Init(canvas);

        if (obj == false) {
          //加载失败降级
          downGrade(ele, _objectSpread2$2({}, options, {}, {
            icon: 'blue'
          }));
        }
      }
    }

    if (options.icon == 'red_v3') {
      var _canvas = ele.getElementsByClassName('red_v3')[0];
      var obj = kg11Init(_canvas, {
        type: "warn"
      });

      if (obj == false) {
        //加载失败降级
        downGrade(ele, _objectSpread2$2({}, options, {}, {
          icon: 'red'
        }));
      }
    }

    if (options.icon == 'blue_v2') {
      var _canvas2 = ele.getElementsByClassName('blue_v2')[0];

      if (options.showLongLoad) {
        var obj = iconInit(_canvas2);

        if (obj == false) {
          //加载失败降级
          downGrade(ele, _objectSpread2$2({}, options, {}, {
            icon: 'blue'
          }));
        } else {
          setTimeout(function () {
            obj.changeOptions({
              color: "error"
            });
            ele.getElementsByClassName("kg-loading-msg")[0] && (ele.getElementsByClassName("kg-loading-msg")[0].innerHTML = "<span>".concat(options.longLoadConfig.msg || '加载缓慢', "</span>"));
          }, Math.ceil(options.longLoadConfig.time / 1000) * 1000 || 3000);
        }
      } else {
        var obj = iconInit(_canvas2);

        if (obj == false) {
          //加载失败降级
          downGrade(ele, _objectSpread2$2({}, options, {}, {
            icon: 'blue'
          }));
        }
      }
    }

    if (options.icon == 'red_v2') {
      var _canvas3 = ele.getElementsByClassName('red_v2')[0];
      var obj = iconInit(_canvas3, {
        color: "error"
      });

      if (obj == false) {
        //加载失败降级
        downGrade(ele, _objectSpread2$2({}, options, {}, {
          icon: 'red'
        }));
      }
    }

    if (options.icon == "blue") {
      if (options.showLongLoad) {
        setTimeout(function () {
          ele.getElementsByClassName("kg-loading-icon")[0].className += ' red';
          ele.getElementsByClassName("kg-loading-msg")[0] && (ele.getElementsByClassName("kg-loading-msg")[0].innerHTML = "<span>".concat(options.longLoadConfig.msg || '加载缓慢', "</span>"));
        }, Math.ceil(options.longLoadConfig.time / 1000) * 1000 || 3000);
      }
    }

    if (options.time && options.time > 0) {
      setTimeout(function () {
        removeEle(ele);
      }, options.time);
    }
  };
  /**
   * 降级处理
   * @param {Object} ele 
   * @param {Object} options 
   */


  var downGrade = function downGrade(ele, options) {
    removeEle(ele);
    var DomEle = getEle(options);
    var DomHtml = getHTML(options);
    DomEle.appendChild(DomHtml);
    postProcess(DomEle, options);
  };
  /**
   * 统一loading组件
   * 
   * @param {JSON} options 
   * @field type 显示类型（inline：并列显示 block：块显示）
   * @field msg 消息内容 
   * @field time 显示时长（不指定无限长 毫秒）
   * @field ele DOM容器（DOM ID/对象）
   * @field icon 显示的ICON(blue red blue_v2 red_v2)
   * @field color 显示颜色（RGBA）
   * 
   * @field showPop 是否浮窗显示
   * @field popConfig 浮窗配置
   * @field popConfig-showBg 浮窗背景显示
   * @field popConfig-popColor 浮窗颜色（RGBA）
   * @field popConfig-bgColor 浮窗背景颜色（RGBA）
   * 
   * @field showLongLoad 是否显示红菊
   * @field longLoadConfig 红菊配置
   * @field longLoadConfig-time 加载多少毫秒后显示红菊
   * @field longLoadConfig-msg 显示红菊时的文案
   */


  function kgLoad() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    options = _objectSpread2$2({}, {
      popConfig: {}
    }, {}, {
      longLoadConfig: {}
    }, {}, {
      type: 'inline',
      icon: 'blue',
      showPop: false,
      showLongLoad: false,
      color: !options.color && options.showPop ? "white" : "black"
    }, {}, options);
    var DomEle = getEle(options);

    if (options.time == -1) {
      return removeEle(DomEle);
    }

    var DomHtml = getHTML(options);
    DomEle.appendChild(DomHtml);
    postProcess(DomEle, options);
    return DomEle;
  }

  function t(o) {
    return t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, t(o);
  }

  function o(o) {
    if (!o) return o;
    if (~o.indexOf("https://")) return o;
    var s = "";
    return [["https://imgessl.kugou.com", ["http://imge.kugou.com", "http://imgessl.kugou.com", "http://singerimg.kugou.com", "http://c0.kgimg.com", "http://c1.kgimg.com", "http://c2.kgimg.com", "http://c3.kgimg.com", "http://c4.kgimg.com", "http://c5.kgimg.com", "http://c6.kgimg.com", "http://c7.kgimg.com", "http://c8.kgimg.com", "http://c9.kgimg.com", "http://s1.kgimg.com"]], ["https://webimg.kgimg.com", ["http://webimg.bssdl.kugou.com"]], ["https://mobileservicebssdl.kugou.com", ["http://mobileservice.bssdl.kugou.com"]], ["https://mwebbssdl.kugou.com", ["http://mweb.bssdl.kugou.com"]], ["https://schoolimgbssdl.kugou.com", ["http://schoolimg.bssdl.kugou.com"]], ["https://activitybssdl.kugou.com", ["http://activity.bssdl.kugou.com"]], ["https://adsfile.kugou.com", ["http://adsfile.bssdlbig.kugou.com"]], ["https://imgacsing.kugou.com", ["http://img.acsing.kugou.com"]], ["https://s10.fxwork.kugou.com", ["http://s10.fxwork.fanxing.kugou.com", "http://s10.fxwork.fanxing.com", "http://s10.fxwork.kugou.com"]], ["https://p3fx.kgimg.com", ["http://imge.kugou.com", "http://s3.fx.kgimg.com", "http://p3.fx.kgimg.com"]], ["https://s4fx.kgimg.com", ["http://s4fx.kgimg.com"]], ["https://m3ws.kugou.com", ["http://m.kugou.com"]], ["https://ep.kugou.com", ["http://zhuanjistatic.kugou.com"]], ["https://ksongbssdl.kugou.com", ["http://ksong.bssdl.kugou.com"]], ["https://fxbssdl.kgimg.com", ["http://fxbssdl.kgimg.com"]], ["https://fxmimagebssdl.kgimg.com", ["http://fxmimagebssdl.kgimg.com"]], ["https://fximgbssdl.kugou.com", ["http://fximgbssdl.kugou.com"]], ["https://fxbssdl.kgimg.com/bss/fxvideoimg/", ["http://fxvideoimg.bssdl.kugou.com"]], ["https://fxbssdl.kgimg.com/bss/fxams", ["http://fxams.bssdl.kugou.com"]], ["https://fxbssdl.kgimg.com/bss/album", ["http://album.bssdl.kugou.com"]], ["https://fxv.kugou.com", ["http://fx.v.kugou.com"]], ["https://imgulssl.kugou.com", ["http://image.upload.kugou.com"]], ["https://imgphpulssl.kugou.com", ["http://imgphp.kugou.com"]], ["https://audioulssl.kugou.com", ["http://upload.fs.kugou.com"]], ["https://bssulbig.service.kugou.com", ["http://bssulbig.kugou.com"]], ["https://qrcodebssdl.kugou.com", ["http://qrcode.bssdl.kugou.com"]], ["https://vipbssdl.kugou.com", ["http://vip.bssdl.kugou.com"]], ["https://$13fx.kgimg.com", [/^http:\/\/([sp])[1-5]\.fx\.(kgimg)\.com/, /^http:\/\/([sp])[1-5]\.fanxing\.com/]], ["https://imagemsgbssdl.kugou.com", ["http://imagemsg.bssdl.kugou.com"]], ["https://$1.yun.kugou.com", [/^http:\/\/(.+)\.yun\.kugou\.com/]], ["https://$1.cloud.kugou.com", [/^http:\/\/(.+)\.cloud\.kugou\.com/]]].forEach(function (m) {
      var g = m[1],
          u = m[0];
      return g.forEach(function (m) {
        if (!s) return ("object" === t(m) && m.test(o) || ~o.indexOf(m)) && (s = o.replace(m, u)), !s;
      }), !s;
    }), s || function (t, o) {
      try {
        var s = window.location.href;
        new Image().src = "https://statwww2.kugou.com/node/weblog/jsloger?key=img_https_list&sourceUrl=" + s + "&imgurl=" + t + "&msg=" + o;
      } catch (t) {}
    }(o, "转化https链接失败"), s || o;
  }

  Array.prototype.forEach || (Array.prototype.forEach = function (t) {
    var o, s;
    if (null == this) throw new TypeError("this is null or not defined");
    var m = Object(this),
        g = m.length >>> 0;
    if ("function" != typeof t) throw new TypeError(t + " is not a function");

    for (1 < arguments.length && (o = arguments[1]), s = 0; s < g;) {
      var u;
      s in m && (u = m[s], t.call(o, u, s, m)), s++;
    }
  });
  var replaceHttpsImg = o;
  main_min$2.requestConfig.useMobileCall = false;
  main_min$2.requestConfig.retry = 0;
  main_min$2.requestConfig.sign = 'h5';
  main_min$2.requestConfig.isAllowSign = true;
  main_min$2.requestConfig.isAllowKGAntiBush = true;
  var UA = window.navigator.userAgent;

  var OS = function () {
    var osInner = {},
        android = UA.match(/(Android);?[\s\/]+([\d.]+)?/),
        ipad = UA.match(/(iPad).*OS\s([\d_]+)/),
        ipod = UA.match(/(iPod)(.*OS\s([\d_]+))?/),
        iphone = !ipad && UA.match(/(iPhone\sOS)\s([\d_]+)/),
        SafariBrowser = new RegExp("Safari/", "gi").test(UA),
        UCBrowser = new RegExp("UCBrowser", "gi").test(UA),
        MQQBrowser = new RegExp("MQQBrowser", "gi").test(UA),
        MicroMessenger = new RegExp("MicroMessenger", "gi").test(UA),
        QQ = new RegExp("QQ/", "gi").test(UA),
        Weibo = new RegExp("Weibo", "gi").test(UA),
        Mobile = UA.toLowerCase().indexOf("mobile") !== -1;

    if (android) {
      osInner.android = true;
      osInner.version = android[2];
    }

    if (iphone && !ipod) {
      osInner.ios = osInner.iphone = true;
      osInner.version = iphone[2].replace(/_/g, ".");
    }

    if (ipad) {
      osInner.ios = osInner.ipad = true;
      osInner.version = ipad[2].replace(/_/g, ".");
    }

    osInner.SafariBrowser = SafariBrowser;
    osInner.UCBrowser = UCBrowser;
    osInner.MQQBrowser = MQQBrowser;
    osInner.MicroMessenger = MicroMessenger;
    osInner.QQ = QQ;
    osInner.Weibo = Weibo;
    osInner.Mobile = Mobile;
    return osInner;
  }();

  var ios134 = false;

  if (OS.iphone && Number(OS.version.substring(0, 2)) >= 13) {
    if (Number(OS.version.substring(0, 4)) >= 13.4) {
      ios134 = true;
    }
  }

  var ios9 = false;

  if (OS.iphone && Number(OS.version.substring(0, 2)) <= 9) {
    ios9 = true;
  }

  var ios9Deal = false;
  var uploadedImageURL;

  var uploadImage =
  /*#__PURE__*/
  function () {
    /**
     * 构造函数
     * @param config 初始化配置参数
     */
    function uploadImage(config) {
      _classCallCheck(this, uploadImage);

      this.inputDom = null; //input元素

      this.loadingEle; //loading

      this.inputFileNum; //input上传的文件数
      //压缩输出的图片格式

      this.compressForm = "image/jpeg"; //cropper相关

      this.cropper; //裁剪输出，否则部分机型会黑屏

      this.getCroppedCanvasDataSet = {
        maxWidth: 4096,
        maxHeight: 4096
      };
      this.cropperOpt = {};
      config = Object.assign({
        size: 2,
        //压缩尺寸限制，单位MB，默认2MB
        imgRatio: 1,
        //输出图片与原图的比例，原图尺寸输出为1，为原图一半时填1/2
        compressionRatio: 0.05,
        fileSizeLimit: 10,
        //上传图片大小限制，单位MB，默认10MB
        fileSizeLimitTip: "请上传10M以内的图片",
        //超出上传大小限制文案
        bucket: 'webimg',
        bucketType: 1,
        //1：共有桶，2：内网桶，3：私有桶
        bssAuthParams: {},
        bssUploadParams: {},
        userInfo: null,
        appid: 1058,
        loginType: 1,
        //默认内网桶loginType=0，其他都是1，支持组件初始化覆盖loginType，以防其他平台（如5sing）使用
        salt: "b51ea3057dda8fa2",
        //input属性
        inputEle: true,
        //组件内部生成input元素
        multi: false,
        //是否允许多选图片，默认为false
        limit: 5,
        //上传图片数限制，默认为5
        limitTip: "超过上传限制",
        accept: "image/*",
        //input的accept属性，默认为image/*
        //裁剪相关
        ratio: 1,
        //裁剪宽高比
        imgCropper: false,
        //是否使用裁剪功能
        form: "image/jpeg",
        //输出图片格式，'image/jpeg'、'image/png'
        cwidth: 500,
        //裁剪输出尺寸
        cheight: 500,
        //裁剪输出尺寸
        cropperOptions: {
          viewMode: 1,
          //cropperjs设置
          dragMode: "move",
          ready: function ready(e) {}
        },
        //使用mobilecall方式上传裁剪获取图片
        cType: "cropperjs",
        //mobilecall、cropperjs两种方式
        authMeet: {
          type: 2
        },
        //可自定义传mobilecall参数
        mobileCallCompress: false,
        //mobilecall方式得到的图片是否进行压缩
        limitWidth: 8000,
        limitHeight: 8000,
        limitSizeTip: "上传的图片太大，请重新上传",
        minWidth: 100,
        minHeight: 100,
        minSizeTip: "上传的图片太小，请重新上传",
        toastTime: 3000,
        //toast显示时长
        authReqObj: {},
        uploadReqObj: {},
        log: false
      }, config);
      this.config = config;
      this.init();
    }

    _createClass(uploadImage, [{
      key: "init",
      value: function init() {
        this.configSet(); //使用者自己处理input上传

        if (this.config.inputEle) {
          this.createInput();
        } //使用mobilecall方式


        if (this.config.cType == "mobilecall") {
          this.mobileCallUploadCb();
        }
      } //生成input元素

    }, {
      key: "createInput",
      value: function createInput() {
        var _this2 = this;

        this.inputDom = document.createElement("input");
        this.inputDom.type = "file";
        this.inputDom.accept = this.config.accept;

        if (this.config.id) {
          this.inputDom.id = this.config.id;
        }

        if (this.config.multi) {
          this.inputDom.multiple = "multiple";
        }

        this.inputDom.style.opacity = 0;
        this.inputDom.style.position = "absolute";
        this.inputDom.style.left = "-100000%";
        this.inputDom.style.top = "-100000%";
        document.body.appendChild(this.inputDom);
        this.inputDom.addEventListener("change", function (e) {
          _this2.onChange(e);
        });
      }
    }, {
      key: "triggerClick",
      value: function triggerClick(node) {
        if (document.createEvent) {
          var evt = document.createEvent('MouseEvents');
          evt.initEvent('click', true, false);
          node.dispatchEvent(evt);
        } else if (document.createEventObject) {
          node.fireEvent('onclick');
        } else if (typeof node.onclick == 'function') {
          node.onclick();
        }
      } //触发上传

    }, {
      key: "upload",
      value: function upload() {
        //使用mobilecall方式
        if (this.config.cType == "mobilecall") {
          this.mobileCallUpload();
        } else {
          this.inputDom.value = null;
          this.triggerClick(this.inputDom); //$(this.inputDom).trigger("click");
        }
      }
      /**
       * 初始化参数判断
       */

    }, {
      key: "configSet",
      value: function configSet() {
        var _this3 = this; //cropper相关设置


        if (this.config.imgCropper) {
          var ready = {};

          if (this.config.cropperOptions.ready) {
            ready = {
              //ready注入一些操作
              ready: function ready() {
                _this3._hideLoading(); //禁止滑动


                document.querySelector(".cropper-container").addEventListener("touchmove", function (e) {
                  e.preventDefault();
                }, false); //禁止页面滑动

                _this3.config.cropperOptions.ready();
              }
            };
          } else {
            ready = {
              //ready注入一些操作
              ready: function ready() {
                _this3._hideLoading(); //禁止滑动


                document.querySelector(".cropper-container").addEventListener("touchmove", function (e) {
                  e.preventDefault();
                }, false); //禁止页面滑动
              }
            };
          }

          this.cropperOpt = Object.assign(this.cropperOpt, this.config.cropperOptions, ready);
          this.cropperOpt.aspectRatio = this.config.ratio;

          if (this.config.getCroppedCanvasData) {
            this.getCroppedCanvasDataSet = Object.assign(this.getCroppedCanvasDataSet, this.config.getCroppedCanvasData);
          } else {
            this.getCroppedCanvasDataSet = Object.assign(this.getCroppedCanvasDataSet, {
              width: this.config.cwidth,
              height: this.config.cheight,
              maxWidth: 4096,
              maxHeight: 4096
            });
          }
        }

        this.imgRatio = this.config.imgRatio;
      } //input事件

    }, {
      key: "onChange",
      value: function onChange(e) {
        var file = e.currentTarget.files;
        this.dealFiles(file, e);
      } //清除input，使可以重新上传

    }, {
      key: "clearInput",
      value: function clearInput() {
        if (this.inputDom) {
          this.inputDom.value = null;
          this.file = null;
        }
      }
    }, {
      key: "dealFiles",
      value: function dealFiles(file, e) {
        var _this4 = this;

        this.getUserInfo(function (userInfo) {
          var needLogin = _this4.checkNeedLogin(userInfo);

          if (!needLogin) {
            _this4._dealFiles(file);

            if (e) {
              //选择重复的触发onchange
              e.target.value = null;
            }
          } else {
            _this4.config.fail && _this4.config.fail("needLogin");
          }
        });
      } //处理文件

    }, {
      key: "_dealFiles",
      value: function _dealFiles(file, uInfo) {
        var _this5 = this;

        if (uInfo) {
          //外部自己处理input直接调用此方法的情况
          var needLogin = this.checkNeedLogin(userInfo);

          if (needLogin) {
            this.config.fail && this.config.fail("needLogin");
            return;
          }
        }

        this._openLoading();

        this.inputFileNum = file.length;

        if (this.inputFileNum < 1) {
          this.clearInput();

          this._hideLoading();

          this.config.fail && this.config.fail("无文件");
          return;
        }

        if (this.inputFileNum > this.config.limit) {
          //上传数量限制
          this.config.limitTip && this.toast(this.config.limitTip, this.config.toastTime);
          this.config.limitFun && this.config.limitFun();
          this.clearInput();

          this._hideLoading();

          return;
        }

        var arr = [];

        for (var i = 0; i < file.length; i++) {
          if (file[i].size > this.config.fileSizeLimit * 1024 * 1024) {
            this.config.fileSizeLimitTip && this.toast(this.config.fileSizeLimitTip, this.config.toastTime);
            this.clearInput();

            this._hideLoading();

            return;
          }

          arr.push(this.fileRead(file[i]));
        }

        Promise.all(arr).then(function (res) {
          var result = [];

          for (var _i = 0; _i < res.length; _i++) {
            result.push(res[_i]);
          }

          _this5._hideLoading();

          _this5.config.log && console.log("结果：", result);
          _this5.config.result && _this5.config.result(result);
        })["catch"](function (err) {
          _this5._hideLoading();

          _this5.config.log && console.log("处理失败");
          var toastErr = ['图片尺寸太小', '图片尺寸太大'];

          if (~toastErr.indexOf(err)) {
            //已经toast了
            _this5.config.fail && _this5.config.fail(err);
          }
        });
      } //读取文件

    }, {
      key: "fileRead",
      value: function fileRead(file) {
        var _this6 = this;

        this.config.log && console.log("读取的文件", file);
        var fileType = this.getFileType(file.name);
        this.compressForm = fileType == "jpeg" || fileType == "jpg" ? "image/jpeg" : "image/png"; //ios9拍照的会被压扁，保留原流程，拍照格式为jpg；

        ios9Deal = ios9 && fileType == "jpg";
        return new Promise(function (resolve, reject) {
          fileType = fileType.toLowerCase();

          if (fileType != 'jpeg' && fileType != 'png' && fileType != 'jpg') {
            //this.toast('请上传正确的图片文件');
            reject('文件格式错误');
            return;
          }

          _this6.file = file;

          if (_this6.inputFileNum == 1 && _this6.config.imgCropper && !ios9Deal) {
            _this6.cropImg(file, function (data) {
              resolve(data);
            }, reject);

            return;
          }

          var reader = new FileReader(); // 读取文件

          var tempTimer = setTimeout(function () {
            reader.onload = function (e) {
              var result = e.target.result;
              var fileSize = file.size / (1024 * 1024);

              if (fileSize <= _this6.config.size) {
                var img = new Image();
                img.src = result;

                img.onload = function () {
                  //读取图片尺寸
                  if (img.width < _this6.config.minWidth || img.height < _this6.config.minHeight) {
                    _this6.toast(_this6.config.minSizeTip, _this6.config.toastTime);

                    _this6._hideLoading();

                    reject('图片尺寸太小');
                    return;
                  }

                  if (img.width >= _this6.config.limitWidth || img.height >= _this6.config.limitHeight) {
                    _this6.toast(_this6.config.limitSizeTip, _this6.config.toastTime);

                    _this6._hideLoading();

                    reject('图片尺寸太大');
                    return;
                  } //需要改变图片比例时
                  //自定义bss上传时需要转成base64


                  if (_this6.config.imgRatio != 1 || _this6.inputFileNum == 1 && _this6.config.imgCropper || _this6.config.bucket != '') {
                    //超出输入尺寸比例也进行压缩，改变尺寸
                    _this6.zip(result, file, function (data) {
                      resolve(data);
                    });
                  } else {
                    _this6.uploadImg(result, function (data) {
                      resolve(data);
                    });
                  }
                };

                img.onerror = function () {
                  reject("文件读取错误");
                  return;
                };
              } else {
                //大小超出限制进行压缩
                _this6.zip(result, file, function (data) {
                  resolve(data);
                });
              }
            };

            reader.readAsDataURL(file);
            tempTimer = null;
          }, 500);
        });
      } //修改图片尺寸、文件压缩

    }, {
      key: "zip",
      value: function zip(base64, file, callback) {
        var _this7 = this;

        var _this = this;

        var img = new Image(); //img.setAttribute("crossorigin", "anonymous"); 不能加，iOS9不能触发onload

        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        canvas.style.position = "absolute";
        canvas.style.left = "-100000%";
        canvas.style.top = "-100000%";

        if (this.inputFileNum == 1 && this.config.imgCropper && ios9Deal) {
          //需要添加，不然cropperjs报错，在哪个容器添加裁剪
          if (this.config.cropperContainer) {
            if (this.config.cropperContainer.nodeType) {
              //dom元素
              this.cropperContainer = this.config.cropperContainer;
            } else {
              this.cropperContainer = document.querySelector(this.config.cropperContainer) ? document.querySelector(this.config.cropperContainer) : document.body;
            }
          } else {
            this.cropperContainer = document.body;
          }

          this.cropperContainer.appendChild(canvas);
        } //获取文件信息


        this.getEXIF(file, function (orientation) {
          _this7.config.log && console.log("orientation:", orientation);
          img.src = base64;

          img.onerror = function () {
            _this.config.fail && _this.config.fail("文件读取错误");
          };

          img.onload = function () {
            var width = img.width,
                height = img.height;
            _this7.config.log && console.log("初始宽高：", width, height);
            var ra = _this7.imgRatio; //大图，避免iOS黑屏；画布太大会导致绘制失败，数据为空

            if (width >= 5000 || height >= 5000 || width * ra >= 5000 || height * ra >= 5000) {
              ra = ra < 1 / 2 ? ra : 1 / 2;
            } //图片旋转到 正向


            if (orientation && orientation == 3) {
              canvas.width = width * ra;
              canvas.height = height * ra;
              ctx.rotate(Math.PI);
              ctx.drawImage(img, -width * ra, -height * ra, width * ra, height * ra);
            } else if (orientation && orientation == 6 && !ios134) {
              //iOS13.4以下照相上传会旋转90°
              canvas.width = height * ra;
              canvas.height = width * ra;
              ctx.rotate(Math.PI / 2);
              ctx.drawImage(img, 0, -height * ra, width * ra, height * ra);
            } else if (orientation && orientation == 8) {
              canvas.width = height * ra;
              canvas.height = width * ra;
              ctx.rotate(-Math.PI / 2);
              ctx.drawImage(img, -width * ra, 0, width * ra, height * ra);
            } else {
              //不旋转原图
              canvas.width = width * ra;
              canvas.height = height * ra;
              ctx.drawImage(img, 0, 0, width * ra, height * ra);
            }

            var n = 1;
            _this7.config.log && console.log("原始大小，", _this7.showSize(base64), "MB"); //未超过大小，无需压缩

            if (_this7.showSize(base64) <= _this7.config.size) {
              //单张图片上传才支持裁切，ios9拍照
              if (_this7.inputFileNum == 1 && _this7.config.imgCropper && ios9Deal) {
                _this7.cropperjs(canvas, callback);
              } else {
                if (_this7.config.imgRatio != 1) {
                  _this7.uploadImg(canvas.toDataURL(_this7.compressForm, 1), callback);
                } else {
                  _this7.uploadImg(base64, callback);
                }
              }
            } else {
              var fileType = file ? _this7.getFileType(file.name) : '';
              _this7.config.log && console.log('fileType', fileType); //png采用库的方式压缩

              if (fileType == 'png' && _this7.config.compressorjs) {
                new Compressor(file, {
                  quality: _this.config.quality,
                  success: function success(result) {
                    if (_this.config.bucket != '') {
                      var reader = new FileReader(); // 读取文件

                      reader.onload = function (e) {
                        var result = e.target.result;

                        _this.uploadImg(result, callback);
                      };

                      reader.readAsDataURL(file);
                    } else {
                      _this.uploadImg(result, callback);
                    }
                  },
                  error: function error(err) {
                    _this._hideLoading();

                    console.log(err.message, '压缩失败');
                    _this.config.fail && _this.config.fail(err);
                  }
                });
                return;
              }

              var compressionRatio = 1; //第一次粗压缩

              var finalBase64 = canvas.toDataURL(_this7.compressForm, compressionRatio); //0.1-表示将原图10M变成1M 10-表示将原图1M变成10M
              //100保证图片容量 0.05保证不失真

              _this7.config.log && console.log("第一次粗压缩", _this7.showSize(finalBase64), "MB，压缩率", compressionRatio); //第二次细压缩

              while (_this7.showSize(finalBase64) > _this7.config.size && compressionRatio > 0.01) {
                compressionRatio -= _this7.config.compressionRatio;
                finalBase64 = canvas.toDataURL(_this7.compressForm, compressionRatio); //0.1-表示将原图10M变成1M 10-表示将原图1M变成10M

                _this7.config.log && console.log("第" + n++ + "次细压缩", _this7.showSize(finalBase64), "MB，压缩率", compressionRatio);
              }

              _this7.config.log && console.log("压缩后大小：", _this7.showSize(finalBase64), "MB");
              var image = new Image();
              image.src = finalBase64;

              image.onload = function () {
                _this7.config.log && console.log("压缩结果宽高：", image.width, image.height);
              }; //单张图片上传才支持裁切，ios9拍照


              if (_this7.inputFileNum == 1 && _this7.config.imgCropper && ios9Deal) {
                _this7.cropperjs(canvas, callback);
              } else {
                _this7.uploadImg(finalBase64, callback);
              }
            }
          };
        });
      } //修改流程，先裁剪再对裁剪结果进行压缩

    }, {
      key: "cropImg",
      value: function cropImg(file, callback, failCb) {
        var _this8 = this;

        var URL = window.URL || window.webkitURL;

        if (uploadedImageURL) {
          URL.revokeObjectURL(uploadedImageURL);
        }

        var img = new Image();
        img.setAttribute("crossorigin", "anonymous");
        img.style.opacity = 0;
        img.style.position = "absolute";
        img.style.left = "-100000px";
        img.style.top = "-100000px";
        img.classList.add('crop-temp-img'); //需要添加，不然cropperjs报错，在哪个容器添加裁剪

        if (this.config.cropperContainer) {
          if (this.config.cropperContainer.nodeType) {
            //dom元素
            this.cropperContainer = this.config.cropperContainer;
          } else {
            this.cropperContainer = document.querySelector(this.config.cropperContainer) ? document.querySelector(this.config.cropperContainer) : document.body;
          }
        } else {
          this.cropperContainer = document.body;
        }

        this.cropperContainer.appendChild(img);
        img.src = uploadedImageURL = URL.createObjectURL(file);

        img.onload = function () {
          //读取图片尺寸
          if (img.width < _this8.config.minWidth || img.height < _this8.config.minHeight) {
            _this8.toast(_this8.config.minSizeTip, _this8.config.toastTime);

            _this8._hideLoading();

            failCb('图片尺寸太小');
            return;
          }

          if (img.width >= _this8.config.limitWidth || img.height >= _this8.config.limitHeight) {
            _this8.toast(_this8.config.limitSizeTip, _this8.config.toastTime);

            _this8._hideLoading();

            failCb('图片尺寸太大');
            return;
          }

          _this8.cropper && _this8.cropper.destroy();
          _this8.cropper = new Cropper(img, _this8.cropperOpt);
          _this8.cropperCallback = callback;

          _this8.btnSet();
        };

        img.onerror = function () {
          failCb("文件读取错误");
          return;
        };
      } //裁切

    }, {
      key: "cropperjs",
      value: function cropperjs(canvas, callback) {
        this.cropper && this.cropper.destroy();
        this.cropper = new Cropper(canvas, this.cropperOpt);
        this.cropperCallback = callback;
        this.btnSet();
      }
    }, {
      key: "btnSet",
      value: function btnSet() {
        var _this9 = this;

        if (!this.config.hideBtn) {
          this.btnBox = document.createElement("div");
          this.btnBox.className = "uploadImage-cropperBtn-box";
          this.btnBox.innerHTML = '<div class="cropperBtn" id="js-rotateCrop">旋转</div><div class="cropperBtn" id="js-confirmCrop">确认</div>';
          this.cropperContainer.appendChild(this.btnBox);
          document.querySelector("#js-rotateCrop").addEventListener("click", function () {
            _this9.rotateCropper();
          });
          document.querySelector("#js-confirmCrop").addEventListener("click", function () {
            _this9.confirmCropFn();

            _this9.cropperContainer.removeChild(_this9.btnBox);
          });
        }
      } //销毁裁剪

    }, {
      key: "destroy",
      value: function destroy() {
        this.cropper.destroy();

        if (this.btnBox) {
          this.cropperContainer.removeChild(this.btnBox);
          this.btnBox = null;
        }
      } //暴露旋转按钮

    }, {
      key: "rotateCropper",
      value: function rotateCropper() {
        this.cropper.rotate(-90);
      } //暴露确定裁剪按钮

    }, {
      key: "confirmCropFn",
      value: function confirmCropFn() {
        var cropperData = this.cropper.getCroppedCanvas(this.getCroppedCanvasDataSet).toDataURL(this.config.form);
        this.config.confirmCrop && this.config.confirmCrop(cropperData);
        this.afterCrop(cropperData);
        var tempImg = document.querySelector(".crop-temp-img");

        if (tempImg) {
          this.cropperContainer.removeChild(tempImg);
        }

        this.cropper.destroy();
      }
    }, {
      key: "afterCrop",
      value: function afterCrop(cropperData) {
        var _this10 = this; //仅裁剪


        if (this.config.onlyCrop) {
          this.cropperCallback({
            base64: cropperData
          });
          return;
        } //ios9Deal: 先压缩后裁剪


        if (ios9Deal) {
          if (this.config.handleCropImg) {
            this.config.handleCropImg(cropperData, function (base64) {
              _this10.uploadImg(base64, _this10.cropperCallback);
            });
          } else {
            this.uploadImg(cropperData, this.cropperCallback);
          }

          return;
        }

        this._openLoading(); //裁剪后压缩


        if (this.showSize(cropperData) <= this.config.size) {
          if (this.config.handleCropImg) {
            this.config.handleCropImg(cropperData, function (base64) {
              _this10.uploadImg(base64, _this10.cropperCallback);
            });
          } else {
            this.uploadImg(cropperData, this.cropperCallback);
          }
        } else {
          if (this.config.handleCropImg) {
            this.config.handleCropImg(cropperData, function (base64) {
              _this10.zip(base64, null, _this10.cropperCallback);
            });
          } else {
            this.zip(cropperData, null, this.cropperCallback);
          }
        }
      } //获取EXIF信息

    }, {
      key: "getEXIF",
      value: function getEXIF(file, cb) {
        if (!file) {
          return cb && cb(1);
        }

        exif.getData(file, function () {
          var Orientation = exif.getTag(this, "Orientation");

          if (Orientation && Orientation != 1) {
            cb && cb(Orientation);
          } else {
            //不需处理直接上传
            cb && cb(Orientation);
          }
        });
      } //上传上报
      //type:1:成功，2:失败，3：网络失败

    }, {
      key: "uploadLog",
      value: function uploadLog(type, fileType, res) {
        var img = new Image();
        var msg = {
          fileType: fileType,
          url: window.location.href,
          res: res
        };

        if (type == 1) {
          img.src = "https://statwww2.kugou.com/node/weblog/jsloger?key=uploadImage&status=success" + "&msg=" + JSON.stringify(msg) + "&time=" + new Date().getTime();
        } else if (type == 2) {
          img.src = "https://statwww2.kugou.com/node/weblog/jsloger?key=uploadImage&status=fail" + "&msg=" + JSON.stringify(msg) + "&time=" + new Date().getTime();
        } else {
          img.src = "https://statwww2.kugou.com/node/weblog/jsloger?key=uploadImage&status=500" + "&msg=" + JSON.stringify(msg) + "&time=" + new Date().getTime();
        }
      }
    }, {
      key: "getUserInfo",
      value: function getUserInfo(cb) {
        if (this.config.userInfo) {
          cb(this.config.userInfo);
        } else {
          main_min$1(main_min.isInClient() ? null : this.config.appid || 1058, function (info) {
            var params = {
              appid: info.appid,
              userid: info.userid || '0',
              token: info.token || '',
              clientver: info.clientver || '10000',
              mid: info.mid,
              uuid: info.uuid,
              dfid: info.dfid
            };
            var userInfo = Object.assign({}, params);
            cb(userInfo);
          });
        }
      }
    }, {
      key: "uploadImg",
      value: function uploadImg(base64, callback) {
        var _this11 = this;

        this.getUserInfo(function (userInfo) {
          _this11.bssUpload(base64, userInfo, callback);
        });
      }
    }, {
      key: "json2keyval",
      value: function json2keyval(params) {
        var thisParam = "";

        for (var Key in params) {
          if (thisParam) {
            thisParam = thisParam + "&" + Key + "=" + encodeURIComponent(params[Key]) + "";
          } else {
            thisParam = Key + "=" + params[Key] + "";
          }
        }

        return thisParam;
      }
    }, {
      key: "dataURLtoFile",
      value: function dataURLtoFile(dataurl) {
        var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'file';
        var arr = dataurl.split(',');
        var mime = arr[0].match(/:(.*?);/)[1];
        var suffix = mime.split('/')[1];
        var bstr = atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], "".concat(filename, ".").concat(suffix), {
          type: mime
        });
      } //默认内网桶loginType=0，其他都是1，支持组件初始化覆盖loginType，以防其他平台（如5sing）使用
      //bucket为内网桶的时候可以免登录上传，其他情况未登录上传都fail提示要登录

    }, {
      key: "checkNeedLogin",
      value: function checkNeedLogin(userInfo) {
        //配置的loginType优先
        if (this.config.loginType == 0) {
          return false;
        } //内网桶


        if (this.config.bucketType == 2) {
          this.config.loginType = 0;
          return false;
        }

        if (userInfo && userInfo.userid && parseInt(userInfo.userid) != 0) {
          return false;
        } else {
          return true;
        }
      } //bss上传

    }, {
      key: "bssUpload",
      value: function bssUpload(base64, userInfo, callback) {
        var _this12 = this;

        var needLogin = this.checkNeedLogin(userInfo);

        if (needLogin) {
          this._hideLoading();

          this.config.fail && this.config.fail("needLogin");
          return;
        }

        var fileType = base64.match(/^data:image\/(\S+);base64,/)[1];
        var data = Object.assign({
          bucket: this.config.bucket,
          filename: md5(base64) + ".".concat(fileType),
          loginType: this.config.loginType,
          buVerifyCode: md5(userInfo.appid + this.config.bucket + this.config.salt),
          extranet: 1,
          appid: userInfo.appid,
          userid: userInfo.userid || userInfo.kugouID,
          token: userInfo.token,
          clientver: userInfo.clientver,
          mid: userInfo.mid,
          dfid: userInfo.dfid || '-'
        }, this.config.bssAuthParams);
        this.config.log && console.log("授权请求参数", data); //http://kapi.kugou.net/project/10/interface/api/111314

        main_min$2(Object.assign({
          baseURL: "https://bsstrackercdngz.kugou.com",
          url: "/v1/upload/auth",
          method: "get",
          params: data
        }, this.config.authReqObj)).then(function (res1) {
          var result1 = res1.data;
          _this12.config.log && console.log("授权 res:", result1);

          if (+result1.status == 1) {
            var imgFile = _this12.dataURLtoFile(base64, md5(base64)); //二进制file文件类型


            var _data = Object.assign({
              bucket: _this12.config.bucket,
              extendname: fileType,
              use_ext: 1,
              filename: md5(base64) + ".".concat(fileType),
              type: '',
              authorization: result1.data.authorization,
              serverid: '',
              userid: userInfo.userid || userInfo.kugouID,
              appid: userInfo.appid,
              token: userInfo.token,
              mid: userInfo.mid,
              dfid: userInfo.dfid || '-',
              clientver: userInfo.clientver,
              body_empty: 1 // 值为1时，计算sianatrue， bodv当空字符串处理

            }, _this12.config.bssUploadParams);

            _this12.config.log && console.log("上传请求参数", _data); //http://kapi.kugou.net/project/10/interface/api/21

            main_min$2(Object.assign({
              baseURL: "https://bssul.service.kugou.com",
              url: "/v2/upload",
              method: "post",
              params: _data,
              data: imgFile,
              isGateway: false,
              isFormData: true,
              headers: [{
                "Content-Type": "application/x-www-form-urlencoded"
              }]
            }, _this12.config.uploadReqObj)).then(function (res2) {
              var result2 = res2.data;
              _this12.config.log && console.log("上传 res:", result2);

              if (+result2.status == 1 && result2.data) {
                if (_this12.config.bucketType === 1) {
                  //共有桶
                  result2.data.url = replaceHttpsImg('http://' + _this12.config.bucket + '.bssdl.kugou.com/' + result2.data['x-bss-filename']);
                  result2.url = replaceHttpsImg('http://' + _this12.config.bucket + '.bssdl.kugou.com/' + result2.data['x-bss-filename']);
                } else if (_this12.config.bucketType === 2) {
                  //内网桶
                  result2.data.url = 'https://bssdl.kugou.net/bss/' + _this12.config.bucket + '/' + result2.data['x-bss-filename'];
                  result2.url = 'https://bssdl.kugou.net/bss/' + _this12.config.bucket + '/' + result2.data['x-bss-filename'];
                }

                result2.base64 = base64; //私有桶原始返回
              }

              callback && callback(result2);

              if (+result2.status == 1) {
                _this12.uploadLog(1, "bss2", result2);
              } else {
                _this12.uploadLog(2, "bss2", result2);
              }
            })["catch"](function (err) {
              _this12.config.log && console.log("upload err:", err);

              _this12._hideLoading();

              _this12.config.fail && _this12.config.fail(err);

              _this12.uploadLog(3, "bss2");
            });
          } else {
            _this12._hideLoading();

            _this12.config.fail && _this12.config.fail(result1);

            _this12.uploadLog(2, "bss1", result1);
          }
        })["catch"](function (err) {
          _this12.config.log && console.log("authorization err:", err);

          _this12._hideLoading();

          _this12.config.fail && _this12.config.fail(err);

          _this12.uploadLog(3, "bss1");
        });
      } //读取图片，二次压缩

    }, {
      key: "imageRead",
      value: function imageRead(url, cb) {
        var _this13 = this;

        var img = new Image();
        img.setAttribute("crossorigin", "anonymous");
        img.src = url;
        img.style.position = "absolute";
        img.style.left = "-100000px";
        img.style.top = "-100000px";
        document.body.appendChild(img);

        img.onload = function () {
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0, img.width, img.height);

          var fileType = _this13.getFileType(url);

          _this13.compressForm = fileType == "jpeg" || fileType == "jpg" ? "image/jpeg" : "image/png";
          var base64 = canvas.toDataURL(_this13.compressForm);

          if (_this13.showSize(base64) <= _this13.config.size) {
            cb && cb(url);
          } else {
            _this13.zip(base64, null, function (data) {
              cb && cb(data);
            });
          }
        };
      } //使用mobilecall方式裁剪

    }, {
      key: "mobileCallUpload",
      value: function mobileCallUpload() {
        //http://doc.kugou.net/showdoc-master/web/#/5?page_id=513
        main_min.mobileCall(266, this.config.authMeet);
      }
    }, {
      key: "mobileCallUploadCb",
      value: function mobileCallUploadCb() {
        var _this14 = this;

        main_min.KgWebMobileCall("KgWebMobileCall.returnAuthMeet", function (res) {
          _this14.config.log && console.log("mobilecall回调：", res);
          res = typeof res === "string" ? JSON.parse(res) : res;

          if (~~res.status === 1) {
            var result = [];
            result.push(res); //对mobilecall获取的图片进行压缩

            if (_this14.config.mobileCallCompress) {
              _this14._openLoading();

              _this14.imgRatio = 1;

              _this14.imageRead(res.url, function (data) {
                _this14._hideLoading();

                if (~~data.status === 1) {
                  var result2 = [];
                  result2.push(data);
                  _this14.config.result && _this14.config.result(result2);
                } else {
                  _this14.config.result && _this14.config.result(result);
                }
              });
            } else {
              _this14.config.result && _this14.config.result(result);
            }
          } else {
            _this14.config.fail && _this14.config.fail();
          }
        });
      } //获取图片后缀

    }, {
      key: "getFileType",
      value: function getFileType(name) {
        return name.substring(name.lastIndexOf(".") + 1).toLowerCase();
      } //获取base64图片大小，返回MB数字

    }, {
      key: "showSize",
      value: function showSize(base64url) {
        var str = base64url.replace("data:image/png;base64,", "");
        var equalIndex = str.indexOf("=");

        if (str.indexOf("=") > 0) {
          str = str.substring(0, equalIndex);
        }

        var strLength = str.length;
        var fileLength = parseInt(strLength - strLength / 8 * 2); // 由字节转换为MB

        var size = "";
        size = (fileLength / (1024 * 1024)).toFixed(2);
        var sizeStr = size + ""; //转成字符串

        var index = sizeStr.indexOf("."); //获取小数点处的索引

        var dou = sizeStr.substr(index + 1, 2); //获取小数点后两位的值

        if (dou == "00") {
          //判断后两位是否为00，如果是则删除00
          return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
        }

        return size;
      }
      /**
       * toast提示
       * @param word 提示的信息
       * @param time 延时时间，毫秒
       */

    }, {
      key: "toast",
      value: function toast(word, time) {
        var toastCover = document.createElement("div"),
            toastCoverExist = document.getElementById("toastCover");

        if (toastCoverExist) {
          document.body.removeChild(toastCoverExist);
        }

        var base = "position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);-webkit-transform: translate(-50%, -50%);z-index: 99999;line-height: 22px;background-color: rgba(0, 0, 0, 0.8);border-radius: 5px;font-size: 13px;color: #fff;text-align: center;";
        toastCover.style.cssText = base + (word.length <= 10 ? "min-width: 70px;height:21px;padding: 12.5px 15px;" : "width: 200px;padding: 12.5px 25px;");
        toastCover.id = "toastCover";
        toastCover.innerText = word;
        document.body.appendChild(toastCover);

        if (window.toastTimeout) {
          clearTimeout(window["toastTimeout"]);
        }

        window.toastTimeout = setTimeout(function () {
          if (document.querySelector("#toastCover")) {
            toastCover.parentNode.removeChild(toastCover);
          }
        }, time || 2000);
      }
      /**
       * 显示loading组件
       * @param
       * @return
       */

    }, {
      key: "_openLoading",
      value: function _openLoading() {
        if (this.config.openLoading) {
          this.config.openLoading();
        } else {
          this.loadingEle = document.createElement("div");
          this.loadingEle.className = "uploadImage-loading";
          this.loadingEle.id = "uploadImage-loading";
          document.body.appendChild(this.loadingEle);
          kgLoad({
            icon: 'blue_v3',
            msg: "",
            ele: 'uploadImage-loading'
          });
        }
      }
    }, {
      key: "_hideLoading",
      value: function _hideLoading() {
        if (this.config.hideLoading) {
          this.config.hideLoading();
        } else {
          this.loadingEle && document.body.removeChild(this.loadingEle);
          this.loadingEle = null;
        }
      }
    }]);

    return uploadImage;
  }();

  return uploadImage;
});